webpackJsonp([76],{

/***/ 1224:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(550);
module.exports = __webpack_require__(549);


/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Helper__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_bdToast_index__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__storage_localStorage__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__storage_sessionStorage__ = __webpack_require__(241);










var protocol = "http://";
var host = '.bidinghuo.cn';
var AxiosIns = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
	baseURL: location.origin + '/wapi/',
	timeout: 20000,
	contentType: 'application/json',
	withCredentials: true
});

var timer = {};
var delay = 30;
AxiosIns.interceptors.request.use(function (config) {
	var sessionUserInfo = __WEBPACK_IMPORTED_MODULE_9__storage_sessionStorage__["a" /* default */].$getSessionStorageByName('userInfo');
	var localUserInfo = __WEBPACK_IMPORTED_MODULE_8__storage_localStorage__["a" /* default */].$getLocalStorageByName('userInfo');
	if (!!sessionUserInfo && !!localUserInfo && sessionUserInfo.id !== localUserInfo.id) {
		sessionStorage.clear();
		if (!!!location.host.startsWith('sy.')) {
			__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
				name: 'login'
			});
		}
	}

	if (false) {
		host = process.env.PLATFORM === 'app' ? host : '.bdh.com';
		if (config.domain === 'www') {
			config.baseURL = protocol + config.domain + host + '/api/';
		} else {
			var domain = localStorage.getItem('companyDomain');
			config.baseURL = protocol + domain + host + '/wapi/';
		}
	}
	if (false) {
		config.baseURL = location.origin + '/api/';
	}
	if (config.showFullLoading !== 'close') {
		if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(timer).length < 1) {
			__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a.Indicator.open('加载中...');
		}
		timer[config.baseURL + config.url] = setTimeout(function () {}, delay);
	}
	return config;
});

AxiosIns.interceptors.response.use(function (response) {
	setTimeout(function () {
		for (var key in timer) {
			clearTimeout(timer[key]);
			if (key === response.config.url) {
				delete timer[key];
			}
		}
		if (__WEBPACK_IMPORTED_MODULE_6__Helper__["a" /* default */].isEmptyObj(timer)) {
			__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a.Indicator.close();
		}
	}, delay);

	if (response.config && response.config.responseType === 'blob') {
		return response;
	}
	try {
		if (response.data.code !== 0) {
			var notMessage = response.config.notMessage;

			if (!notMessage) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_common_bdToast_index__["a" /* default */])(response.data.message);
			}
			if (response.data.code === 200000) {
				sessionStorage.removeItem("userInfo");
				localStorage.removeItem("userInfo");
				setTimeout(function () {
					__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
						name: 'login'
					});
				}, 800);
			}
			if (response.config && response.config.showFullResult) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data);
			}
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.message);
		}
	} catch (e) {}
	return response.data;
}, function (error) {
	setTimeout(function () {
		for (var key in timer) {
			clearTimeout(timer[key]);
			if (key === error.config.url) {
				delete timer[key];
			}
		}
		if (__WEBPACK_IMPORTED_MODULE_6__Helper__["a" /* default */].isEmptyObj(timer)) {}
	}, delay);
	try {
		var msg = typeof error.data === "string" ? error.data : error.data.Message;
		if (!msg || msg.length > 20) {
			msg = '网络出现异常，请稍后再试';
		}
		__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a.Toast(msg);
		__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a.Indicator.close();
	} catch (e) {
		__WEBPACK_IMPORTED_MODULE_3_mint_ui___default.a.Indicator.close();
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
	AxiosIns: AxiosIns,
	axios: __WEBPACK_IMPORTED_MODULE_4_axios___default.a
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.axios = AxiosIns;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);



var session = {};

session.install = function (Vue) {
	Vue.prototype.$getSessionStorageByName = session.$getSessionStorageByName;
	Vue.prototype.$setSessionStorageByName = session.$setSessionStorageByName;
	Vue.prototype.$removeSessionStorageByName = session.$removeSessionStorageByName;
};

session.$getSessionStorageByName = function (name) {
	if (!sessionStorage || !sessionStorage.getItem) {
		throw Error('浏览器不支持sessionStorage');
		return;
	}
	var s = name ? sessionStorage.getItem(name) : sessionStorage;
	try {
		return JSON.parse(s);
	} catch (e) {
		return s;
	}
};

session.$setSessionStorageByName = function (name, value) {
	if (!sessionStorage || !sessionStorage.setItem) {
		throw Error('浏览器不支持sessionStorage');
		return;
	}
	sessionStorage.setItem(name, (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) : value);
};
session.$removeSessionStorageByName = function (name) {
	if (!sessionStorage || !sessionStorage.setItem) {
		throw Error('浏览器不支持sessionStorage');
		return;
	}
	sessionStorage.removeItem(name);
};
/* harmony default export */ __webpack_exports__["a"] = (session);

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_mainSearch__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_orderingDialog__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_listSearch__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_toggleMenu__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_singalDialog__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__module_analyzeDialog__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__module_deduceDialog__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__module_pactTotal__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__module_userReturnBack__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__module_infer__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__module_submitOrder__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__module_meetingDetail__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__module_global__ = __webpack_require__(629);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		mainSearch: __WEBPACK_IMPORTED_MODULE_2__module_mainSearch__["a" /* default */], orderingDialog: __WEBPACK_IMPORTED_MODULE_3__module_orderingDialog__["a" /* default */], listSearch: __WEBPACK_IMPORTED_MODULE_4__module_listSearch__["a" /* default */],
		toggleMenu: __WEBPACK_IMPORTED_MODULE_5__module_toggleMenu__["a" /* default */], singalDialog: __WEBPACK_IMPORTED_MODULE_6__module_singalDialog__["a" /* default */], analyzeDialog: __WEBPACK_IMPORTED_MODULE_7__module_analyzeDialog__["a" /* default */], deduceDialog: __WEBPACK_IMPORTED_MODULE_8__module_deduceDialog__["a" /* default */], pactTotal: __WEBPACK_IMPORTED_MODULE_9__module_pactTotal__["a" /* default */], userReturnBack: __WEBPACK_IMPORTED_MODULE_10__module_userReturnBack__["a" /* default */], infer: __WEBPACK_IMPORTED_MODULE_11__module_infer__["a" /* default */], submitOrder: __WEBPACK_IMPORTED_MODULE_12__module_submitOrder__["a" /* default */], meetingDetail: __WEBPACK_IMPORTED_MODULE_13__module_meetingDetail__["a" /* default */], global: __WEBPACK_IMPORTED_MODULE_14__module_global__["a" /* default */]
	}
}));

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__axiosSetting__ = __webpack_require__(154);













var Helper = function () {
	function Helper() {
		__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default()(this, Helper);
	}

	__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default()(Helper, [{
		key: 'throttle',
		value: function throttle(fn, wait) {
			var time = Date.now();
			return function () {
				if (time + wait - Date.now() < 0) {
					fn();
					time = Date.now();
				}
			};
		}
	}, {
		key: 'clone',
		value: function clone(obj) {
			var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
				return obj;
			}
			if (deep) {
				if (Array.isArray(obj)) {
					var cloneObj = [];
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(obj.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _ref = _step.value;

							var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

							var o = _ref2[1];

							cloneObj.push(this.clone(o, true));
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					return cloneObj;
				} else {
					var _cloneObj = {};
					for (var k in obj) {
						if (Array.isArray(obj[k])) {
							var a = [];
							for (var i = 0; i < obj[k].length; i++) {
								a.push(this.clone(obj[k][i], true));
							}
							_cloneObj[k] = a;
						} else if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj[k]) !== 'object') {
							_cloneObj[k] = obj[k];
						} else {
							_cloneObj[k] = this.clone(obj[k], true);
						}
					}
					return _cloneObj;
				}
			} else {
				if (Array.isArray(obj)) {
					return [].concat(obj);
				} else {
					return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, obj);
				}
			}
		}
	}, {
		key: 'entries',
		value: function entries(obj) {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(obj);
		}
	}, {
		key: 'values',
		value: function values(obj) {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(obj);
		}
	}, {
		key: 'isEmptyObj',
		value: function isEmptyObj(obj) {
			for (var key in obj) {
				if (obj[key]) {
					return false;
				}
			}
			return true;
		}
	}, {
		key: 'getDefaultStyle',
		value: function getDefaultStyle(obj, attribute) {
			return obj.currentStyle ? obj.currentStyle[attribute] : document.defaultView.getComputedStyle(obj, false)[attribute];
		}
	}, {
		key: 'getOffset',
		value: function getOffset(node) {
			function getParentOffset(node) {
				var left = node.offsetLeft || 0;
				var top = node.offsetTop || 0;
				if (node.offsetParent) {
					var offset = getParentOffset(node.offsetParent);
					left += offset.left;
					top += offset.top;
				}
				return {
					left: left, top: top
				};
			}
			return getParentOffset(node);
		}
	}, {
		key: 'extendData',
		value: function extendData(target) {
			var clone = function clone(out, obj) {
				out = out || {};
				if (!obj) {} else {
					for (var key in obj) {
						if (obj.hasOwnProperty(key)) {
							if (Array.isArray(obj[key])) {
								out[key] = (out[key] || []).concat([obj[key]]);
							} else if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj[key]) === 'object') {
								out[key] = clone(out[key], obj[key]);
							} else {
								out[key] = obj[key];
							}
						}
					}
				}
				return out;
			};

			for (var _len = arguments.length, cloneObj = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				cloneObj[_key - 1] = arguments[_key];
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(cloneObj.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

					var o = _ref4[1];

					target = clone(target, o);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return target;
		}
	}, {
		key: 'getFormData',
		value: function getFormData() {
			var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var data = {};
			for (var key in form) {
				if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(form[key]) === 'object' && 'rules' in form[key] && 'domValue' in form[key]) {
					data[key] = form[key]['domValue'];
				} else {
					data[key] = form[key];
				}
			}
			return this.removeEmptyPro(data);
		}
	}, {
		key: 'removeEmptyPro',
		value: function removeEmptyPro(form) {
			for (var v in form) {
				if (form[v] === '') {
					delete form[v];
				}
			}
			return form;
		}
	}, {
		key: 'initForm',
		value: function initForm() {
			var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var init = function init(obj) {
				if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
					return '';
				}
				if (Array.isArray(obj)) {
					return [];
				}
				for (var key in obj) {
					if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj[key]) === 'object') {
						if ('domValue' in obj[key]) {
							obj[key].domValue = '';
						} else {
							obj[key] = init(obj[key]);
						}
					} else {
						obj[key] = '';
					}
				}
				return obj;
			};
			return init(form);
		}
	}, {
		key: 'getDate',
		value: function getDate() {
			var timeStamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();
			var splitSymble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
			var disDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

			if (typeof timeStamp === 'string') {
				timeStamp = timeStamp.replace(/-/g, '/');
			}
			var date = new Date(new Date(timeStamp).getTime() - disDay * 24 * 60 * 60 * 1000);
			var beauty = function beauty(num) {
				return num > 9 ? num : '0' + num;
			};
			return date.getFullYear() + splitSymble + beauty(date.getMonth() + 1) + splitSymble + beauty(date.getDate());
		}
	}, {
		key: 'getTimeDetail',
		value: function getTimeDetail() {
			var timeStamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();
			var splitSymble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

			if (typeof timeStamp === 'string') {
				timeStamp = timeStamp.replace(/-/g, '/');
			}
			var date = new Date(timeStamp);
			var beauty = function beauty(num) {
				return num > 9 ? num : '0' + num;
			};
			return beauty(date.getHours()) + splitSymble + beauty(date.getMinutes()) + splitSymble + beauty(date.getSeconds());
		}
	}, {
		key: 'setContainerFullHeight',
		value: function setContainerFullHeight() {
			var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelectorAll('.container')[1];

			var _height = document.body.clientHeight - document.querySelectorAll('.container')[0].clientHeight;
			$container.style.minHeight = _height + 'px';
		}
	}, {
		key: 'ossParam',
		value: function ossParam() {
			var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { width: 320, height: 320, m: '', limit: 1, hasWatermark: false },
			    _ref5$width = _ref5.width,
			    width = _ref5$width === undefined ? '' : _ref5$width,
			    _ref5$height = _ref5.height,
			    height = _ref5$height === undefined ? '' : _ref5$height,
			    _ref5$m = _ref5.m,
			    m = _ref5$m === undefined ? '' : _ref5$m,
			    _ref5$limit = _ref5.limit,
			    limit = _ref5$limit === undefined ? 1 : _ref5$limit,
			    _ref5$hasWatermark = _ref5.hasWatermark,
			    hasWatermark = _ref5$hasWatermark === undefined ? false : _ref5$hasWatermark;

			var extraParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			var p = hasWatermark ? '/resize' : '?x-oss-process=image/resize';
			if (m) {
				p += ',m_' + m;
			}
			if (height) {
				p += ',h_' + height;
			}
			if (width) {
				p += ',w_' + width;
			}
			if (limit === 0 || limit === 1) {
				p += ',limit_' + limit;
			}
			p += extraParam;
			return p;
		}
	}, {
		key: 'printArea',
		value: function printArea(id) {
			if (!id) {
				return;
			}
			var el = document.getElementById(id);
			var iframe = document.createElement('iframe');
			var doc = null;
			iframe.setAttribute('style', 'position:absolute;width:0;height:0,left:-9999px');
			document.body.appendChild(iframe);
			doc = iframe.contentWindow.document;
			doc.write('<div>' + el.innerHTML + '</div>');
			doc.close();
			iframe.contentWindow.focus();
			iframe.contentWindow.print();
		}
	}, {
		key: 'test',
		value: function test() {
			return 'xxx';
		}
	}, {
		key: 'dateFormat',
		value: function dateFormat(timeStamp, fmt) {
			var timeObj = new Date(parseInt(timeStamp) * 1000);
			var o = {
				"M+": timeObj.getMonth() + 1,
				"d+": timeObj.getDate(),
				"h+": timeObj.getHours(),
				"m+": timeObj.getMinutes(),
				"s+": timeObj.getSeconds(),
				"q+": Math.floor((timeObj.getMonth() + 3) / 3),
				"S": timeObj.getMilliseconds() };
			if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (timeObj.getFullYear() + "").substr(4 - RegExp.$1.length));
			for (var k in o) {
				if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
			}return fmt;
		}
	}, {
		key: 'upload',
		value: function upload(base64Data) {
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (!!base64Data) {
					var formData = new FormData();
					formData.append('file', base64Data);
					__WEBPACK_IMPORTED_MODULE_11__axiosSetting__["a" /* default */].AxiosIns({
						method: 'post',
						url: 'upload/image.json',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						data: formData
					}).then(function (res) {
						resolve(res);
					}).catch(function (e) {
						reject(e);
					});
				}
			});
		}
	}, {
		key: 'formatMoney',
		value: function formatMoney(money) {
			var isShowEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (money === '' && isShowEmpty) {
				return money;
			}
			if (String(money).indexOf('*') >= 0) {
				return money;
			}
			var m = parseFloat(money);
			var length = String(m).split('.')[1] ? String(m).split('.')[1].length : 0;
			var format = '0,0';
			switch (length) {
				case 1:
					format = '0,0.0';
					break;
				case 2:
				case 3:
					format = '0,0.00';
					break;
				default:
					format = '0,0';
					break;
			}
			return __WEBPACK_IMPORTED_MODULE_10_numeral___default()(m).format(format);
		}
	}]);

	return Helper;
}();

Helper.prototype.numeral = __WEBPACK_IMPORTED_MODULE_10_numeral___default.a;
var helper = new Helper();
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].prototype.Helper = helper;
/* harmony default export */ __webpack_exports__["a"] = (helper);

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage_sessionStorage__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__storage_vuex__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__introduct__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ordering__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__order__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__exhibit__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__star__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pact__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__submitOrder__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__orderNew__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__orderNewPurchase__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orderNewAgent__ = __webpack_require__(620);



var _this = this;






var test = function test(resolve) {
	return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var missing = function missing(resolve) {
	return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1232)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var main = function main(resolve) {
	return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1238)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var login = function login(resolve) {
	return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1237)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var platFormLogin = function platFormLogin(resolve) {
	return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};













__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
var toIndex = function toIndex(to, from, next) {
	if (to.query.isInit) {
		__WEBPACK_IMPORTED_MODULE_4__storage_sessionStorage__["a" /* default */].$setSessionStorageByName('userInfo', {});
	}
	var userInfo = __WEBPACK_IMPORTED_MODULE_4__storage_sessionStorage__["a" /* default */].$getSessionStorageByName('userInfo') || {};
	if (userInfo.id && !to.query.role) {
		next(__WEBPACK_IMPORTED_MODULE_8__ordering__["a" /* default */][0]);
	} else {
		next();
	}
};
var instance = null;
var r = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
	routes: [{
		path: '*',
		name: 'missing',
		component: missing
	}, {
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			title: '订货端登录'
		},
		beforeEnter: function beforeEnter(to, from, next) {
			toIndex(to, from, next);
		}
	}, {
		path: '/platform/login',
		name: 'platFormLogin',
		component: platFormLogin,
		meta: {
			title: '订货端登录'
		}
	}, {
		path: '/',
		redirect: __WEBPACK_IMPORTED_MODULE_8__ordering__["a" /* default */][0]
	}, {
		path: '/test',
		name: 'test',
		component: test
	}, {
		path: '/main',
		component: main,
		beforeEnter: function beforeEnter(to, from, next) {
			if (to.path === '/main') {
				next(__WEBPACK_IMPORTED_MODULE_8__ordering__["a" /* default */][0]);
			} else {
				next();
			}
		},

		children: [].concat(__WEBPACK_IMPORTED_MODULE_7__introduct__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__ordering__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__order__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__exhibit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__star__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__pact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__submitOrder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__orderNew__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__orderNewPurchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__orderNewAgent__["a" /* default */])
	}].reverse(),
	mode:  false ? 'hash' : 'history',
	scrollBehavior: function scrollBehavior() {
		return { x: 10, y: 0 };
	}
});

r.beforeEach(function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
		var userInfo, notLoginName, mainSearchHandle;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						document.body.scrollTop = 0;userInfo = __WEBPACK_IMPORTED_MODULE_4__storage_sessionStorage__["a" /* default */].$getSessionStorageByName('userInfo') || {};

						document.title = (typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title) || '无标题';
						notLoginName = { 'login': 1, 'platFormLogin': 1 };

						if (!(__WEBPACK_IMPORTED_MODULE_5__storage_vuex__["a" /* default */].state.infer.coercePush && ['orderingInfer', 'login'].indexOf(to.name) < 0)) {
							_context.next = 8;
							break;
						}

						if (['orderingInfer'].indexOf(to.name) < 0 && from.name !== 'orderingInfer') {
							next({
								name: 'orderingInfer'
							});
						}
						if (from.name === 'orderingInfer') {
							instance && instance.close();
							instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mint_ui__["Toast"])('强制推送中，不能进行该操作');
						}
						return _context.abrupt('return');

					case 8:
						if (!userInfo.id && !(to.name in notLoginName)) {
							next({
								name: 'login'
							});
						} else {
							mainSearchHandle = to.meta.mainSearchHandle || function () {};

							__WEBPACK_IMPORTED_MODULE_5__storage_vuex__["a" /* default */].commit("changeMainSearchHandle", mainSearchHandle);
							__WEBPACK_IMPORTED_MODULE_5__storage_vuex__["a" /* default */].commit("changeSearchDisabled", to.meta.searchDisabled);
							__WEBPACK_IMPORTED_MODULE_5__storage_vuex__["a" /* default */].commit("changeSearchKeyword", '');
							next();
						}

					case 9:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this);
	}));

	return function (_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	};
}());

/* harmony default export */ __webpack_exports__["a"] = (r);

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);



var local = {};

local.install = function (Vue) {
	Vue.prototype.$getLocalStorageByName = local.$getLocalStorageByName;
	Vue.prototype.$setLocalStorageByName = local.$setLocalStorageByName;
	Vue.prototype.$removeLocalStorageByName = local.$removeLocalStorageByName;
};

local.$getLocalStorageByName = function (name) {
	if (!localStorage || !localStorage.getItem) {
		throw Error('浏览器不支持localStorage');
		return;
	}
	var s = name ? localStorage.getItem(name) : localStorage;
	try {
		return JSON.parse(s);
	} catch (e) {
		return s;
	}
};

local.$setLocalStorageByName = function (name, value) {
	if (!localStorage || !localStorage.setItem) {
		throw Error('浏览器不支持localStorage');
		return;
	}
	localStorage.setItem(name, (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) : value);
};

local.$removeLocalStorageByName = function (name) {
	if (!localStorage || !localStorage.setItem) {
		throw Error('浏览器不支持localStorage');
		return;
	}
	localStorage.removeItem(name);
};

/* harmony default export */ __webpack_exports__["a"] = (local);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_promise_polyfill__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_photoswipe_dist_photoswipe_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_photoswipe_dist_photoswipe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_photoswipe_dist_photoswipe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_photoswipe_dist_photoswipe_ui_default_min_js__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_photoswipe_dist_photoswipe_ui_default_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_photoswipe_dist_photoswipe_ui_default_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vxe_table_lib_style_css__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vxe_table_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vxe_table_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_photoswipe_dist_photoswipe_css__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_photoswipe_dist_photoswipe_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_photoswipe_dist_photoswipe_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_photoswipe_dist_default_skin_default_skin_css__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_photoswipe_dist_default_skin_default_skin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_photoswipe_dist_default_skin_default_skin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__storage_vuex__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_font_awesome_css_font_awesome_min_css__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_common_css__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directive_disabledPassword__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__directive_watermark__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_axiosSetting__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_Helper__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_systemSetting__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_alert__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_kxSelect__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_kxSelectPopper__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_bdDialog__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__storage_localStorage__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__storage_sessionStorage__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_favicon_ico__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_images_favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_load_gif__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_load_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_images_load_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_default_goods_portrait_jpg__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_default_goods_portrait_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_images_default_goods_portrait_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_fastclick__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_psl__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_psl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_psl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_js_checkAppUpdate__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_xe_utils__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_xe_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_xe_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__common_vxeTableUse__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__common_constants__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_v_viewer__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_viewerjs_dist_viewer_css__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_js_versionCheck__ = __webpack_require__(608);











































var userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf('ipad') > -1) {
	var OSversion = /cpu os (.*) like mac os x/g.exec(userAgent);
	OSversion = OSversion[1];
	if (OSversion) {
		OSversion = OSversion.replace('_', '.');
		OSversion = isNaN(parseFloat(OSversion)) ? 0 : parseFloat(OSversion);
	}
	if (OSversion < 11) {
		__WEBPACK_IMPORTED_MODULE_32_fastclick___default.a.attach(document.body, null);
	}

	if (OSversion < 9) {
		__WEBPACK_IMPORTED_MODULE_5_mint_ui___default.a.MessageBox({
			title: '温馨提示',
			message: '当前IOS版本过低，可能影响使用性能，建议使用IOS9.0以上版本',
			showCancelButton: false,
			confirmButtonClass: 'MintUI-alert-btn'
		});
	}
}

if (userAgent.indexOf('android') > -1) {
	var AndroidOSVersion = /linux; android (.*);/g.exec(userAgent);
	AndroidOSVersion = AndroidOSVersion[1] && parseInt(AndroidOSVersion[1]);
	if (AndroidOSVersion && !isNaN(AndroidOSVersion) && AndroidOSVersion < 6) {
		__WEBPACK_IMPORTED_MODULE_5_mint_ui___default.a.MessageBox({
			title: '温馨提示',
			message: '当前系统版本过低，可能影响使用性能，建议使用Android 6.0以上版本的设备',
			showCancelButton: false,
			confirmButtonClass: 'MintUI-alert-btn'
		});
	}
}


if (!window.Promise) {
	window.Promise = __WEBPACK_IMPORTED_MODULE_6_promise_polyfill___default.a;
}

Number.prototype.toFixedNew = function t(d) {
	var s = this + "";
	if (!d) d = 0;
	if (s.indexOf(".") == -1) s += ".";
	s += new Array(d + 1).join("0");
	if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
		var s = "0" + RegExp.$2,
		    pm = RegExp.$1,
		    a = RegExp.$3.length,
		    b = true;
		if (a == d + 2) {
			a = s.match(/\d/g);
			if (parseInt(a[a.length - 1]) > 4) {
				for (var i = a.length - 2; i >= 0; i--) {
					a[i] = parseInt(a[i]) + 1;
					if (a[i] == 10) {
						a[i] = 0;
						b = i != 1;
					} else break;
				}
			}
			s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");
		}if (b) s = s.substr(1);
		return (pm + s).replace(/\.$/, "");
	}
	return this + "";
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.constants = __WEBPACK_IMPORTED_MODULE_37__common_constants__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$PhotoSwipe = function (el, items, options) {
	return new __WEBPACK_IMPORTED_MODULE_7_photoswipe_dist_photoswipe_js___default.a(el, __WEBPACK_IMPORTED_MODULE_8_photoswipe_dist_photoswipe_ui_default_min_js___default.a, items, options);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24__components_common_kxSelect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__components_common_kxSelectPopper__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26__components_common_bdDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__common_alert__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__directive_disabledPassword__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__directive_watermark__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28__storage_sessionStorage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_v_viewer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__storage_localStorage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a, {
	preLoad: 1.3,
	error: __WEBPACK_IMPORTED_MODULE_31__assets_images_default_goods_portrait_jpg___default.a,
	loading: __WEBPACK_IMPORTED_MODULE_30__assets_images_load_gif___default.a,
	attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true || "production" !== 'production';
if (true) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.errorHandler = function (err, vm) {
		console.log(err, vm);
	};
}

window.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
try {
	sessionStorage.setItem('isTraceless', 1);
	sessionStorage.removeItem('isTraceless');
} catch (e) {
	__WEBPACK_IMPORTED_MODULE_5_mint_ui___default.a.Toast({
		message: '请关闭无痕模式',
		duration: 999999
	});
}

if (navigator.userAgent.indexOf('iPad') >= 0) {
	document.body.className = document.body.className + ' cur';
}

if (true) {
	document.addEventListener('contextmenu', function (e) {
		e.preventDefault();
		return false;
	}, true);
}

document.addEventListener('dragstart', function (e) {
	if (e.target.tagName === 'IMG') {
		e.preventDefault();
		return false;
	}
}, true);

document.addEventListener('keydown', function (e) {
	if ((e.ctrlKey || e.metaKey) && e.key === 's') {
		e.preventDefault();
		return false;
	}
}, true);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_13__storage_vuex__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
	watch: {
		'$route': function $route(to) {
			var appType = '11';
			var url = "https://www.bidinghuo.cn";
			var host = document.domain;
			var baseHost = __WEBPACK_IMPORTED_MODULE_33_psl___default.a.parse(host);
			if (baseHost.domain && "web" !== 'testApp' && "web" !== 'app') {
				url = '//www.' + baseHost.domain;
			}
			if (false) {
				url = 'http://www.bdh.com';
			}
			try {
				if (true) {
					this.$axios({
						url: url + '/api/log/add.json',
						method: 'post',
						data: {
							meeting_id: this.$getSessionStorageByName('meetingDetail') ? this.$getSessionStorageByName('meetingDetail').meeting_id : '',
							member_id: this.$getSessionStorageByName('userInfo') ? this.$getSessionStorageByName('userInfo').id : '',
							app_type: appType,
							url: document.location.href,
							vue_path: to.fullPath,
							title: to.meta.title,
							domain: document.domain,
							wap_role: this.$getSessionStorageByName('userInfo') ? this.$getSessionStorageByName('userInfo').wap_role : ''
						}
					}).catch(function (e) {
						console.log(e);
					});
				}
			} catch (e) {
				console.log(e);
			}
		}
	}
});

function currentDomain() {
	var currentDomain = 'localhost';
	if ("production" === 'production' && location.host.includes('.')) {
		var curentHostArr = location.host.split('.');
		var targetIndex = curentHostArr.findIndex(function (item) {
			return item !== 'www';
		});
		if (targetIndex !== -1) {
			currentDomain = curentHostArr[targetIndex];
		}
	}
	return currentDomain;
}
var bdhV2 = ['a', 'localhost', 'zh', 'test', 'test3'].includes(currentDomain());

if ("production" === 'production' && bdhV2) {
	__WEBPACK_IMPORTED_MODULE_40__assets_js_versionCheck__["a" /* default */].init("1.0.20" || '');

	__WEBPACK_IMPORTED_MODULE_40__assets_js_versionCheck__["a" /* default */].currentBuildId = "1778321620069" || '';
}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAAQAMQQAObm5uLi4unp6dHR0cnJydfX1+jo6O/v7/Dw8NPT0/39/crKyvr6+uDg4MfHx////////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAQACwAAAAAEAAQAAAFXeAjPkiTjGgaLI6Tvs9BtPAIMPH8KgK5DDhZSlFYlFrAGIrYMrUcyRGzdapZr6jE02FAyZ6JxrOrEAVnjgaCRS6IkjLjo9F2PaDBwLJAu+NfAix2LQsAMCVVYQgoIQAh+QQFAAAQACwJAAAABwAHAAAFFGDSIE/5OM7SmKhjsK55vjIt32UIACH5BAUAABAALAoAAwAGAAoAAAUaICQqgggpxYKcheM0qOskZm0/eA7luMibvRAAIfkEBQAAEAAsCQAJAAcABwAABRXgcxBOmTwi6TRouiAoIwbtI9d4/oQAIfkEBQAAEAAsAwAKAAoABgAABRsgJI7MKD6POJQnKjpD60IODKFzvQD3nDQISAgAIfkEBQAAEAAsAAAJAAcABwAABRPgI45kSSrFWTgj6rCisLwk0iQhACH5BAUAABAALAAAAwAHAAoAAAUcIPRAJPmco4mm61m+cJk4tGNATX0ryGK/jVspBAAh+QQFAAAQACwAAAAABwAHAAAFFOAjjmRpPgBDIsugio3juGIiz2oIADs="

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_bdToast_toast__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_bdToast_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_bdToast_toast__);



var toastInstance = null;
function clear() {
	if (toastInstance && document.body.contains(toastInstance.$el)) {
		toastInstance.$el.remove();
		toastInstance.$destroy();
		toastInstance = null;
	}
}
function createToastIns(msg) {
	var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1200;

	clear();
	toastInstance = new (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__components_common_bdToast_toast___default.a))({
		el: document.createElement('div')
	});
	toastInstance.msg = msg;
	document.body.appendChild(toastInstance.$el);
	setTimeout(function () {
		clear();
	}, duration);
}

/* harmony default export */ __webpack_exports__["a"] = (createToastIns);

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	see_old_order: {
		TRUE: 2,
		FALSE: 1 },

	wap_role: {
		ADMIN: 'admin',
		PURCHASER: 'purchaser',
		SHOPER: 'shoper' },
	parent_id: {
		TRUE: 0 }
});

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = clearWatermarkCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_map__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(21);








var watermarkCache = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();

var watermarkClassCache = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();

var currentConfigKey = null;

var currentStoreConfigKey = null;

var globalWatcher = null;
var globalStore = null;

var watermarkElements = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_map___default.a();

var watermarkElementRefs = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();

var defaultOptions = {
	content: '',
	rotate: -22,
	font: {
		color: 'rgba(153,153,153,.24)',
		fontSize: 14,
		fontWeight: 'normal',
		fontFamily: 'sans-serif',
		fontStyle: 'normal',
		textAlign: 'center',
		textBaseline: 'middle'
	},
	gap: [100, 100],
	offset: [0, 0]
};

function generateCacheKey(options) {
	return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(options);
}

function createWatermarkImage(options) {
	var cacheKey = generateCacheKey(options);

	if (watermarkCache.has(cacheKey)) {
		return watermarkCache.get(cacheKey);
	}

	var content = options.content,
	    _options$rotate = options.rotate,
	    rotate = _options$rotate === undefined ? defaultOptions.rotate : _options$rotate,
	    _options$font = options.font,
	    font = _options$font === undefined ? {} : _options$font,
	    _options$gap = options.gap,
	    gap = _options$gap === undefined ? defaultOptions.gap : _options$gap,
	    _options$offset = options.offset,
	    offset = _options$offset === undefined ? defaultOptions.offset : _options$offset;

	var fontConfig = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultOptions.font, font);

	var gapX = Array.isArray(gap) ? gap[0] : gap;
	var gapY = Array.isArray(gap) ? gap[1] : gap;
	var offsetX = Array.isArray(offset) ? offset[0] : offset;
	var offsetY = Array.isArray(offset) ? offset[1] : offset;

	var contentArray = Array.isArray(content) ? content : [content];

	var canvas = document.createElement('canvas');
	var ctx = canvas.getContext('2d');

	var fontSize = fontConfig.fontSize;
	var fontFamily = fontConfig.fontFamily;
	var fontWeight = fontConfig.fontWeight;
	var fontStyle = fontConfig.fontStyle;
	ctx.font = fontStyle + ' ' + fontWeight + ' ' + fontSize + 'px ' + fontFamily;
	ctx.fillStyle = fontConfig.color;
	ctx.textAlign = fontConfig.textAlign;
	ctx.textBaseline = fontConfig.textBaseline;

	var maxWidth = 0;
	var lineHeight = fontSize * 1.2;
	contentArray.forEach(function (text) {
		var metrics = ctx.measureText(text);
		maxWidth = Math.max(maxWidth, metrics.width);
	});

	var textHeight = contentArray.length * lineHeight;
	var textWidth = maxWidth;

	var angle = rotate * Math.PI / 180;
	var cos = Math.abs(Math.cos(angle));
	var sin = Math.abs(Math.sin(angle));

	var rotatedTextWidth = textWidth * cos + textHeight * sin;
	var rotatedTextHeight = textWidth * sin + textHeight * cos;

	var canvasWidth = rotatedTextWidth + gapX;
	var canvasHeight = rotatedTextHeight + gapY;

	canvas.width = canvasWidth;
	canvas.height = canvasHeight;

	ctx.font = fontStyle + ' ' + fontWeight + ' ' + fontSize + 'px ' + fontFamily;
	ctx.fillStyle = fontConfig.color;
	ctx.textAlign = fontConfig.textAlign;
	ctx.textBaseline = fontConfig.textBaseline;

	var rotateCenterX = offsetX + rotatedTextWidth / 2;
	var rotateCenterY = offsetY + rotatedTextHeight / 2;

	ctx.save();
	ctx.translate(rotateCenterX, rotateCenterY);
	ctx.rotate(angle);

	contentArray.forEach(function (text, index) {
		var y = (index - (contentArray.length - 1) / 2) * lineHeight;
		ctx.fillText(text, 0, y);
	});

	ctx.restore();

	var base64 = canvas.toDataURL('image/png');

	watermarkCache.set(cacheKey, base64);

	return base64;
}

function getOrCreateWatermarkClass(base64Image) {
	if (watermarkClassCache.has(base64Image)) {
		return watermarkClassCache.get(base64Image);
	}

	var className = 'watermark-bg-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
	var style = document.createElement('style');
	style.textContent = '\n\t\t.' + className + ' {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tpointer-events: none;\n\t\t\tz-index: 9999;\n\t\t\tbackground-image: url(' + base64Image + ');\n\t\t\tbackground-repeat: repeat;\n\t\t\tbackground-position: 0 0;\n\t\t}\n\t';
	document.head.appendChild(style);
	watermarkClassCache.set(base64Image, className);
	return className;
}

function removeWatermark(el) {
	el.querySelectorAll('.watermark-container').forEach(function (node) {
		return node.remove();
	});

	watermarkElements.delete(el);
	watermarkElementRefs.delete(el);

	delete el._watermarkConfigKey;
}

function createWatermarkElement(el, options, configKey) {
	var existing = el.querySelectorAll('.watermark-container');

	if (el._watermarkConfigKey === configKey && existing.length === 1) {
		return;
	}

	existing.forEach(function (node) {
		return node.remove();
	});

	var watermarkDiv = document.createElement('div');
	watermarkDiv.className = 'watermark-container';

	var base64Image = createWatermarkImage(options);

	var className = getOrCreateWatermarkClass(base64Image);
	watermarkDiv.className = 'watermark-container ' + className;

	var originalPosition = window.getComputedStyle(el).position;
	if (originalPosition === 'static') {
		el.style.position = 'relative';
	}

	el.appendChild(watermarkDiv);

	el._watermarkConfigKey = configKey;
}

function getMergedWatermarkOptions(vm) {
	var localOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	if (!vm || !vm.$store) {
		return null;
	}

	var meetingDetail = vm.$store.state.meetingDetail || {};

	if (!meetingDetail.is_open_global_watermark) {
		if (currentConfigKey !== null) {
			watermarkCache.clear();
			watermarkClassCache.clear();
			currentConfigKey = null;
			currentStoreConfigKey = null;
		}
		return null;
	}

	var storeOptions = meetingDetail.watermarkOptions || {};

	var mergedOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultOptions, storeOptions, localOptions, {
		font: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultOptions.font, storeOptions.font || {}, localOptions.font || {})
	});

	if (!mergedOptions.content) {
		return null;
	}

	var newConfigKey = generateCacheKey(mergedOptions);
	if (currentConfigKey !== null && currentConfigKey !== newConfigKey) {
		watermarkCache.clear();
		watermarkClassCache.clear();
	}
	currentConfigKey = newConfigKey;

	return mergedOptions;
}

function updateAllWatermarks() {
	if (!globalStore) {
		return;
	}

	watermarkElementRefs.forEach(function (el) {
		if (!document.contains(el)) {
			watermarkElementRefs.delete(el);
			watermarkElements.delete(el);
			return;
		}

		var elementInfo = watermarkElements.get(el);
		if (!elementInfo) {
			watermarkElementRefs.delete(el);
			return;
		}

		var vm = elementInfo.vm,
		    localOptions = elementInfo.localOptions,
		    _elementInfo$shouldSh = elementInfo.shouldShow,
		    shouldShow = _elementInfo$shouldSh === undefined ? true : _elementInfo$shouldSh;

		if (!shouldShow) {

			removeWatermark(el);
			return;
		}

		var options = getMergedWatermarkOptions(vm, localOptions);

		if (options) {
			var configKey = generateCacheKey(options);
			createWatermarkElement(el, options, configKey);
		} else {

			removeWatermark(el);
		}
	});
}

function initGlobalWatcher(store) {
	if (globalWatcher || !store) {
		return;
	}

	globalStore = store;

	globalWatcher = store.watch(function (state) {
		var meetingDetail = state.meetingDetail || {};
		return {
			is_open_global_watermark: meetingDetail.is_open_global_watermark,
			watermarkOptions: meetingDetail.watermarkOptions
		};
	}, function () {
		var meetingDetail = globalStore.state.meetingDetail || {};

		if (!meetingDetail.is_open_global_watermark) {
			if (currentStoreConfigKey !== null) {
				currentStoreConfigKey = null;
				currentConfigKey = null;
				watermarkCache.clear();
				watermarkClassCache.clear();
				updateAllWatermarks();
			}
			return;
		}

		var storeOptions = meetingDetail.watermarkOptions || {};
		var storeMergedOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultOptions, storeOptions, {
			font: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultOptions.font, storeOptions.font || {})
		});

		var newStoreConfigKey = generateCacheKey(storeMergedOptions);

		if (currentStoreConfigKey === newStoreConfigKey) {
			return;
		}

		currentStoreConfigKey = newStoreConfigKey;

		updateAllWatermarks();
	}, { deep: true });
}

var directiveName = 'watermark';

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_6_vue__["default"].directive(directiveName, {
			inserted: function inserted(el, binding, vnode) {
				var vm = vnode.context;

				var shouldShow = true;
				var localOptions = {};

				if (typeof binding.value === 'boolean') {
					shouldShow = binding.value;
				} else if (binding.value && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(binding.value) === 'object') {
					localOptions = binding.value;
					shouldShow = true;
				} else if (binding.value === undefined || binding.value === null) {
					shouldShow = true;
				}

				if (!shouldShow) {
					return;
				}

				if (vm && vm.$store && !globalWatcher) {
					initGlobalWatcher(vm.$store);
				}

				var options = getMergedWatermarkOptions(vm, localOptions);

				if (!options) {
					return;
				}

				var configKey = generateCacheKey(options);
				createWatermarkElement(el, options, configKey);

				watermarkElements.set(el, { vm: vm, localOptions: localOptions, shouldShow: shouldShow });
				watermarkElementRefs.add(el);
			},
			update: function update(el, binding, vnode) {
				var vm = vnode.context;

				var shouldShow = true;
				var localOptions = {};

				if (typeof binding.value === 'boolean') {
					shouldShow = binding.value;
				} else if (binding.value && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(binding.value) === 'object') {
					localOptions = binding.value;
					shouldShow = true;
				} else if (binding.value === undefined || binding.value === null) {
					shouldShow = true;
				}

				watermarkElements.set(el, { vm: vm, localOptions: localOptions, shouldShow: shouldShow });

				if (!shouldShow) {

					removeWatermark(el);
					return;
				}

				var options = getMergedWatermarkOptions(vm, localOptions);

				if (options) {
					var configKey = generateCacheKey(options);
					createWatermarkElement(el, options, configKey);
				} else {

					removeWatermark(el);
				}
			},
			unbind: function unbind(el) {

				removeWatermark(el);
				watermarkElementRefs.delete(el);
			}
		});
	}
});

function clearWatermarkCache() {
	watermarkCache.clear();
	watermarkClassCache.clear();
}

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var Component = __webpack_require__(147)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5964ba53",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_axiosSetting__ = __webpack_require__(154);







var updateApp = function () {
	function updateApp() {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, updateApp);

		var _this = this;
		plus.runtime.getProperty(plus.runtime.appid, function (inf) {
			_this.checkVersions(inf.version);
		});
	}

	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(updateApp, [{
		key: 'checkVersions',
		value: function checkVersions(version) {
			__WEBPACK_IMPORTED_MODULE_4__common_axiosSetting__["a" /* default */].AxiosIns({
				url: 'app/padinfo',
				domain: 'www',
				params: {
					version: version,
					os_name: plus.os.name,
					os_version: plus.os.version,
					os_model: plus.device.model
				}
			}).then(function (res) {
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.data.app).length > 0) {
					var app_info = res.data.app;
					var pkgType = app_info.url.slice(-3);

					if (app_info.is_constraint === 1) {
						if (pkgType !== 'wgt') {
							plus.nativeUI.showWaiting("请安装最新版本后重启应用...");
							plus.runtime.openURL(app_info.url);
						} else {
							var dtask = plus.downloader.createDownload(app_info.url, {}, function (d, status) {
								if (status === 200) {
									plus.nativeUI.closeWaiting();
									plus.nativeUI.showWaiting("正在更新...");
									var path = d.filename;
									plus.runtime.install(path, {}, function () {
										plus.nativeUI.closeWaiting();
										plus.nativeUI.toast("更新完成");
										plus.runtime.restart();
									}, function (e) {
										plus.nativeUI.alert("更新失败，请重试！\n" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
									});
								} else {
									plus.nativeUI.showWaiting("更新失败，请退出重试！");
								}
							});
							dtask.start();
						}
					} else {
						if (pkgType !== 'wgt') {
							plus.runtime.openURL(app_info.url);
						} else {
							plus.nativeUI.showWaiting("正在后台更新...");
							var _dtask = plus.downloader.createDownload(app_info.url, {}, function (d, status) {
								if (status === 200) {
									var path = d.filename;
									plus.runtime.install(path, {}, function () {
										plus.nativeUI.closeWaiting();
										plus.nativeUI.toast("更新完成");
										plus.runtime.restart();
									}, function (e) {
										plus.nativeUI.closeWaiting();
										plus.nativeUI.alert("更新失败，请重试！\n" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
									});
								} else {
									plus.nativeUI.alert("网络错误，更新失败！");
								}
							});
							_dtask.start();
						}
					}
				}
			});
		}
	}]);

	return updateApp;
}();

document.addEventListener('plusready', function () {
	new updateApp();
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);





var versionCheck = {
	currentVersion: '',

	currentBuildId: '',

	lastCheckTime: 0,

	checkInterval: 60 * 60 * 1000,

	timer: null,

	isUpdateNoticeShown: false,
	init: function init(version) {
		var _this = this;

		this.currentVersion = version;
		this.startCheck();

		window.addEventListener('visibilitychange', function () {
			if (document.visibilityState === 'visible') {
				_this.checkVersion(true);
				_this.ensureTimerRunning();
			} else {
				_this.clearTimer();
			}
		});
	},
	ensureTimerRunning: function ensureTimerRunning() {
		var _this2 = this;

		if (!this.timer) {
			this.timer = setInterval(function () {
				_this2.checkVersion();
			}, this.checkInterval);
		}
	},
	clearTimer: function clearTimer() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	},
	startCheck: function startCheck() {
		var _this3 = this;

		this.checkVersion(true);

		this.clearTimer();

		this.timer = setInterval(function () {
			_this3.checkVersion();
		}, this.checkInterval);
	},
	checkVersion: function checkVersion() {
		var _this4 = this;

		var skipTimeCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

		var now = Date.now();
		if (!skipTimeCheck && now - this.lastCheckTime < this.checkInterval) {
			return;
		}
		this.lastCheckTime = now;

		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/version.json?t=' + now, {
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				'Pragma': 'no-cache',
				'Expires': '0'
			}
		}).then(function (response) {
			var serverVersion = response.data.version;
			var serverBuildId = response.data.buildId;

			if (serverVersion && serverVersion !== _this4.currentVersion && serverBuildId && serverBuildId !== _this4.currentBuildId) {
				_this4.currentBuildId = serverBuildId;
				_this4.currentVersion = serverVersion;
				_this4.notifyUpdate();
			}
		});
	},
	notifyUpdate: function notifyUpdate() {
		var _this5 = this;

		if (this.isUpdateNoticeShown) {
			return;
		}

		this.isUpdateNoticeShown = true;

		var currentUrl = new URL(window.location.href);
		var currentParams = currentUrl.searchParams;
		var newParams = new URLSearchParams();
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(currentParams), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _ref = _step.value;

				var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

				var key = _ref2[0];
				var value = _ref2[1];

				newParams.append(key, value);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		newParams.append('refresh_t', Date.now());

		var newUrl = currentUrl.pathname + '?' + newParams.toString();
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["MessageBox"])({
			title: '发现新版本',
			message: '系统功能已更新，请关闭软件后重新开启，或联系服务人员',
			showCancelButton: false,
			confirmButtonText: '立即刷新',
			confirmButtonClass: 'mint-msgbox-confirm',
			closeOnPressEscape: false,
			closeOnClickModal: false
		}).then(function (action) {
			if (action === 'confirm') {
				_this5.isUpdateNoticeShown = false;

				window.location.replace(newUrl);
			}
		}).catch(function () {
			_this5.isUpdateNoticeShown = false;
			window.location.replace(newUrl);
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (versionCheck);

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);





var Alert = function () {
	function Alert() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Alert);

		this.duration = duration;
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Alert, [{
		key: 'success',
		value: function success() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.duration;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
				message: message,
				duration: duration
			});
		}
	}]);

	return Alert;
}();

var alert = new Alert();

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$bdAlert = alert;
	}
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_vuex__ = __webpack_require__(242);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
	computed: {
		currentDomain: function currentDomain() {
			var currentDomain = 'localhost';
			if ("production" === 'production' && location.host.includes('.')) {
				var curentHostArr = location.host.split('.');
				var targetIndex = curentHostArr.findIndex(function (item) {
					return item !== 'www';
				});
				if (targetIndex !== -1) {
					currentDomain = curentHostArr[targetIndex];
				}
			}
			return currentDomain;
		},
		isForbidOrder: function isForbidOrder() {
			return __WEBPACK_IMPORTED_MODULE_1__storage_vuex__["a" /* default */].state.meetingDetail.is_forbid_order;
		},
		isOpenRetailerOrder: function isOpenRetailerOrder() {
			return __WEBPACK_IMPORTED_MODULE_1__storage_vuex__["a" /* default */].state.meetingDetail.is_open_retailer_order;
		},
		bdhV2: function bdhV2() {
			return ['a', 'localhost', 'zh', 'test', 'test3'].includes(this.currentDomain);
		}
	}
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vxe_table__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vxe_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vxe_table__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Colgroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Column"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Tooltip"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Grid"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Icon"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vxe_table__["Table"]);
__WEBPACK_IMPORTED_MODULE_1_vxe_table__["VXETable"].formats.add('formatMoney', function (_ref) {
  var cellValue = _ref.cellValue;
  return cellValue === '' || cellValue === '-' ? cellValue : __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.Helper.formatMoney(cellValue);
});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__template__);





var dialog = function () {
	function dialog() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, dialog);

		this.instances = null;
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(dialog, [{
		key: 'add',
		value: function add(ins) {
			this.instances = ins;
		}
	}, {
		key: 'init',
		value: function init(dom) {
			this.instances.init(dom.innerHTML);
			return this;
		}
	}, {
		key: 'open',
		value: function open() {
			this.instances.active = true;
		}
	}, {
		key: 'test',
		value: function test() {}
	}]);

	return dialog;
}();

var dialogIns = new dialog();

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$bdDialog = dialogIns;
		__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('bdDialog', __WEBPACK_IMPORTED_MODULE_3__template___default.a);
	}
});

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kxSelect__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kxSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__kxSelect__);







var kxSelect = function () {
	function kxSelect() {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, kxSelect);

		this.instances = [];
	}

	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(kxSelect, [{
		key: 'init',
		value: function init() {}
	}, {
		key: 'add',
		value: function add(ins) {
			this.instances.push(ins);
		}
	}, {
		key: 'remove',
		value: function remove(ins) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;

					var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

					var index = _ref2[0];
					var v = _ref2[1];

					if (v._uid === ins._uid) {
						this.instances.splice(index, 1);
						break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'closeAll',
		value: function closeAll() {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

					var v = _ref4[1];

					v.close();
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}, {
		key: 'closeOthers',
		value: function closeOthers(ins) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _ref5 = _step3.value;

					var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

					var v = _ref6[1];

					if (v._uid !== ins._uid) {
						v.close();
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		}
	}, {
		key: 'test',
		value: function test() {}
	}]);

	return kxSelect;
}();

var kxs = new kxSelect();
document.body.addEventListener('click', kxs.closeAll.bind(kxs));
document.body.addEventListener('touchstart', kxs.closeAll.bind(kxs));
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$kxSelect = kxs;
		__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('kxSelect', __WEBPACK_IMPORTED_MODULE_5__kxSelect___default.a);
	}
});

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kxSelect__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kxSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__kxSelect__);







var kxSelect = function () {
	function kxSelect() {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, kxSelect);

		this.instances = [];
	}

	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(kxSelect, [{
		key: 'init',
		value: function init() {}
	}, {
		key: 'add',
		value: function add(ins) {
			this.instances.push(ins);
		}
	}, {
		key: 'remove',
		value: function remove(ins) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;

					var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

					var index = _ref2[0];
					var v = _ref2[1];

					if (v._uid === ins._uid) {
						this.instances.splice(index, 1);
						break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'closeAll',
		value: function closeAll() {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

					var v = _ref4[1];

					v.close();
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}, {
		key: 'closeOthers',
		value: function closeOthers(ins) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instances.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _ref5 = _step3.value;

					var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

					var v = _ref6[1];

					if (v._uid !== ins._uid) {
						v.close();
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		}
	}, {
		key: 'test',
		value: function test() {}
	}]);

	return kxSelect;
}();

var kxs = new kxSelect();
document.body.addEventListener('click', kxs.closeAll.bind(kxs));
document.body.addEventListener('touchstart', kxs.closeAll.bind(kxs));
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$kxSelectPopper = kxs;
		__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('kxSelectPopper', __WEBPACK_IMPORTED_MODULE_5__kxSelect___default.a);
	}
});

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);

var directiveName = "password";

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive(directiveName, {
			bind: function bind(el) {
				el.addEventListener('focus', function () {
					el.setAttribute('type', 'password');
				});
			}
		});
	}
});

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var list = function list(resolve) {
	return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1234)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var detail = function detail(resolve) {
	return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'exhibit/list',
	name: 'exhibitList',
	meta: {
		title: '陈列订货',
		searchDisabled: false
	},
	component: list
}, {
	path: 'exhibit/detail',
	name: 'exhibitDetail',
	meta: {
		title: '陈列订货详情',
		searchDisabled: false,
		activeName: 'exhibitList'
	},
	component: detail
}]);

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var introduct = function introduct(resolve) {
	return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1235)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var notice = function notice(resolve) {
	return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1236)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'introduct',
	name: 'introduct',
	meta: {
		title: '介绍',
		searchDisabled: true
	},
	component: introduct
}, {
	path: 'notice',
	name: 'notice',
	meta: {
		title: '公告',
		searchDisabled: true
	},
	component: notice
}]);

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var collect = function collect(resolve) {
	return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1242)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myorder = function myorder(resolve) {
	return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1245)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var unusualOrder = function unusualOrder(resolve) {
	return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1254)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var rank = function rank(resolve) {
	return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1251)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var audit = function audit(resolve) {
	return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1240)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var auditDetail = function auditDetail(resolve) {
	return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1241)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var minimumOrder = function minimumOrder(resolve) {
	return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1244)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var analyze = function analyze(resolve) {
	return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1239)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var retailOrderAnalyse = function retailOrderAnalyse(resolve) {
	return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1252)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var target = function target(resolve) {
	return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1253)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var newPlan = function newPlan(resolve) {
	return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1246)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var planDetail = function planDetail(resolve) {
	return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1247)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var productTotal = function productTotal(resolve) {
	return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1248)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var colorSizeRatio = function colorSizeRatio(resolve) {
	return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1243)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var productsLimitDetail = function productsLimitDetail(resolve) {
	return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1249)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var productsOrderLimitDetail = function productsOrderLimitDetail(resolve) {
	return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1250)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'order/collect',
	name: 'orderCollect',
	meta: {
		title: '收藏评款',
		searchDisabled: true
	},
	component: collect
}, {
	path: 'order/myorder',
	name: 'orderMyOrder',
	meta: {
		title: '我的订单',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: myorder
}, {
	path: 'order/unusual',
	name: 'orderUnusual',
	meta: {
		title: '异常订单',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: unusualOrder
}, {
	path: 'order/rank',
	name: 'orderRank',
	meta: {
		title: '订货排名',
		searchDisabled: false,
		notNeedGlobalScroll: true
	},
	component: rank
}, {
	path: 'order/audit',
	name: 'orderAudit',
	meta: {
		title: '订单审核',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: audit
}, {
	path: 'order/auditDetail',
	name: 'orderAuditDetail',
	meta: {
		title: '订单审核',
		searchDisabled: true,
		activeName: 'orderAudit',
		notNeedGlobalScroll: true
	},
	component: auditDetail
}, {
	path: 'order/minimumOrder',
	name: 'orderMinimumOrder',
	meta: {
		title: '起订量',
		searchDisabled: true,
		activeName: 'minimumOrder',
		notNeedGlobalScroll: true
	},
	component: minimumOrder
}, {
	path: 'order/analyze',
	name: 'orderAnalyze',
	meta: {
		title: '订单分析',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: analyze
}, {
	path: 'order/retailOrderAnalyse/index',
	name: 'retailOrderAnalyze',
	meta: {
		title: '零售订单分析',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: retailOrderAnalyse
}, {
	path: 'order/target',
	name: 'orderTarget',
	meta: {
		title: '指标达成',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: target
}, {
	path: 'order/newPlan',
	name: 'orderNewPlan',
	meta: {
		title: '新订货规划',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: newPlan
}, {
	path: 'order/planDetail',
	name: 'orderPlanDetail',
	meta: {
		title: '新订货规划明细',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: planDetail
}, {
	path: 'order/productTotal',
	name: 'orderProductTotal',
	meta: {
		title: '订量汇总',
		searchDisabled: false,
		notNeedGlobalScroll: true
	},
	component: productTotal
}, {
	path: 'order/colorSizeRatio',
	name: 'orderColorSizeRatio',
	meta: {
		title: '款色尺码占比',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: colorSizeRatio
}, {
	path: 'order/productsLimitDetail',
	name: 'productsLimitDetail',
	meta: {
		title: '商品组限制详情',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: productsLimitDetail
}, {
	path: 'order/productsOrderLimitDetail',
	name: 'productsOrderLimitDetail',
	meta: {
		title: '组合起订量详情',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: productsOrderLimitDetail
}]);

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var overview = function overview(resolve) {
	return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1261)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var goodsCompare = function goodsCompare(resolve) {
	return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1258)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandAnalysis = function bandAnalysis(resolve) {
	return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1256)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var structureAnalysis = function structureAnalysis(resolve) {
	return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1265)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var structureCategory = function structureCategory(resolve) {
	return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1266)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var size = function size(resolve) {
	return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var sizeModel = function sizeModel(resolve) {
	return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var tagSkc = function tagSkc(resolve) {
	return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1267)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandColor = function bandColor(resolve) {
	return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1257)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var price = function price(resolve) {
	return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1262)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mainPush = function mainPush(resolve) {
	return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1260)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var kjTag = function kjTag(resolve) {
	return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1259)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var areaOrderRank = function areaOrderRank(resolve) {
	return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1255)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var topSkc = function topSkc(resolve) {
	return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1268)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'orderNew/overview',
	name: 'overview',
	meta: {
		title: '整体概况',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: overview
}, {
	path: 'orderNew/compare',
	name: 'goodsCompare',
	meta: {
		title: '两年对比',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: goodsCompare
}, {
	path: 'orderNew/band',
	name: 'bandAnalysis',
	meta: {
		title: '波段指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandAnalysis
}, {
	path: 'orderNew/structure',
	name: 'structureAnalysis',
	meta: {
		title: '结构分析',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: structureAnalysis
}, {
	path: 'orderNew/size',
	name: 'sizeDistribution',
	meta: {
		title: '品类尺码分析',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: size
}, {
	path: 'orderNew/sizeModel',
	name: 'sizeModelDistribution',
	meta: {
		title: '尺码指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: sizeModel
}, {
	path: 'orderNew/tag',
	name: 'tagSkc',
	meta: {
		title: '标签指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: tagSkc
}, {
	path: 'orderNew/bandColor',
	name: 'bandColor',
	meta: {
		title: '色系指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandColor
}, {
	path: 'orderNew/price',
	name: 'priceDistribution',
	meta: {
		title: '价格指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: price
}, {
	path: 'orderNew/structureCategory',
	name: 'structureCategory',
	meta: {
		title: '品类指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: structureCategory
}, {
	path: 'orderNew/mainPush',
	name: 'mainPush',
	meta: {
		title: '主推爆杆',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: mainPush
}, {
	path: 'orderNew/kjTag',
	name: 'kjTag',
	meta: {
		title: '框架款指引',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: kjTag
}, {
	path: 'orderNew/areaOrderRank',
	name: 'areaOrderRank',
	meta: {
		title: '区域订量排名',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: areaOrderRank
}, {
	path: 'orderNew/topSkc',
	name: 'topSkc',
	meta: {
		title: 'TOP指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: topSkc
}]);

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var overview = function overview(resolve) {
	return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1275)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var goodsCompare = function goodsCompare(resolve) {
	return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1272)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandAnalysis = function bandAnalysis(resolve) {
	return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1270)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var structureCategory = function structureCategory(resolve) {
	return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var sizeModel = function sizeModel(resolve) {
	return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1277)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var kjTag = function kjTag(resolve) {
	return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1273)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var areaOrderRank = function areaOrderRank(resolve) {
	return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1269)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var tagSkc = function tagSkc(resolve) {
	return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandColor = function bandColor(resolve) {
	return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1271)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var price = function price(resolve) {
	return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1276)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mainPush = function mainPush(resolve) {
	return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1274)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var topSkc = function topSkc(resolve) {
	return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1280)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'orderNewAgent/overview',
	name: 'overviewAgent',
	meta: {
		title: '整体概况',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: overview
}, {
	path: 'orderNewAgent/compare',
	name: 'goodsCompareAgent',
	meta: {
		title: '两年对比',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: goodsCompare
}, {
	path: 'orderNewAgent/band',
	name: 'bandAnalysisAgent',
	meta: {
		title: '波段指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandAnalysis
}, {
	path: 'orderNewAgent/sizeModel',
	name: 'sizeModelDistributionAgent',
	meta: {
		title: '尺码指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: sizeModel
}, {
	path: 'orderNewAgent/kjTag',
	name: 'kjTagAgent',
	meta: {
		title: '框架款指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: kjTag
}, {
	path: 'orderNewAgent/areaOrderRank',
	name: 'areaOrderRankAgent',
	meta: {
		title: '区域订量排名',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: areaOrderRank
}, {
	path: 'orderNewAgent/tag',
	name: 'tagSkcAgent',
	meta: {
		title: '标签指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: tagSkc
}, {
	path: 'orderNewAgent/bandColor',
	name: 'bandColorAgent',
	meta: {
		title: '色系指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandColor
}, {
	path: 'orderNewAgent/price',
	name: 'priceDistributionAgent',
	meta: {
		title: '价格指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: price
}, {
	path: 'orderNewAgent/structureCategory',
	name: 'structureCategoryAgent',
	meta: {
		title: '品类指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: structureCategory
}, {
	path: 'orderNewAgent/mainPush',
	name: 'mainPushAgent',
	meta: {
		title: '主推爆杆',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: mainPush
}, {
	path: 'orderNewAgent/topSkc',
	name: 'topSkcAgent',
	meta: {
		title: 'TOP指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: topSkc
}]);

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var overview = function overview(resolve) {
	return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1230)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var goodsCompare = function goodsCompare(resolve) {
	return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1227)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandAnalysis = function bandAnalysis(resolve) {
	return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1282)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var structureCategory = function structureCategory(resolve) {
	return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1286)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var sizeModel = function sizeModel(resolve) {
	return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var tagSkc = function tagSkc(resolve) {
	return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1231)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var kjTag = function kjTag(resolve) {
	return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1228)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var areaOrderRank = function areaOrderRank(resolve) {
	return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1281)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var bandColor = function bandColor(resolve) {
	return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1283)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var price = function price(resolve) {
	return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1284)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mainPush = function mainPush(resolve) {
	return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1229)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var topSkc = function topSkc(resolve) {
	return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1287)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'orderNewPurchase/overview',
	name: 'overviewPurchase',
	meta: {
		title: '整体概况',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: overview
}, {
	path: 'orderNewPurchase/compare',
	name: 'goodsComparePurchase',
	meta: {
		title: '两年对比',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: goodsCompare
}, {
	path: 'orderNewPurchase/band',
	name: 'bandAnalysisPurchase',
	meta: {
		title: '波段指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandAnalysis
}, {
	path: 'orderNewPurchase/sizeModel',
	name: 'sizeModelDistributionPurchase',
	meta: {
		title: '尺码指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: sizeModel
}, {
	path: 'orderNewPurchase/kjTag',
	name: 'kjTagPurchase',
	meta: {
		title: '框架款指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: kjTag
}, {
	path: 'orderNewPurchase/areaOrderRank',
	name: 'areaOrderRankPurchase',
	meta: {
		title: '区域订量排名',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: areaOrderRank
}, {
	path: 'orderNewPurchase/tag',
	name: 'tagSkcPurchase',
	meta: {
		title: '标签指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: tagSkc
}, {
	path: 'orderNewPurchase/bandColor',
	name: 'bandColorPurchase',
	meta: {
		title: '色系指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: bandColor
}, {
	path: 'orderNewPurchase/price',
	name: 'priceDistributionPurchase',
	meta: {
		title: '价格指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: price
}, {
	path: 'orderNewPurchase/structureCategory',
	name: 'structureCategoryPurchase',
	meta: {
		title: '品类指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: structureCategory
}, {
	path: 'orderNewPurchase/mainPush',
	name: 'mainPushPurchase',
	meta: {
		title: '主推爆杆',
		searchDisabled: true,
		notNeedGlobalScroll: false
	},
	component: mainPush
}, {
	path: 'orderNewPurchase/topSkc',
	name: 'topSkcPurchase',
	meta: {
		title: 'TOP指引',
		searchDisabled: true,
		notNeedGlobalScroll: true
	},
	component: topSkc
}]);

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var singal = function singal(resolve) {
	return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var batch = function batch(resolve) {
	return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var match = function match(resolve) {
	return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var infer = function infer(resolve) {
	return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var inferControl = function inferControl(resolve) {
	return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var deduceList = function deduceList(resolve) {
	return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1290)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var deduceDetail = function deduceDetail(resolve) {
	return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'ordering/singal',
	name: 'orderingSingal',
	meta: {
		title: '单款订货',
		mainSearchHandle: function mainSearchHandle() {}
	},
	component: singal
}, {
	path: 'ordering/batch',
	name: 'orderingBatch',
	meta: {
		title: '批量订货',
		searchDisabled: false
	},
	component: batch
}, {
	path: 'ordering/match',
	name: 'orderingMatch',
	meta: {
		title: '搭配订货',
		mainSearchHandle: function mainSearchHandle() {}
	},
	component: match
}, {
	path: 'ordering/infer',
	name: 'orderingInfer',
	meta: {
		title: '推送订货',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: true
	},
	component: infer
}, {
	path: 'ordering/inferControl',
	name: 'orderingInferControl',
	meta: {
		title: '推送订货',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: false,
		activeName: 'orderingInfer'
	},
	component: inferControl
}, {
	path: 'ordering/deduceList',
	name: 'orderingDeduceList',
	meta: {
		title: '360推演列表',
		mainSearchHandle: function mainSearchHandle() {}
	},
	component: deduceList
}, {
	path: 'ordering/deduceDetail',
	name: 'orderingDeduceDetail',
	meta: {
		title: '360推演详情',
		mainSearchHandle: function mainSearchHandle() {},

		activeName: 'orderingDeduceList'
	},
	component: deduceDetail
}]);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pactList = function pactList(resolve) {
	return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var sendPact = function sendPact(resolve) {
	return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'pact/pactList',
	name: 'pactList',
	meta: {
		title: '电子合同',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: true
	},
	component: pactList
}, {
	path: 'pact/sendPact',
	name: 'sendPact',
	meta: {
		title: '合同推送',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: true
	},
	component: sendPact
}]);

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var starStore = function starStore(resolve) {
	return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'star/star',
	name: 'starStore',
	meta: {
		title: '明星店铺',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: true
	},
	component: starStore
}]);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = function list(resolve) {
	return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'submitOrder/list',
	name: 'submitOrderList',
	meta: {
		title: '必订款',
		mainSearchHandle: function mainSearchHandle() {},

		notNeedGlobalScroll: true,
		searchDisabled: true
	},
	component: list
}]);

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var user = function user(resolve) {
	return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
	path: 'user/back',
	name: 'user',
	component: user,
	meta: {
		title: '客户返程',
		notNeedGlobalScroll: true,
		searchDisabled: true
	}
}]);

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	showGoods: false,
	selIds: ''
};

var mutations = {
	changeAnalyzeActive: function changeAnalyzeActive(state, payload) {
		state.showGoods = payload;
	},
	changeAnalyzeId: function changeAnalyzeId(state, payload) {
		state.selIds = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	id: '',
	active: false,
	title: '',
	initSearch: function initSearch() {},

	fab: '',
	originMethod: ''
};

var mutations = {
	changeDeduceId: function changeDeduceId(state, payload) {
		state.id = payload;
	},
	changeOriginMethod: function changeOriginMethod(state, payload) {
		state.originMethod = payload;
	},
	changeDeduceStatus: function changeDeduceStatus(state, payload) {
		state.active = payload;
	},
	changeDeduceTitle: function changeDeduceTitle(state, payload) {
		state.title = payload;
	},
	changeDeduceSearch: function changeDeduceSearch(state, payload) {
		state.initSearch = payload;
	},
	changeDeducFab: function changeDeducFab(state, payload) {
		state.fab = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
	commonPre: 'common',
	commonPreCN: '通用属性',
	imageViewerOpen: false };

var mutations = {
	setImageViewerOpen: function setImageViewerOpen(state, payload) {
		state.imageViewerOpen = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	coercePush: false
};
var mutations = {
	changePushStatus: function changePushStatus(state, status) {
		state.coercePush = status;
	}
};
/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
	condition: {},
	auditParams: {
		isBack: false,
		toName: ''
	},
	minimumOrderStoreList: [],
	sendPactRetailerList: []
};

var mutations = {
	changeCondition: function changeCondition(state, payload) {
		state.condition = payload;
	},
	changeAuditParams: function changeAuditParams(state, payload) {
		state.auditParams = payload;
	},
	changeMinimumOrderStoreList: function changeMinimumOrderStoreList(state, payload) {
		state.minimumOrderStoreList = payload;
	},
	changeSendPactRetailerList: function changeSendPactRetailerList(state, payload) {
		state.sendPactRetailerList = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
	mainSearchHandle: {},
	isDisabled: true,
	searchKeyword: '' };

var mutations = {
	changeMainSearchHandle: function changeMainSearchHandle(state, payload) {
		state.mainSearchHandle = payload;
	},
	changeSearchDisabled: function changeSearchDisabled(state, payload) {
		state.isDisabled = payload;
	},
	changeSearchKeyword: function changeSearchKeyword(state, payload) {
		state.searchKeyword = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	info: {},
	is_forbid_order: true,
	is_open_retailer_order: false,
	is_open_global_watermark: false,
	watermarkOptions: {
		content: ''
	}

};
var mutations = {
	updateMeetingDetailDate: function updateMeetingDetailDate(state, status) {
		state.info = status || {};
	},
	updatIsForbidOrder: function updatIsForbidOrder(state, payload) {
		state.is_forbid_order = payload;
	},
	updateIsOpenRetailerOrder: function updateIsOpenRetailerOrder(state, payload) {
		state.is_open_retailer_order = payload;
	},
	updatIsOpenWatermark: function updatIsOpenWatermark(state, payload) {
		state.is_open_global_watermark = payload;
	},
	updateWatermarkOptions: function updateWatermarkOptions(state, payload) {
		state.watermarkOptions = payload;
	}
};
/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	productDetail: {},
	matchDetail: {}
};

var mutations = {
	changeProductDetail: function changeProductDetail(state, payload) {
		state.productDetail = payload;
	},
	changeMatchDetail: function changeMatchDetail(state, payload) {
		state.matchDetail = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_axiosSetting__ = __webpack_require__(154);

var state = {
	pactNum: 0
};
var mutations = {
	increment: function increment(state, n) {
		state.pactNum = n;
	}
};
var actions = {
	incrementAsync: function incrementAsync(_ref) {
		var commit = _ref.commit;

		var userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
		if (userInfo.id && userInfo.wap_role !== 'shoper' && userInfo.wap_role !== 'admin') {
			__WEBPACK_IMPORTED_MODULE_0__common_axiosSetting__["a" /* default */].AxiosIns({
				url: 'contract/sign_count.json'
			}).then(function (res) {
				commit('increment', res.wait);
			});
		}
	}
};
/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions
});

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	detail: {},
	matchDetail: {},
	initSearch: function initSearch() {},
	initLikeSearch: function initLikeSearch() {},

	listData: [],
	historyStore: [],
	editStoreIds: [],
	drillParentListRefresh: false,
	drillListRefresh: false,
	drillActive: false,
	drillParentActive: false,
	isRefreshSingal: false,
	scrollGoodsId: 0 };

var mutations = {
	changeSingalDetail: function changeSingalDetail(state, payload) {
		state.detail = payload;
	},
	changeIsRefreshSingal: function changeIsRefreshSingal(state, payload) {
		state.isRefreshSingal = payload;
	},
	changeSingalMatchDetail: function changeSingalMatchDetail(state, payload) {
		state.matchDetail = payload;
	},
	changeSingalList: function changeSingalList(state, payload) {
		state.listData = payload;
	},
	changeSingalInitFunc: function changeSingalInitFunc(state, payload) {
		state.initSearch = payload;
	},
	changeSingalInitLikeFunc: function changeSingalInitLikeFunc(state, payload) {
		state.initLikeSearch = payload;
	},
	changeDrillListRefresh: function changeDrillListRefresh(state, payload) {
		state.drillListRefresh = payload;
	},
	changeDrillParentListRefresh: function changeDrillParentListRefresh(state, payload) {
		state.drillParentListRefresh = payload;
	},
	changeDrillActiveRefresh: function changeDrillActiveRefresh(state, payload) {
		state.drillActive = payload;
	},
	changeDrillParentActiveRefresh: function changeDrillParentActiveRefresh(state, payload) {
		state.drillParentActive = payload;
	},
	changeScrollGoodsId: function changeScrollGoodsId(state, payload) {
		state.scrollGoodsId = payload;
	},
	changeHistoryStore: function changeHistoryStore(state, payload) {
		state.historyStore = payload;
	},
	changeEditStoreIds: function changeEditStoreIds(state, payload) {
		state.editStoreIds = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		updateListFun: function updateListFun() {},
		updatePlanListFun: function updatePlanListFun() {},
		recordSrolllTop: 0,
		orderNewPlanSearch: {} },
	mutations: {
		setUpdateListFun: function setUpdateListFun(state, payload) {
			if (typeof payload !== 'function') {
				throw new Error('updateListFun mast be function');
			} else {
				state.updateListFun = payload;
			}
		},
		setUpdatePlanListFun: function setUpdatePlanListFun(state, payload) {
			if (typeof payload !== 'function') {
				throw new Error('updateListFun mast be function');
			} else {
				state.updatePlanListFun = payload;
			}
		},
		changeOrderNewPlanSearch: function changeOrderNewPlanSearch(state, payload) {
			state.orderNewPlanSearch = payload;
		},
		changeRecordSrolllTop: function changeRecordSrolllTop(state, payload) {
			state.recordSrolllTop = payload;
		}
	}
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	showMenu: true,
	refresh: function refresh() {
		setTimeout(function () {
			window.myScroll && window.myScroll.refresh();
		}, 200);
	}
};

var mutations = {
	toggleMenu: function toggleMenu() {
		state.showMenu = !state.showMenu;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_axiosSetting__ = __webpack_require__(154);

var state = {
	hasEdit: false
};
var mutations = {
	changeUserReturnStatus: function changeUserReturnStatus(state, n) {
		state.hasEdit = n;
	}
};
var actions = {
	changeUserReturnStatusAsync: function changeUserReturnStatusAsync(_ref) {
		var commit = _ref.commit;

		__WEBPACK_IMPORTED_MODULE_0__common_axiosSetting__["a" /* default */].AxiosIns({
			url: 'back_home/query.json'
		}).then(function (res) {
			var status = false;
			var endTime = res.meeting.end_time;
			var startTime = res.meeting.start_time;
			var now = Math.round(new Date().getTime() / 1000);
			if (!res.data && startTime < now && endTime > now) {
				status = true;
			}
			commit('changeUserReturnStatus', status);
		});
	}
};
/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			active: false,
			dbody: ''
		};
	},
	mounted: function mounted() {
		this.$bdDialog.add(this);
	},

	methods: {
		close: function close() {
			this.active = false;
		},
		init: function init(html) {
			this.dbody = html;
		}
	}
});

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: "BDToast",
	data: function data() {
		return {
			msg: ''
		};
	}
});

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'kxSelect',
	props: {
		'options': { required: true, type: Array },
		'multiple': { type: Boolean, default: false },
		'filter': { type: Boolean, default: false },
		'beautyName': { type: String },
		'name': { default: 'name', type: String },
		'valueName': { default: 'value', type: String },
		'change': { default: Function, type: Function },
		'isClear': { type: Boolean, default: false },
		value: {},
		maxHeight: { type: Number, default: 300 },
		placeholder: String,
		canCancel: { type: Boolean, default: true },
		defaultSelect: Boolean,
		disabled: Boolean,
		maxLimit: Number,

		isShowSelectAll: {
			type: Boolean,
			default: true
		},

		btnShow: {
			type: Boolean,
			default: true
		},

		showSelectBtn: {
			type: Boolean,
			default: true
		},

		showCancelBtn: {
			type: Boolean,
			default: true
		}

	},
	destroyed: function destroyed() {
		this.$kxSelect.remove(this);
	},
	mounted: function mounted() {
		this.$kxSelect.add(this);
		this.soptions = this.Helper.clone(this.options, true);
		this.defaultSelectDo();
	},
	data: function data() {
		return {
			isActive: false,
			soptions: [],
			id: 'kxSelect_beauty_ul_' + this._uid,
			filterKey: '',
			num: 1
		};
	},

	methods: {
		close: function close() {
			this.isActive = false;
			this.num += 1;
		},
		closeSelect: function closeSelect(e) {
			e && e.preventDefault();
			this.isActive = false;
		},
		toggle: function toggle(e) {
			var _this = this;

			e && e.preventDefault();
			this.isActive = !this.isActive;
			if (this.isActive) {
				this.filterKey = '';
				this.$nextTick(function () {
					_this.selectDomPosition();
					_this.defaultSelectDo();
				});
			} else {
				this.num += 1;
			}
		},
		selectDomPosition: function selectDomPosition() {
			var selectDom = document.getElementById(this.id);
			if (selectDom) {
				var _Helper$getOffset = this.Helper.getOffset(selectDom),
				    left = _Helper$getOffset.left;

				var leftMain = document.getElementById('leftMain');
				if (left + selectDom.offsetWidth > leftMain.offsetWidth) {
					selectDom.classList.add('right');
				} else {
					selectDom.classList.remove('right');
				}
			}
		},
		selHandle: function selHandle(option, index) {
			var _this2 = this;

			if (this.maxLimit > 0 && this.value.length >= this.maxLimit && !option.$isActive) {
				if (this.instanceToast) {
					this.instanceToast.close();
				}
				this.instanceToast = this.$toast('\u6700\u591A\u53EF\u9009' + this.maxLimit + '\u9879');
				return;
			}
			if (option.$isDisabled) {
				return;
			}
			this.setActive([index]);
			this.$emit('change');
			requestAnimationFrame(function () {
				_this2.selectDomPosition();
			});
		},
		filterHandle: function filterHandle() {
			var _this3 = this;

			this.soptions.map(function (item) {
				_this3.$set(item, '$isVisible', true);
				if (item.name.toString().includes(_this3.filterKey)) {
					_this3.$set(item, '$isVisible', false);
				}
			});
		},
		setActive: function setActive(sindexArr) {
			var notNeedChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (this.multiple) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sindexArr.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var index = _step.value;

						var i = sindexArr[index];
						this.$set(this.soptions[i], "$isActive", !this.soptions[i].$isActive);
						if (!this.soptions[i].$isActive) {
							this.$emit('removeTag');
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var _ref = _step2.value;

						var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

						var _i = _ref2[0];
						var v = _ref2[1];

						if (_i === sindexArr[0] && sindexArr.includes(_i) && this.soptions[sindexArr[0]][this.valueName] !== undefined) {
							this.$set(v, "$isActive", this.canCancel ? !v.$isActive : true);
						} else {
							this.$set(v, "$isActive", false);
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				this.toggle();
			}
			if (!notNeedChange) {
				this.$emit('input', this.soptions.filter(function (v) {
					return v.$isActive;
				}));
			}
		},
		selectAll: function selectAll() {
			var _this4 = this;

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _ref3 = _step3.value;

					var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

					var v = _ref4[1];

					if (!v.$isDisabled && !v.$isVisible) {
						this.$set(v, "$isActive", true);
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
			requestAnimationFrame(function () {
				_this4.selectDomPosition();
			});
		},
		cancelAll: function cancelAll() {
			var _this5 = this;

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _ref5 = _step4.value;

					var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

					var v = _ref6[1];

					this.$set(v, "$isActive", false);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
			requestAnimationFrame(function () {
				_this5.selectDomPosition();
			});
		},
		clearSel: function clearSel() {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var _ref7 = _step5.value;

					var _ref8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

					var v = _ref8[1];

					this.$set(v, "$isActive", false);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
		},
		defaultSelectDo: function defaultSelectDo() {
			var _this6 = this;

			if (this.defaultSelect && this.soptions[0]) {
				if (!Array.isArray(this.value)) {
					this.$set(this.soptions[0], '$isActive', true);
				} else {
					this.soptions.map(function (option) {
						if (Array.isArray(_this6.value)) {
							_this6.value.map(function (v) {
								if (v[_this6.valueName] === option[_this6.valueName]) {
									_this6.$set(option, '$isActive', true);
								}
							});
						}
					});
				}
				this.$emit('input', this.soptions.filter(function (v) {
					return v.$isActive;
				}));
				this.$emit('defaultSelectChange');
			}
			this.soptions.forEach(function (ele) {
				_this6.$set(ele, '$isVisible', false);
			});
		}
	},
	watch: {
		isActive: function isActive(newval) {
			if (newval) {
				this.$kxSelect.closeOthers(this);
			}
		},

		options: {
			immediate: true,
			handler: function handler() {
				this.soptions = this.Helper.clone(this.options, true);
				this.defaultSelectDo();
			}
		},
		selected: function selected() {},

		value: {
			immediate: true,
			handler: function handler() {
				var _this7 = this;

				this.soptions.map(function (option) {
					_this7.$set(option, '$isActive', false);
					if (Array.isArray(_this7.value)) {
						_this7.value.map(function (v) {
							if (v[_this7.valueName] === option[_this7.valueName]) {
								_this7.$set(option, '$isActive', true);
							}
						});
					} else {
						try {
							if (_this7.value[_this7.valueName] === option[_this7.valueName]) {
								_this7.$set(option, '$isActive', true);
							}
						} catch (e) {}
					}
				});
			}
		}
	},
	computed: {
		selected: function selected() {
			if (this.multiple) {
				var active = [];
				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;

				try {
					for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var _ref9 = _step6.value;

						var _ref10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

						var v = _ref10[1];

						if (v.$isActive) {
							active.push(v);
						}
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}

				return active;
			} else {
				var _active = null;
				var _iteratorNormalCompletion7 = true;
				var _didIteratorError7 = false;
				var _iteratorError7 = undefined;

				try {
					for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
						var _ref11 = _step7.value;

						var _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);

						var _v = _ref12[1];

						if (_v.$isActive) {
							_active = _v;
							break;
						}
					}
				} catch (err) {
					_didIteratorError7 = true;
					_iteratorError7 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion7 && _iterator7.return) {
							_iterator7.return();
						}
					} finally {
						if (_didIteratorError7) {
							throw _iteratorError7;
						}
					}
				}

				return _active;
			}
		},
		selectedName: function selectedName() {
			if (Array.isArray(this.selected)) {
				var name = [];
				var _iteratorNormalCompletion8 = true;
				var _didIteratorError8 = false;
				var _iteratorError8 = undefined;

				try {
					for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selected.entries()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
						var _ref13 = _step8.value;

						var _ref14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13, 2);

						var s = _ref14[1];

						name.push(s[this.name]);
					}
				} catch (err) {
					_didIteratorError8 = true;
					_iteratorError8 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion8 && _iterator8.return) {
							_iterator8.return();
						}
					} finally {
						if (_didIteratorError8) {
							throw _iteratorError8;
						}
					}
				}

				return name.join(',') || this.beautyName;
			} else {
				return this.selected ? this.selected[this.name] : this.beautyName;
			}
		},
		isEmpty: function isEmpty() {
			var visibleOptios = this.soptions.filter(function (item) {
				return !item.$isVisible;
			});
			return !this.soptions.length || !visibleOptios.length;
		}
	}
});

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popperjs_core__ = __webpack_require__(577);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'kxSelectPopper',
	props: {
		'options': { required: true, type: Array },
		'multiple': { type: Boolean, default: false },
		'beautyName': { type: String },
		'name': { default: 'name', type: String },
		'valueName': { default: 'value', type: String },
		'change': { default: Function, type: Function },
		'isClear': { type: Boolean, default: false },
		value: {},
		maxHeight: { type: Number, default: 300 },
		placeholder: String,
		canCancel: { type: Boolean, default: true },
		defaultSelect: Boolean,
		disabled: Boolean
	},
	destroyed: function destroyed() {
		if (this.popperInstance) {
			this.popperInstance.destroy();
		}
		this.$kxSelectPopper.remove(this);
	},
	mounted: function mounted() {
		this.$kxSelectPopper.add(this);
		this.soptions = this.Helper.clone(this.options, true);
		this.defaultSelectDo();
		this.popperInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__popperjs_core__["a" /* createPopper */])(this.$el.querySelector('.select-popper-btn'), this.$el.querySelector('.select-popper'), {
			placement: 'bottom-start',
			strategy: 'fixed'
		});
	},
	data: function data() {
		return {
			isActive: false,
			soptions: [],
			id: 'kxSelect_beauty_ul_' + this._uid,
			popperInstance: null
		};
	},

	methods: {
		close: function close() {
			this.isActive = false;
		},
		toggle: function toggle(e) {
			var _this = this;

			e && e.preventDefault();
			this.isActive = !this.isActive;
			if (this.isActive) {
				var selectDom = document.getElementById(this.id);
				this.$nextTick(function () {
					var _Helper$getOffset = _this.Helper.getOffset(selectDom),
					    left = _Helper$getOffset.left;

					var leftMain = document.getElementById('leftMain');
					if (left + selectDom.offsetWidth > leftMain.offsetWidth) {
						selectDom.classList.add('right');
					} else {
						selectDom.classList.remove('right');
					}
				});
			}
		},
		selHandle: function selHandle(option, index) {
			this.setActive([index]);
			this.$emit('change');
		},
		setActive: function setActive(sindexArr) {
			var notNeedChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (this.multiple) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sindexArr.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var index = _step.value;

						var i = sindexArr[index];
						this.$set(this.soptions[i], "$isActive", !this.soptions[i].$isActive);
						if (!this.soptions[i].$isActive) {
							this.$emit('removeTag');
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var _ref = _step2.value;

						var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

						var _i = _ref2[0];
						var v = _ref2[1];

						if (_i === sindexArr[0] && sindexArr.includes(_i) && this.soptions[sindexArr[0]][this.valueName] !== undefined) {
							this.$set(v, "$isActive", this.canCancel ? !v.$isActive : true);
						} else {
							this.$set(v, "$isActive", false);
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				this.toggle();
			}
			if (!notNeedChange) {
				this.$emit('input', this.soptions.filter(function (v) {
					return v.$isActive;
				}));
			}
		},
		selectAll: function selectAll() {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _ref3 = _step3.value;

					var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

					var v = _ref4[1];

					this.$set(v, "$isActive", true);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
		},
		cancelAll: function cancelAll() {
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _ref5 = _step4.value;

					var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

					var v = _ref6[1];

					this.$set(v, "$isActive", false);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
		},
		clearSel: function clearSel() {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var _ref7 = _step5.value;

					var _ref8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

					var v = _ref8[1];

					this.$set(v, "$isActive", false);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			this.$emit('input', this.soptions.filter(function (v) {
				return v.$isActive;
			}));
			this.$emit('change');
		},
		defaultSelectDo: function defaultSelectDo() {
			var _this2 = this;

			if (this.defaultSelect && this.soptions[0]) {
				if (!Array.isArray(this.value)) {
					this.$set(this.soptions[0], '$isActive', true);
				} else {
					this.soptions.map(function (option) {
						if (Array.isArray(_this2.value)) {
							_this2.value.map(function (v) {
								if (v[_this2.valueName] === option[_this2.valueName]) {
									_this2.$set(option, '$isActive', true);
								}
							});
						}
					});
				}
				this.$emit('input', this.soptions.filter(function (v) {
					return v.$isActive;
				}));
				this.$emit('defaultSelectChange');
			}
		}
	},
	watch: {
		isActive: function isActive(newval) {
			if (newval) {
				this.$kxSelectPopper.closeOthers(this);
			}
		},
		options: function options() {
			this.soptions = this.Helper.clone(this.options, true);
			this.defaultSelectDo();
		},
		selected: function selected() {},
		value: function value() {
			var _this3 = this;

			this.soptions.map(function (option) {
				_this3.$set(option, '$isActive', false);
				if (Array.isArray(_this3.value)) {
					_this3.value.map(function (v) {
						if (v[_this3.valueName] === option[_this3.valueName]) {
							_this3.$set(option, '$isActive', true);
						}
					});
				} else {
					try {
						if (_this3.value[_this3.valueName] === option[_this3.valueName]) {
							_this3.$set(option, '$isActive', true);
						}
					} catch (e) {}
				}
			});
		}
	},
	computed: {
		selected: function selected() {
			if (this.multiple) {
				var active = [];
				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;

				try {
					for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var _ref9 = _step6.value;

						var _ref10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

						var v = _ref10[1];

						if (v.$isActive) {
							active.push(v);
						}
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}

				return active;
			} else {
				var _active = null;
				var _iteratorNormalCompletion7 = true;
				var _didIteratorError7 = false;
				var _iteratorError7 = undefined;

				try {
					for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.soptions.entries()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
						var _ref11 = _step7.value;

						var _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);

						var _v = _ref12[1];

						if (_v.$isActive) {
							_active = _v;
							break;
						}
					}
				} catch (err) {
					_didIteratorError7 = true;
					_iteratorError7 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion7 && _iterator7.return) {
							_iterator7.return();
						}
					} finally {
						if (_didIteratorError7) {
							throw _iteratorError7;
						}
					}
				}

				return _active;
			}
		},
		selectedName: function selectedName() {
			if (Array.isArray(this.selected)) {
				var name = [];
				var _iteratorNormalCompletion8 = true;
				var _didIteratorError8 = false;
				var _iteratorError8 = undefined;

				try {
					for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selected.entries()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
						var _ref13 = _step8.value;

						var _ref14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13, 2);

						var s = _ref14[1];

						name.push(s[this.name]);
					}
				} catch (err) {
					_didIteratorError8 = true;
					_iteratorError8 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion8 && _iterator8.return) {
							_iterator8.return();
						}
					} finally {
						if (_didIteratorError8) {
							throw _iteratorError8;
						}
					}
				}

				return name.join(',') || this.beautyName;
			} else {
				return this.selected ? this.selected[this.name] : this.beautyName;
			}
		}
	}
});

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 909:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports = ["ac","com.ac","edu.ac","gov.ac","net.ac","mil.ac","org.ac","ad","nom.ad","ae","co.ae","net.ae","org.ae","sch.ae","ac.ae","gov.ae","mil.ae","aero","accident-investigation.aero","accident-prevention.aero","aerobatic.aero","aeroclub.aero","aerodrome.aero","agents.aero","aircraft.aero","airline.aero","airport.aero","air-surveillance.aero","airtraffic.aero","air-traffic-control.aero","ambulance.aero","amusement.aero","association.aero","author.aero","ballooning.aero","broker.aero","caa.aero","cargo.aero","catering.aero","certification.aero","championship.aero","charter.aero","civilaviation.aero","club.aero","conference.aero","consultant.aero","consulting.aero","control.aero","council.aero","crew.aero","design.aero","dgca.aero","educator.aero","emergency.aero","engine.aero","engineer.aero","entertainment.aero","equipment.aero","exchange.aero","express.aero","federation.aero","flight.aero","freight.aero","fuel.aero","gliding.aero","government.aero","groundhandling.aero","group.aero","hanggliding.aero","homebuilt.aero","insurance.aero","journal.aero","journalist.aero","leasing.aero","logistics.aero","magazine.aero","maintenance.aero","media.aero","microlight.aero","modelling.aero","navigation.aero","parachuting.aero","paragliding.aero","passenger-association.aero","pilot.aero","press.aero","production.aero","recreation.aero","repbody.aero","res.aero","research.aero","rotorcraft.aero","safety.aero","scientist.aero","services.aero","show.aero","skydiving.aero","software.aero","student.aero","trader.aero","trading.aero","trainer.aero","union.aero","workinggroup.aero","works.aero","af","gov.af","com.af","org.af","net.af","edu.af","ag","com.ag","org.ag","net.ag","co.ag","nom.ag","ai","off.ai","com.ai","net.ai","org.ai","al","com.al","edu.al","gov.al","mil.al","net.al","org.al","am","co.am","com.am","commune.am","net.am","org.am","ao","ed.ao","gv.ao","og.ao","co.ao","pb.ao","it.ao","aq","ar","com.ar","edu.ar","gob.ar","gov.ar","int.ar","mil.ar","musica.ar","net.ar","org.ar","tur.ar","arpa","e164.arpa","in-addr.arpa","ip6.arpa","iris.arpa","uri.arpa","urn.arpa","as","gov.as","asia","at","ac.at","co.at","gv.at","or.at","au","com.au","net.au","org.au","edu.au","gov.au","asn.au","id.au","info.au","conf.au","oz.au","act.au","nsw.au","nt.au","qld.au","sa.au","tas.au","vic.au","wa.au","act.edu.au","catholic.edu.au","nsw.edu.au","nt.edu.au","qld.edu.au","sa.edu.au","tas.edu.au","vic.edu.au","wa.edu.au","qld.gov.au","sa.gov.au","tas.gov.au","vic.gov.au","wa.gov.au","education.tas.edu.au","schools.nsw.edu.au","aw","com.aw","ax","az","com.az","net.az","int.az","gov.az","org.az","edu.az","info.az","pp.az","mil.az","name.az","pro.az","biz.az","ba","com.ba","edu.ba","gov.ba","mil.ba","net.ba","org.ba","bb","biz.bb","co.bb","com.bb","edu.bb","gov.bb","info.bb","net.bb","org.bb","store.bb","tv.bb","*.bd","be","ac.be","bf","gov.bf","bg","a.bg","b.bg","c.bg","d.bg","e.bg","f.bg","g.bg","h.bg","i.bg","j.bg","k.bg","l.bg","m.bg","n.bg","o.bg","p.bg","q.bg","r.bg","s.bg","t.bg","u.bg","v.bg","w.bg","x.bg","y.bg","z.bg","0.bg","1.bg","2.bg","3.bg","4.bg","5.bg","6.bg","7.bg","8.bg","9.bg","bh","com.bh","edu.bh","net.bh","org.bh","gov.bh","bi","co.bi","com.bi","edu.bi","or.bi","org.bi","biz","bj","asso.bj","barreau.bj","gouv.bj","bm","com.bm","edu.bm","gov.bm","net.bm","org.bm","bn","com.bn","edu.bn","gov.bn","net.bn","org.bn","bo","com.bo","edu.bo","gob.bo","int.bo","org.bo","net.bo","mil.bo","tv.bo","web.bo","academia.bo","agro.bo","arte.bo","blog.bo","bolivia.bo","ciencia.bo","cooperativa.bo","democracia.bo","deporte.bo","ecologia.bo","economia.bo","empresa.bo","indigena.bo","industria.bo","info.bo","medicina.bo","movimiento.bo","musica.bo","natural.bo","nombre.bo","noticias.bo","patria.bo","politica.bo","profesional.bo","plurinacional.bo","pueblo.bo","revista.bo","salud.bo","tecnologia.bo","tksat.bo","transporte.bo","wiki.bo","br","9guacu.br","abc.br","adm.br","adv.br","agr.br","aju.br","am.br","anani.br","aparecida.br","arq.br","art.br","ato.br","b.br","barueri.br","belem.br","bhz.br","bio.br","blog.br","bmd.br","boavista.br","bsb.br","campinagrande.br","campinas.br","caxias.br","cim.br","cng.br","cnt.br","com.br","contagem.br","coop.br","cri.br","cuiaba.br","curitiba.br","def.br","ecn.br","eco.br","edu.br","emp.br","eng.br","esp.br","etc.br","eti.br","far.br","feira.br","flog.br","floripa.br","fm.br","fnd.br","fortal.br","fot.br","foz.br","fst.br","g12.br","ggf.br","goiania.br","gov.br","ac.gov.br","al.gov.br","am.gov.br","ap.gov.br","ba.gov.br","ce.gov.br","df.gov.br","es.gov.br","go.gov.br","ma.gov.br","mg.gov.br","ms.gov.br","mt.gov.br","pa.gov.br","pb.gov.br","pe.gov.br","pi.gov.br","pr.gov.br","rj.gov.br","rn.gov.br","ro.gov.br","rr.gov.br","rs.gov.br","sc.gov.br","se.gov.br","sp.gov.br","to.gov.br","gru.br","imb.br","ind.br","inf.br","jab.br","jampa.br","jdf.br","joinville.br","jor.br","jus.br","leg.br","lel.br","londrina.br","macapa.br","maceio.br","manaus.br","maringa.br","mat.br","med.br","mil.br","morena.br","mp.br","mus.br","natal.br","net.br","niteroi.br","*.nom.br","not.br","ntr.br","odo.br","ong.br","org.br","osasco.br","palmas.br","poa.br","ppg.br","pro.br","psc.br","psi.br","pvh.br","qsl.br","radio.br","rec.br","recife.br","ribeirao.br","rio.br","riobranco.br","riopreto.br","salvador.br","sampa.br","santamaria.br","santoandre.br","saobernardo.br","saogonca.br","sjc.br","slg.br","slz.br","sorocaba.br","srv.br","taxi.br","tc.br","teo.br","the.br","tmp.br","trd.br","tur.br","tv.br","udi.br","vet.br","vix.br","vlog.br","wiki.br","zlg.br","bs","com.bs","net.bs","org.bs","edu.bs","gov.bs","bt","com.bt","edu.bt","gov.bt","net.bt","org.bt","bv","bw","co.bw","org.bw","by","gov.by","mil.by","com.by","of.by","bz","com.bz","net.bz","org.bz","edu.bz","gov.bz","ca","ab.ca","bc.ca","mb.ca","nb.ca","nf.ca","nl.ca","ns.ca","nt.ca","nu.ca","on.ca","pe.ca","qc.ca","sk.ca","yk.ca","gc.ca","cat","cc","cd","gov.cd","cf","cg","ch","ci","org.ci","or.ci","com.ci","co.ci","edu.ci","ed.ci","ac.ci","net.ci","go.ci","asso.ci","aéroport.ci","int.ci","presse.ci","md.ci","gouv.ci","*.ck","!www.ck","cl","aprendemas.cl","co.cl","gob.cl","gov.cl","mil.cl","cm","co.cm","com.cm","gov.cm","net.cm","cn","ac.cn","com.cn","edu.cn","gov.cn","net.cn","org.cn","mil.cn","公司.cn","网络.cn","網絡.cn","ah.cn","bj.cn","cq.cn","fj.cn","gd.cn","gs.cn","gz.cn","gx.cn","ha.cn","hb.cn","he.cn","hi.cn","hl.cn","hn.cn","jl.cn","js.cn","jx.cn","ln.cn","nm.cn","nx.cn","qh.cn","sc.cn","sd.cn","sh.cn","sn.cn","sx.cn","tj.cn","xj.cn","xz.cn","yn.cn","zj.cn","hk.cn","mo.cn","tw.cn","co","arts.co","com.co","edu.co","firm.co","gov.co","info.co","int.co","mil.co","net.co","nom.co","org.co","rec.co","web.co","com","coop","cr","ac.cr","co.cr","ed.cr","fi.cr","go.cr","or.cr","sa.cr","cu","com.cu","edu.cu","org.cu","net.cu","gov.cu","inf.cu","cv","cw","com.cw","edu.cw","net.cw","org.cw","cx","gov.cx","cy","ac.cy","biz.cy","com.cy","ekloges.cy","gov.cy","ltd.cy","name.cy","net.cy","org.cy","parliament.cy","press.cy","pro.cy","tm.cy","cz","de","dj","dk","dm","com.dm","net.dm","org.dm","edu.dm","gov.dm","do","art.do","com.do","edu.do","gob.do","gov.do","mil.do","net.do","org.do","sld.do","web.do","dz","com.dz","org.dz","net.dz","gov.dz","edu.dz","asso.dz","pol.dz","art.dz","ec","com.ec","info.ec","net.ec","fin.ec","k12.ec","med.ec","pro.ec","org.ec","edu.ec","gov.ec","gob.ec","mil.ec","edu","ee","edu.ee","gov.ee","riik.ee","lib.ee","med.ee","com.ee","pri.ee","aip.ee","org.ee","fie.ee","eg","com.eg","edu.eg","eun.eg","gov.eg","mil.eg","name.eg","net.eg","org.eg","sci.eg","*.er","es","com.es","nom.es","org.es","gob.es","edu.es","et","com.et","gov.et","org.et","edu.et","biz.et","name.et","info.et","net.et","eu","fi","aland.fi","fj","ac.fj","biz.fj","com.fj","gov.fj","info.fj","mil.fj","name.fj","net.fj","org.fj","pro.fj","*.fk","fm","fo","fr","asso.fr","com.fr","gouv.fr","nom.fr","prd.fr","tm.fr","aeroport.fr","avocat.fr","avoues.fr","cci.fr","chambagri.fr","chirurgiens-dentistes.fr","experts-comptables.fr","geometre-expert.fr","greta.fr","huissier-justice.fr","medecin.fr","notaires.fr","pharmacien.fr","port.fr","veterinaire.fr","ga","gb","gd","ge","com.ge","edu.ge","gov.ge","org.ge","mil.ge","net.ge","pvt.ge","gf","gg","co.gg","net.gg","org.gg","gh","com.gh","edu.gh","gov.gh","org.gh","mil.gh","gi","com.gi","ltd.gi","gov.gi","mod.gi","edu.gi","org.gi","gl","co.gl","com.gl","edu.gl","net.gl","org.gl","gm","gn","ac.gn","com.gn","edu.gn","gov.gn","org.gn","net.gn","gov","gp","com.gp","net.gp","mobi.gp","edu.gp","org.gp","asso.gp","gq","gr","com.gr","edu.gr","net.gr","org.gr","gov.gr","gs","gt","com.gt","edu.gt","gob.gt","ind.gt","mil.gt","net.gt","org.gt","gu","com.gu","edu.gu","gov.gu","guam.gu","info.gu","net.gu","org.gu","web.gu","gw","gy","co.gy","com.gy","edu.gy","gov.gy","net.gy","org.gy","hk","com.hk","edu.hk","gov.hk","idv.hk","net.hk","org.hk","公司.hk","教育.hk","敎育.hk","政府.hk","個人.hk","个人.hk","箇人.hk","網络.hk","网络.hk","组織.hk","網絡.hk","网絡.hk","组织.hk","組織.hk","組织.hk","hm","hn","com.hn","edu.hn","org.hn","net.hn","mil.hn","gob.hn","hr","iz.hr","from.hr","name.hr","com.hr","ht","com.ht","shop.ht","firm.ht","info.ht","adult.ht","net.ht","pro.ht","org.ht","med.ht","art.ht","coop.ht","pol.ht","asso.ht","edu.ht","rel.ht","gouv.ht","perso.ht","hu","co.hu","info.hu","org.hu","priv.hu","sport.hu","tm.hu","2000.hu","agrar.hu","bolt.hu","casino.hu","city.hu","erotica.hu","erotika.hu","film.hu","forum.hu","games.hu","hotel.hu","ingatlan.hu","jogasz.hu","konyvelo.hu","lakas.hu","media.hu","news.hu","reklam.hu","sex.hu","shop.hu","suli.hu","szex.hu","tozsde.hu","utazas.hu","video.hu","id","ac.id","biz.id","co.id","desa.id","go.id","mil.id","my.id","net.id","or.id","ponpes.id","sch.id","web.id","ie","gov.ie","il","ac.il","co.il","gov.il","idf.il","k12.il","muni.il","net.il","org.il","im","ac.im","co.im","com.im","ltd.co.im","net.im","org.im","plc.co.im","tt.im","tv.im","in","co.in","firm.in","net.in","org.in","gen.in","ind.in","nic.in","ac.in","edu.in","res.in","gov.in","mil.in","info","int","eu.int","io","com.io","iq","gov.iq","edu.iq","mil.iq","com.iq","org.iq","net.iq","ir","ac.ir","co.ir","gov.ir","id.ir","net.ir","org.ir","sch.ir","ایران.ir","ايران.ir","is","net.is","com.is","edu.is","gov.is","org.is","int.is","it","gov.it","edu.it","abr.it","abruzzo.it","aosta-valley.it","aostavalley.it","bas.it","basilicata.it","cal.it","calabria.it","cam.it","campania.it","emilia-romagna.it","emiliaromagna.it","emr.it","friuli-v-giulia.it","friuli-ve-giulia.it","friuli-vegiulia.it","friuli-venezia-giulia.it","friuli-veneziagiulia.it","friuli-vgiulia.it","friuliv-giulia.it","friulive-giulia.it","friulivegiulia.it","friulivenezia-giulia.it","friuliveneziagiulia.it","friulivgiulia.it","fvg.it","laz.it","lazio.it","lig.it","liguria.it","lom.it","lombardia.it","lombardy.it","lucania.it","mar.it","marche.it","mol.it","molise.it","piedmont.it","piemonte.it","pmn.it","pug.it","puglia.it","sar.it","sardegna.it","sardinia.it","sic.it","sicilia.it","sicily.it","taa.it","tos.it","toscana.it","trentin-sud-tirol.it","trentin-süd-tirol.it","trentin-sudtirol.it","trentin-südtirol.it","trentin-sued-tirol.it","trentin-suedtirol.it","trentino-a-adige.it","trentino-aadige.it","trentino-alto-adige.it","trentino-altoadige.it","trentino-s-tirol.it","trentino-stirol.it","trentino-sud-tirol.it","trentino-süd-tirol.it","trentino-sudtirol.it","trentino-südtirol.it","trentino-sued-tirol.it","trentino-suedtirol.it","trentino.it","trentinoa-adige.it","trentinoaadige.it","trentinoalto-adige.it","trentinoaltoadige.it","trentinos-tirol.it","trentinostirol.it","trentinosud-tirol.it","trentinosüd-tirol.it","trentinosudtirol.it","trentinosüdtirol.it","trentinosued-tirol.it","trentinosuedtirol.it","trentinsud-tirol.it","trentinsüd-tirol.it","trentinsudtirol.it","trentinsüdtirol.it","trentinsued-tirol.it","trentinsuedtirol.it","tuscany.it","umb.it","umbria.it","val-d-aosta.it","val-daosta.it","vald-aosta.it","valdaosta.it","valle-aosta.it","valle-d-aosta.it","valle-daosta.it","valleaosta.it","valled-aosta.it","valledaosta.it","vallee-aoste.it","vallée-aoste.it","vallee-d-aoste.it","vallée-d-aoste.it","valleeaoste.it","valléeaoste.it","valleedaoste.it","valléedaoste.it","vao.it","vda.it","ven.it","veneto.it","ag.it","agrigento.it","al.it","alessandria.it","alto-adige.it","altoadige.it","an.it","ancona.it","andria-barletta-trani.it","andria-trani-barletta.it","andriabarlettatrani.it","andriatranibarletta.it","ao.it","aosta.it","aoste.it","ap.it","aq.it","aquila.it","ar.it","arezzo.it","ascoli-piceno.it","ascolipiceno.it","asti.it","at.it","av.it","avellino.it","ba.it","balsan-sudtirol.it","balsan-südtirol.it","balsan-suedtirol.it","balsan.it","bari.it","barletta-trani-andria.it","barlettatraniandria.it","belluno.it","benevento.it","bergamo.it","bg.it","bi.it","biella.it","bl.it","bn.it","bo.it","bologna.it","bolzano-altoadige.it","bolzano.it","bozen-sudtirol.it","bozen-südtirol.it","bozen-suedtirol.it","bozen.it","br.it","brescia.it","brindisi.it","bs.it","bt.it","bulsan-sudtirol.it","bulsan-südtirol.it","bulsan-suedtirol.it","bulsan.it","bz.it","ca.it","cagliari.it","caltanissetta.it","campidano-medio.it","campidanomedio.it","campobasso.it","carbonia-iglesias.it","carboniaiglesias.it","carrara-massa.it","carraramassa.it","caserta.it","catania.it","catanzaro.it","cb.it","ce.it","cesena-forli.it","cesena-forlì.it","cesenaforli.it","cesenaforlì.it","ch.it","chieti.it","ci.it","cl.it","cn.it","co.it","como.it","cosenza.it","cr.it","cremona.it","crotone.it","cs.it","ct.it","cuneo.it","cz.it","dell-ogliastra.it","dellogliastra.it","en.it","enna.it","fc.it","fe.it","fermo.it","ferrara.it","fg.it","fi.it","firenze.it","florence.it","fm.it","foggia.it","forli-cesena.it","forlì-cesena.it","forlicesena.it","forlìcesena.it","fr.it","frosinone.it","ge.it","genoa.it","genova.it","go.it","gorizia.it","gr.it","grosseto.it","iglesias-carbonia.it","iglesiascarbonia.it","im.it","imperia.it","is.it","isernia.it","kr.it","la-spezia.it","laquila.it","laspezia.it","latina.it","lc.it","le.it","lecce.it","lecco.it","li.it","livorno.it","lo.it","lodi.it","lt.it","lu.it","lucca.it","macerata.it","mantova.it","massa-carrara.it","massacarrara.it","matera.it","mb.it","mc.it","me.it","medio-campidano.it","mediocampidano.it","messina.it","mi.it","milan.it","milano.it","mn.it","mo.it","modena.it","monza-brianza.it","monza-e-della-brianza.it","monza.it","monzabrianza.it","monzaebrianza.it","monzaedellabrianza.it","ms.it","mt.it","na.it","naples.it","napoli.it","no.it","novara.it","nu.it","nuoro.it","og.it","ogliastra.it","olbia-tempio.it","olbiatempio.it","or.it","oristano.it","ot.it","pa.it","padova.it","padua.it","palermo.it","parma.it","pavia.it","pc.it","pd.it","pe.it","perugia.it","pesaro-urbino.it","pesarourbino.it","pescara.it","pg.it","pi.it","piacenza.it","pisa.it","pistoia.it","pn.it","po.it","pordenone.it","potenza.it","pr.it","prato.it","pt.it","pu.it","pv.it","pz.it","ra.it","ragusa.it","ravenna.it","rc.it","re.it","reggio-calabria.it","reggio-emilia.it","reggiocalabria.it","reggioemilia.it","rg.it","ri.it","rieti.it","rimini.it","rm.it","rn.it","ro.it","roma.it","rome.it","rovigo.it","sa.it","salerno.it","sassari.it","savona.it","si.it","siena.it","siracusa.it","so.it","sondrio.it","sp.it","sr.it","ss.it","suedtirol.it","südtirol.it","sv.it","ta.it","taranto.it","te.it","tempio-olbia.it","tempioolbia.it","teramo.it","terni.it","tn.it","to.it","torino.it","tp.it","tr.it","trani-andria-barletta.it","trani-barletta-andria.it","traniandriabarletta.it","tranibarlettaandria.it","trapani.it","trento.it","treviso.it","trieste.it","ts.it","turin.it","tv.it","ud.it","udine.it","urbino-pesaro.it","urbinopesaro.it","va.it","varese.it","vb.it","vc.it","ve.it","venezia.it","venice.it","verbania.it","vercelli.it","verona.it","vi.it","vibo-valentia.it","vibovalentia.it","vicenza.it","viterbo.it","vr.it","vs.it","vt.it","vv.it","je","co.je","net.je","org.je","*.jm","jo","com.jo","org.jo","net.jo","edu.jo","sch.jo","gov.jo","mil.jo","name.jo","jobs","jp","ac.jp","ad.jp","co.jp","ed.jp","go.jp","gr.jp","lg.jp","ne.jp","or.jp","aichi.jp","akita.jp","aomori.jp","chiba.jp","ehime.jp","fukui.jp","fukuoka.jp","fukushima.jp","gifu.jp","gunma.jp","hiroshima.jp","hokkaido.jp","hyogo.jp","ibaraki.jp","ishikawa.jp","iwate.jp","kagawa.jp","kagoshima.jp","kanagawa.jp","kochi.jp","kumamoto.jp","kyoto.jp","mie.jp","miyagi.jp","miyazaki.jp","nagano.jp","nagasaki.jp","nara.jp","niigata.jp","oita.jp","okayama.jp","okinawa.jp","osaka.jp","saga.jp","saitama.jp","shiga.jp","shimane.jp","shizuoka.jp","tochigi.jp","tokushima.jp","tokyo.jp","tottori.jp","toyama.jp","wakayama.jp","yamagata.jp","yamaguchi.jp","yamanashi.jp","栃木.jp","愛知.jp","愛媛.jp","兵庫.jp","熊本.jp","茨城.jp","北海道.jp","千葉.jp","和歌山.jp","長崎.jp","長野.jp","新潟.jp","青森.jp","静岡.jp","東京.jp","石川.jp","埼玉.jp","三重.jp","京都.jp","佐賀.jp","大分.jp","大阪.jp","奈良.jp","宮城.jp","宮崎.jp","富山.jp","山口.jp","山形.jp","山梨.jp","岩手.jp","岐阜.jp","岡山.jp","島根.jp","広島.jp","徳島.jp","沖縄.jp","滋賀.jp","神奈川.jp","福井.jp","福岡.jp","福島.jp","秋田.jp","群馬.jp","香川.jp","高知.jp","鳥取.jp","鹿児島.jp","*.kawasaki.jp","*.kitakyushu.jp","*.kobe.jp","*.nagoya.jp","*.sapporo.jp","*.sendai.jp","*.yokohama.jp","!city.kawasaki.jp","!city.kitakyushu.jp","!city.kobe.jp","!city.nagoya.jp","!city.sapporo.jp","!city.sendai.jp","!city.yokohama.jp","aisai.aichi.jp","ama.aichi.jp","anjo.aichi.jp","asuke.aichi.jp","chiryu.aichi.jp","chita.aichi.jp","fuso.aichi.jp","gamagori.aichi.jp","handa.aichi.jp","hazu.aichi.jp","hekinan.aichi.jp","higashiura.aichi.jp","ichinomiya.aichi.jp","inazawa.aichi.jp","inuyama.aichi.jp","isshiki.aichi.jp","iwakura.aichi.jp","kanie.aichi.jp","kariya.aichi.jp","kasugai.aichi.jp","kira.aichi.jp","kiyosu.aichi.jp","komaki.aichi.jp","konan.aichi.jp","kota.aichi.jp","mihama.aichi.jp","miyoshi.aichi.jp","nishio.aichi.jp","nisshin.aichi.jp","obu.aichi.jp","oguchi.aichi.jp","oharu.aichi.jp","okazaki.aichi.jp","owariasahi.aichi.jp","seto.aichi.jp","shikatsu.aichi.jp","shinshiro.aichi.jp","shitara.aichi.jp","tahara.aichi.jp","takahama.aichi.jp","tobishima.aichi.jp","toei.aichi.jp","togo.aichi.jp","tokai.aichi.jp","tokoname.aichi.jp","toyoake.aichi.jp","toyohashi.aichi.jp","toyokawa.aichi.jp","toyone.aichi.jp","toyota.aichi.jp","tsushima.aichi.jp","yatomi.aichi.jp","akita.akita.jp","daisen.akita.jp","fujisato.akita.jp","gojome.akita.jp","hachirogata.akita.jp","happou.akita.jp","higashinaruse.akita.jp","honjo.akita.jp","honjyo.akita.jp","ikawa.akita.jp","kamikoani.akita.jp","kamioka.akita.jp","katagami.akita.jp","kazuno.akita.jp","kitaakita.akita.jp","kosaka.akita.jp","kyowa.akita.jp","misato.akita.jp","mitane.akita.jp","moriyoshi.akita.jp","nikaho.akita.jp","noshiro.akita.jp","odate.akita.jp","oga.akita.jp","ogata.akita.jp","semboku.akita.jp","yokote.akita.jp","yurihonjo.akita.jp","aomori.aomori.jp","gonohe.aomori.jp","hachinohe.aomori.jp","hashikami.aomori.jp","hiranai.aomori.jp","hirosaki.aomori.jp","itayanagi.aomori.jp","kuroishi.aomori.jp","misawa.aomori.jp","mutsu.aomori.jp","nakadomari.aomori.jp","noheji.aomori.jp","oirase.aomori.jp","owani.aomori.jp","rokunohe.aomori.jp","sannohe.aomori.jp","shichinohe.aomori.jp","shingo.aomori.jp","takko.aomori.jp","towada.aomori.jp","tsugaru.aomori.jp","tsuruta.aomori.jp","abiko.chiba.jp","asahi.chiba.jp","chonan.chiba.jp","chosei.chiba.jp","choshi.chiba.jp","chuo.chiba.jp","funabashi.chiba.jp","futtsu.chiba.jp","hanamigawa.chiba.jp","ichihara.chiba.jp","ichikawa.chiba.jp","ichinomiya.chiba.jp","inzai.chiba.jp","isumi.chiba.jp","kamagaya.chiba.jp","kamogawa.chiba.jp","kashiwa.chiba.jp","katori.chiba.jp","katsuura.chiba.jp","kimitsu.chiba.jp","kisarazu.chiba.jp","kozaki.chiba.jp","kujukuri.chiba.jp","kyonan.chiba.jp","matsudo.chiba.jp","midori.chiba.jp","mihama.chiba.jp","minamiboso.chiba.jp","mobara.chiba.jp","mutsuzawa.chiba.jp","nagara.chiba.jp","nagareyama.chiba.jp","narashino.chiba.jp","narita.chiba.jp","noda.chiba.jp","oamishirasato.chiba.jp","omigawa.chiba.jp","onjuku.chiba.jp","otaki.chiba.jp","sakae.chiba.jp","sakura.chiba.jp","shimofusa.chiba.jp","shirako.chiba.jp","shiroi.chiba.jp","shisui.chiba.jp","sodegaura.chiba.jp","sosa.chiba.jp","tako.chiba.jp","tateyama.chiba.jp","togane.chiba.jp","tohnosho.chiba.jp","tomisato.chiba.jp","urayasu.chiba.jp","yachimata.chiba.jp","yachiyo.chiba.jp","yokaichiba.chiba.jp","yokoshibahikari.chiba.jp","yotsukaido.chiba.jp","ainan.ehime.jp","honai.ehime.jp","ikata.ehime.jp","imabari.ehime.jp","iyo.ehime.jp","kamijima.ehime.jp","kihoku.ehime.jp","kumakogen.ehime.jp","masaki.ehime.jp","matsuno.ehime.jp","matsuyama.ehime.jp","namikata.ehime.jp","niihama.ehime.jp","ozu.ehime.jp","saijo.ehime.jp","seiyo.ehime.jp","shikokuchuo.ehime.jp","tobe.ehime.jp","toon.ehime.jp","uchiko.ehime.jp","uwajima.ehime.jp","yawatahama.ehime.jp","echizen.fukui.jp","eiheiji.fukui.jp","fukui.fukui.jp","ikeda.fukui.jp","katsuyama.fukui.jp","mihama.fukui.jp","minamiechizen.fukui.jp","obama.fukui.jp","ohi.fukui.jp","ono.fukui.jp","sabae.fukui.jp","sakai.fukui.jp","takahama.fukui.jp","tsuruga.fukui.jp","wakasa.fukui.jp","ashiya.fukuoka.jp","buzen.fukuoka.jp","chikugo.fukuoka.jp","chikuho.fukuoka.jp","chikujo.fukuoka.jp","chikushino.fukuoka.jp","chikuzen.fukuoka.jp","chuo.fukuoka.jp","dazaifu.fukuoka.jp","fukuchi.fukuoka.jp","hakata.fukuoka.jp","higashi.fukuoka.jp","hirokawa.fukuoka.jp","hisayama.fukuoka.jp","iizuka.fukuoka.jp","inatsuki.fukuoka.jp","kaho.fukuoka.jp","kasuga.fukuoka.jp","kasuya.fukuoka.jp","kawara.fukuoka.jp","keisen.fukuoka.jp","koga.fukuoka.jp","kurate.fukuoka.jp","kurogi.fukuoka.jp","kurume.fukuoka.jp","minami.fukuoka.jp","miyako.fukuoka.jp","miyama.fukuoka.jp","miyawaka.fukuoka.jp","mizumaki.fukuoka.jp","munakata.fukuoka.jp","nakagawa.fukuoka.jp","nakama.fukuoka.jp","nishi.fukuoka.jp","nogata.fukuoka.jp","ogori.fukuoka.jp","okagaki.fukuoka.jp","okawa.fukuoka.jp","oki.fukuoka.jp","omuta.fukuoka.jp","onga.fukuoka.jp","onojo.fukuoka.jp","oto.fukuoka.jp","saigawa.fukuoka.jp","sasaguri.fukuoka.jp","shingu.fukuoka.jp","shinyoshitomi.fukuoka.jp","shonai.fukuoka.jp","soeda.fukuoka.jp","sue.fukuoka.jp","tachiarai.fukuoka.jp","tagawa.fukuoka.jp","takata.fukuoka.jp","toho.fukuoka.jp","toyotsu.fukuoka.jp","tsuiki.fukuoka.jp","ukiha.fukuoka.jp","umi.fukuoka.jp","usui.fukuoka.jp","yamada.fukuoka.jp","yame.fukuoka.jp","yanagawa.fukuoka.jp","yukuhashi.fukuoka.jp","aizubange.fukushima.jp","aizumisato.fukushima.jp","aizuwakamatsu.fukushima.jp","asakawa.fukushima.jp","bandai.fukushima.jp","date.fukushima.jp","fukushima.fukushima.jp","furudono.fukushima.jp","futaba.fukushima.jp","hanawa.fukushima.jp","higashi.fukushima.jp","hirata.fukushima.jp","hirono.fukushima.jp","iitate.fukushima.jp","inawashiro.fukushima.jp","ishikawa.fukushima.jp","iwaki.fukushima.jp","izumizaki.fukushima.jp","kagamiishi.fukushima.jp","kaneyama.fukushima.jp","kawamata.fukushima.jp","kitakata.fukushima.jp","kitashiobara.fukushima.jp","koori.fukushima.jp","koriyama.fukushima.jp","kunimi.fukushima.jp","miharu.fukushima.jp","mishima.fukushima.jp","namie.fukushima.jp","nango.fukushima.jp","nishiaizu.fukushima.jp","nishigo.fukushima.jp","okuma.fukushima.jp","omotego.fukushima.jp","ono.fukushima.jp","otama.fukushima.jp","samegawa.fukushima.jp","shimogo.fukushima.jp","shirakawa.fukushima.jp","showa.fukushima.jp","soma.fukushima.jp","sukagawa.fukushima.jp","taishin.fukushima.jp","tamakawa.fukushima.jp","tanagura.fukushima.jp","tenei.fukushima.jp","yabuki.fukushima.jp","yamato.fukushima.jp","yamatsuri.fukushima.jp","yanaizu.fukushima.jp","yugawa.fukushima.jp","anpachi.gifu.jp","ena.gifu.jp","gifu.gifu.jp","ginan.gifu.jp","godo.gifu.jp","gujo.gifu.jp","hashima.gifu.jp","hichiso.gifu.jp","hida.gifu.jp","higashishirakawa.gifu.jp","ibigawa.gifu.jp","ikeda.gifu.jp","kakamigahara.gifu.jp","kani.gifu.jp","kasahara.gifu.jp","kasamatsu.gifu.jp","kawaue.gifu.jp","kitagata.gifu.jp","mino.gifu.jp","minokamo.gifu.jp","mitake.gifu.jp","mizunami.gifu.jp","motosu.gifu.jp","nakatsugawa.gifu.jp","ogaki.gifu.jp","sakahogi.gifu.jp","seki.gifu.jp","sekigahara.gifu.jp","shirakawa.gifu.jp","tajimi.gifu.jp","takayama.gifu.jp","tarui.gifu.jp","toki.gifu.jp","tomika.gifu.jp","wanouchi.gifu.jp","yamagata.gifu.jp","yaotsu.gifu.jp","yoro.gifu.jp","annaka.gunma.jp","chiyoda.gunma.jp","fujioka.gunma.jp","higashiagatsuma.gunma.jp","isesaki.gunma.jp","itakura.gunma.jp","kanna.gunma.jp","kanra.gunma.jp","katashina.gunma.jp","kawaba.gunma.jp","kiryu.gunma.jp","kusatsu.gunma.jp","maebashi.gunma.jp","meiwa.gunma.jp","midori.gunma.jp","minakami.gunma.jp","naganohara.gunma.jp","nakanojo.gunma.jp","nanmoku.gunma.jp","numata.gunma.jp","oizumi.gunma.jp","ora.gunma.jp","ota.gunma.jp","shibukawa.gunma.jp","shimonita.gunma.jp","shinto.gunma.jp","showa.gunma.jp","takasaki.gunma.jp","takayama.gunma.jp","tamamura.gunma.jp","tatebayashi.gunma.jp","tomioka.gunma.jp","tsukiyono.gunma.jp","tsumagoi.gunma.jp","ueno.gunma.jp","yoshioka.gunma.jp","asaminami.hiroshima.jp","daiwa.hiroshima.jp","etajima.hiroshima.jp","fuchu.hiroshima.jp","fukuyama.hiroshima.jp","hatsukaichi.hiroshima.jp","higashihiroshima.hiroshima.jp","hongo.hiroshima.jp","jinsekikogen.hiroshima.jp","kaita.hiroshima.jp","kui.hiroshima.jp","kumano.hiroshima.jp","kure.hiroshima.jp","mihara.hiroshima.jp","miyoshi.hiroshima.jp","naka.hiroshima.jp","onomichi.hiroshima.jp","osakikamijima.hiroshima.jp","otake.hiroshima.jp","saka.hiroshima.jp","sera.hiroshima.jp","seranishi.hiroshima.jp","shinichi.hiroshima.jp","shobara.hiroshima.jp","takehara.hiroshima.jp","abashiri.hokkaido.jp","abira.hokkaido.jp","aibetsu.hokkaido.jp","akabira.hokkaido.jp","akkeshi.hokkaido.jp","asahikawa.hokkaido.jp","ashibetsu.hokkaido.jp","ashoro.hokkaido.jp","assabu.hokkaido.jp","atsuma.hokkaido.jp","bibai.hokkaido.jp","biei.hokkaido.jp","bifuka.hokkaido.jp","bihoro.hokkaido.jp","biratori.hokkaido.jp","chippubetsu.hokkaido.jp","chitose.hokkaido.jp","date.hokkaido.jp","ebetsu.hokkaido.jp","embetsu.hokkaido.jp","eniwa.hokkaido.jp","erimo.hokkaido.jp","esan.hokkaido.jp","esashi.hokkaido.jp","fukagawa.hokkaido.jp","fukushima.hokkaido.jp","furano.hokkaido.jp","furubira.hokkaido.jp","haboro.hokkaido.jp","hakodate.hokkaido.jp","hamatonbetsu.hokkaido.jp","hidaka.hokkaido.jp","higashikagura.hokkaido.jp","higashikawa.hokkaido.jp","hiroo.hokkaido.jp","hokuryu.hokkaido.jp","hokuto.hokkaido.jp","honbetsu.hokkaido.jp","horokanai.hokkaido.jp","horonobe.hokkaido.jp","ikeda.hokkaido.jp","imakane.hokkaido.jp","ishikari.hokkaido.jp","iwamizawa.hokkaido.jp","iwanai.hokkaido.jp","kamifurano.hokkaido.jp","kamikawa.hokkaido.jp","kamishihoro.hokkaido.jp","kamisunagawa.hokkaido.jp","kamoenai.hokkaido.jp","kayabe.hokkaido.jp","kembuchi.hokkaido.jp","kikonai.hokkaido.jp","kimobetsu.hokkaido.jp","kitahiroshima.hokkaido.jp","kitami.hokkaido.jp","kiyosato.hokkaido.jp","koshimizu.hokkaido.jp","kunneppu.hokkaido.jp","kuriyama.hokkaido.jp","kuromatsunai.hokkaido.jp","kushiro.hokkaido.jp","kutchan.hokkaido.jp","kyowa.hokkaido.jp","mashike.hokkaido.jp","matsumae.hokkaido.jp","mikasa.hokkaido.jp","minamifurano.hokkaido.jp","mombetsu.hokkaido.jp","moseushi.hokkaido.jp","mukawa.hokkaido.jp","muroran.hokkaido.jp","naie.hokkaido.jp","nakagawa.hokkaido.jp","nakasatsunai.hokkaido.jp","nakatombetsu.hokkaido.jp","nanae.hokkaido.jp","nanporo.hokkaido.jp","nayoro.hokkaido.jp","nemuro.hokkaido.jp","niikappu.hokkaido.jp","niki.hokkaido.jp","nishiokoppe.hokkaido.jp","noboribetsu.hokkaido.jp","numata.hokkaido.jp","obihiro.hokkaido.jp","obira.hokkaido.jp","oketo.hokkaido.jp","okoppe.hokkaido.jp","otaru.hokkaido.jp","otobe.hokkaido.jp","otofuke.hokkaido.jp","otoineppu.hokkaido.jp","oumu.hokkaido.jp","ozora.hokkaido.jp","pippu.hokkaido.jp","rankoshi.hokkaido.jp","rebun.hokkaido.jp","rikubetsu.hokkaido.jp","rishiri.hokkaido.jp","rishirifuji.hokkaido.jp","saroma.hokkaido.jp","sarufutsu.hokkaido.jp","shakotan.hokkaido.jp","shari.hokkaido.jp","shibecha.hokkaido.jp","shibetsu.hokkaido.jp","shikabe.hokkaido.jp","shikaoi.hokkaido.jp","shimamaki.hokkaido.jp","shimizu.hokkaido.jp","shimokawa.hokkaido.jp","shinshinotsu.hokkaido.jp","shintoku.hokkaido.jp","shiranuka.hokkaido.jp","shiraoi.hokkaido.jp","shiriuchi.hokkaido.jp","sobetsu.hokkaido.jp","sunagawa.hokkaido.jp","taiki.hokkaido.jp","takasu.hokkaido.jp","takikawa.hokkaido.jp","takinoue.hokkaido.jp","teshikaga.hokkaido.jp","tobetsu.hokkaido.jp","tohma.hokkaido.jp","tomakomai.hokkaido.jp","tomari.hokkaido.jp","toya.hokkaido.jp","toyako.hokkaido.jp","toyotomi.hokkaido.jp","toyoura.hokkaido.jp","tsubetsu.hokkaido.jp","tsukigata.hokkaido.jp","urakawa.hokkaido.jp","urausu.hokkaido.jp","uryu.hokkaido.jp","utashinai.hokkaido.jp","wakkanai.hokkaido.jp","wassamu.hokkaido.jp","yakumo.hokkaido.jp","yoichi.hokkaido.jp","aioi.hyogo.jp","akashi.hyogo.jp","ako.hyogo.jp","amagasaki.hyogo.jp","aogaki.hyogo.jp","asago.hyogo.jp","ashiya.hyogo.jp","awaji.hyogo.jp","fukusaki.hyogo.jp","goshiki.hyogo.jp","harima.hyogo.jp","himeji.hyogo.jp","ichikawa.hyogo.jp","inagawa.hyogo.jp","itami.hyogo.jp","kakogawa.hyogo.jp","kamigori.hyogo.jp","kamikawa.hyogo.jp","kasai.hyogo.jp","kasuga.hyogo.jp","kawanishi.hyogo.jp","miki.hyogo.jp","minamiawaji.hyogo.jp","nishinomiya.hyogo.jp","nishiwaki.hyogo.jp","ono.hyogo.jp","sanda.hyogo.jp","sannan.hyogo.jp","sasayama.hyogo.jp","sayo.hyogo.jp","shingu.hyogo.jp","shinonsen.hyogo.jp","shiso.hyogo.jp","sumoto.hyogo.jp","taishi.hyogo.jp","taka.hyogo.jp","takarazuka.hyogo.jp","takasago.hyogo.jp","takino.hyogo.jp","tamba.hyogo.jp","tatsuno.hyogo.jp","toyooka.hyogo.jp","yabu.hyogo.jp","yashiro.hyogo.jp","yoka.hyogo.jp","yokawa.hyogo.jp","ami.ibaraki.jp","asahi.ibaraki.jp","bando.ibaraki.jp","chikusei.ibaraki.jp","daigo.ibaraki.jp","fujishiro.ibaraki.jp","hitachi.ibaraki.jp","hitachinaka.ibaraki.jp","hitachiomiya.ibaraki.jp","hitachiota.ibaraki.jp","ibaraki.ibaraki.jp","ina.ibaraki.jp","inashiki.ibaraki.jp","itako.ibaraki.jp","iwama.ibaraki.jp","joso.ibaraki.jp","kamisu.ibaraki.jp","kasama.ibaraki.jp","kashima.ibaraki.jp","kasumigaura.ibaraki.jp","koga.ibaraki.jp","miho.ibaraki.jp","mito.ibaraki.jp","moriya.ibaraki.jp","naka.ibaraki.jp","namegata.ibaraki.jp","oarai.ibaraki.jp","ogawa.ibaraki.jp","omitama.ibaraki.jp","ryugasaki.ibaraki.jp","sakai.ibaraki.jp","sakuragawa.ibaraki.jp","shimodate.ibaraki.jp","shimotsuma.ibaraki.jp","shirosato.ibaraki.jp","sowa.ibaraki.jp","suifu.ibaraki.jp","takahagi.ibaraki.jp","tamatsukuri.ibaraki.jp","tokai.ibaraki.jp","tomobe.ibaraki.jp","tone.ibaraki.jp","toride.ibaraki.jp","tsuchiura.ibaraki.jp","tsukuba.ibaraki.jp","uchihara.ibaraki.jp","ushiku.ibaraki.jp","yachiyo.ibaraki.jp","yamagata.ibaraki.jp","yawara.ibaraki.jp","yuki.ibaraki.jp","anamizu.ishikawa.jp","hakui.ishikawa.jp","hakusan.ishikawa.jp","kaga.ishikawa.jp","kahoku.ishikawa.jp","kanazawa.ishikawa.jp","kawakita.ishikawa.jp","komatsu.ishikawa.jp","nakanoto.ishikawa.jp","nanao.ishikawa.jp","nomi.ishikawa.jp","nonoichi.ishikawa.jp","noto.ishikawa.jp","shika.ishikawa.jp","suzu.ishikawa.jp","tsubata.ishikawa.jp","tsurugi.ishikawa.jp","uchinada.ishikawa.jp","wajima.ishikawa.jp","fudai.iwate.jp","fujisawa.iwate.jp","hanamaki.iwate.jp","hiraizumi.iwate.jp","hirono.iwate.jp","ichinohe.iwate.jp","ichinoseki.iwate.jp","iwaizumi.iwate.jp","iwate.iwate.jp","joboji.iwate.jp","kamaishi.iwate.jp","kanegasaki.iwate.jp","karumai.iwate.jp","kawai.iwate.jp","kitakami.iwate.jp","kuji.iwate.jp","kunohe.iwate.jp","kuzumaki.iwate.jp","miyako.iwate.jp","mizusawa.iwate.jp","morioka.iwate.jp","ninohe.iwate.jp","noda.iwate.jp","ofunato.iwate.jp","oshu.iwate.jp","otsuchi.iwate.jp","rikuzentakata.iwate.jp","shiwa.iwate.jp","shizukuishi.iwate.jp","sumita.iwate.jp","tanohata.iwate.jp","tono.iwate.jp","yahaba.iwate.jp","yamada.iwate.jp","ayagawa.kagawa.jp","higashikagawa.kagawa.jp","kanonji.kagawa.jp","kotohira.kagawa.jp","manno.kagawa.jp","marugame.kagawa.jp","mitoyo.kagawa.jp","naoshima.kagawa.jp","sanuki.kagawa.jp","tadotsu.kagawa.jp","takamatsu.kagawa.jp","tonosho.kagawa.jp","uchinomi.kagawa.jp","utazu.kagawa.jp","zentsuji.kagawa.jp","akune.kagoshima.jp","amami.kagoshima.jp","hioki.kagoshima.jp","isa.kagoshima.jp","isen.kagoshima.jp","izumi.kagoshima.jp","kagoshima.kagoshima.jp","kanoya.kagoshima.jp","kawanabe.kagoshima.jp","kinko.kagoshima.jp","kouyama.kagoshima.jp","makurazaki.kagoshima.jp","matsumoto.kagoshima.jp","minamitane.kagoshima.jp","nakatane.kagoshima.jp","nishinoomote.kagoshima.jp","satsumasendai.kagoshima.jp","soo.kagoshima.jp","tarumizu.kagoshima.jp","yusui.kagoshima.jp","aikawa.kanagawa.jp","atsugi.kanagawa.jp","ayase.kanagawa.jp","chigasaki.kanagawa.jp","ebina.kanagawa.jp","fujisawa.kanagawa.jp","hadano.kanagawa.jp","hakone.kanagawa.jp","hiratsuka.kanagawa.jp","isehara.kanagawa.jp","kaisei.kanagawa.jp","kamakura.kanagawa.jp","kiyokawa.kanagawa.jp","matsuda.kanagawa.jp","minamiashigara.kanagawa.jp","miura.kanagawa.jp","nakai.kanagawa.jp","ninomiya.kanagawa.jp","odawara.kanagawa.jp","oi.kanagawa.jp","oiso.kanagawa.jp","sagamihara.kanagawa.jp","samukawa.kanagawa.jp","tsukui.kanagawa.jp","yamakita.kanagawa.jp","yamato.kanagawa.jp","yokosuka.kanagawa.jp","yugawara.kanagawa.jp","zama.kanagawa.jp","zushi.kanagawa.jp","aki.kochi.jp","geisei.kochi.jp","hidaka.kochi.jp","higashitsuno.kochi.jp","ino.kochi.jp","kagami.kochi.jp","kami.kochi.jp","kitagawa.kochi.jp","kochi.kochi.jp","mihara.kochi.jp","motoyama.kochi.jp","muroto.kochi.jp","nahari.kochi.jp","nakamura.kochi.jp","nankoku.kochi.jp","nishitosa.kochi.jp","niyodogawa.kochi.jp","ochi.kochi.jp","okawa.kochi.jp","otoyo.kochi.jp","otsuki.kochi.jp","sakawa.kochi.jp","sukumo.kochi.jp","susaki.kochi.jp","tosa.kochi.jp","tosashimizu.kochi.jp","toyo.kochi.jp","tsuno.kochi.jp","umaji.kochi.jp","yasuda.kochi.jp","yusuhara.kochi.jp","amakusa.kumamoto.jp","arao.kumamoto.jp","aso.kumamoto.jp","choyo.kumamoto.jp","gyokuto.kumamoto.jp","kamiamakusa.kumamoto.jp","kikuchi.kumamoto.jp","kumamoto.kumamoto.jp","mashiki.kumamoto.jp","mifune.kumamoto.jp","minamata.kumamoto.jp","minamioguni.kumamoto.jp","nagasu.kumamoto.jp","nishihara.kumamoto.jp","oguni.kumamoto.jp","ozu.kumamoto.jp","sumoto.kumamoto.jp","takamori.kumamoto.jp","uki.kumamoto.jp","uto.kumamoto.jp","yamaga.kumamoto.jp","yamato.kumamoto.jp","yatsushiro.kumamoto.jp","ayabe.kyoto.jp","fukuchiyama.kyoto.jp","higashiyama.kyoto.jp","ide.kyoto.jp","ine.kyoto.jp","joyo.kyoto.jp","kameoka.kyoto.jp","kamo.kyoto.jp","kita.kyoto.jp","kizu.kyoto.jp","kumiyama.kyoto.jp","kyotamba.kyoto.jp","kyotanabe.kyoto.jp","kyotango.kyoto.jp","maizuru.kyoto.jp","minami.kyoto.jp","minamiyamashiro.kyoto.jp","miyazu.kyoto.jp","muko.kyoto.jp","nagaokakyo.kyoto.jp","nakagyo.kyoto.jp","nantan.kyoto.jp","oyamazaki.kyoto.jp","sakyo.kyoto.jp","seika.kyoto.jp","tanabe.kyoto.jp","uji.kyoto.jp","ujitawara.kyoto.jp","wazuka.kyoto.jp","yamashina.kyoto.jp","yawata.kyoto.jp","asahi.mie.jp","inabe.mie.jp","ise.mie.jp","kameyama.mie.jp","kawagoe.mie.jp","kiho.mie.jp","kisosaki.mie.jp","kiwa.mie.jp","komono.mie.jp","kumano.mie.jp","kuwana.mie.jp","matsusaka.mie.jp","meiwa.mie.jp","mihama.mie.jp","minamiise.mie.jp","misugi.mie.jp","miyama.mie.jp","nabari.mie.jp","shima.mie.jp","suzuka.mie.jp","tado.mie.jp","taiki.mie.jp","taki.mie.jp","tamaki.mie.jp","toba.mie.jp","tsu.mie.jp","udono.mie.jp","ureshino.mie.jp","watarai.mie.jp","yokkaichi.mie.jp","furukawa.miyagi.jp","higashimatsushima.miyagi.jp","ishinomaki.miyagi.jp","iwanuma.miyagi.jp","kakuda.miyagi.jp","kami.miyagi.jp","kawasaki.miyagi.jp","marumori.miyagi.jp","matsushima.miyagi.jp","minamisanriku.miyagi.jp","misato.miyagi.jp","murata.miyagi.jp","natori.miyagi.jp","ogawara.miyagi.jp","ohira.miyagi.jp","onagawa.miyagi.jp","osaki.miyagi.jp","rifu.miyagi.jp","semine.miyagi.jp","shibata.miyagi.jp","shichikashuku.miyagi.jp","shikama.miyagi.jp","shiogama.miyagi.jp","shiroishi.miyagi.jp","tagajo.miyagi.jp","taiwa.miyagi.jp","tome.miyagi.jp","tomiya.miyagi.jp","wakuya.miyagi.jp","watari.miyagi.jp","yamamoto.miyagi.jp","zao.miyagi.jp","aya.miyazaki.jp","ebino.miyazaki.jp","gokase.miyazaki.jp","hyuga.miyazaki.jp","kadogawa.miyazaki.jp","kawaminami.miyazaki.jp","kijo.miyazaki.jp","kitagawa.miyazaki.jp","kitakata.miyazaki.jp","kitaura.miyazaki.jp","kobayashi.miyazaki.jp","kunitomi.miyazaki.jp","kushima.miyazaki.jp","mimata.miyazaki.jp","miyakonojo.miyazaki.jp","miyazaki.miyazaki.jp","morotsuka.miyazaki.jp","nichinan.miyazaki.jp","nishimera.miyazaki.jp","nobeoka.miyazaki.jp","saito.miyazaki.jp","shiiba.miyazaki.jp","shintomi.miyazaki.jp","takaharu.miyazaki.jp","takanabe.miyazaki.jp","takazaki.miyazaki.jp","tsuno.miyazaki.jp","achi.nagano.jp","agematsu.nagano.jp","anan.nagano.jp","aoki.nagano.jp","asahi.nagano.jp","azumino.nagano.jp","chikuhoku.nagano.jp","chikuma.nagano.jp","chino.nagano.jp","fujimi.nagano.jp","hakuba.nagano.jp","hara.nagano.jp","hiraya.nagano.jp","iida.nagano.jp","iijima.nagano.jp","iiyama.nagano.jp","iizuna.nagano.jp","ikeda.nagano.jp","ikusaka.nagano.jp","ina.nagano.jp","karuizawa.nagano.jp","kawakami.nagano.jp","kiso.nagano.jp","kisofukushima.nagano.jp","kitaaiki.nagano.jp","komagane.nagano.jp","komoro.nagano.jp","matsukawa.nagano.jp","matsumoto.nagano.jp","miasa.nagano.jp","minamiaiki.nagano.jp","minamimaki.nagano.jp","minamiminowa.nagano.jp","minowa.nagano.jp","miyada.nagano.jp","miyota.nagano.jp","mochizuki.nagano.jp","nagano.nagano.jp","nagawa.nagano.jp","nagiso.nagano.jp","nakagawa.nagano.jp","nakano.nagano.jp","nozawaonsen.nagano.jp","obuse.nagano.jp","ogawa.nagano.jp","okaya.nagano.jp","omachi.nagano.jp","omi.nagano.jp","ookuwa.nagano.jp","ooshika.nagano.jp","otaki.nagano.jp","otari.nagano.jp","sakae.nagano.jp","sakaki.nagano.jp","saku.nagano.jp","sakuho.nagano.jp","shimosuwa.nagano.jp","shinanomachi.nagano.jp","shiojiri.nagano.jp","suwa.nagano.jp","suzaka.nagano.jp","takagi.nagano.jp","takamori.nagano.jp","takayama.nagano.jp","tateshina.nagano.jp","tatsuno.nagano.jp","togakushi.nagano.jp","togura.nagano.jp","tomi.nagano.jp","ueda.nagano.jp","wada.nagano.jp","yamagata.nagano.jp","yamanouchi.nagano.jp","yasaka.nagano.jp","yasuoka.nagano.jp","chijiwa.nagasaki.jp","futsu.nagasaki.jp","goto.nagasaki.jp","hasami.nagasaki.jp","hirado.nagasaki.jp","iki.nagasaki.jp","isahaya.nagasaki.jp","kawatana.nagasaki.jp","kuchinotsu.nagasaki.jp","matsuura.nagasaki.jp","nagasaki.nagasaki.jp","obama.nagasaki.jp","omura.nagasaki.jp","oseto.nagasaki.jp","saikai.nagasaki.jp","sasebo.nagasaki.jp","seihi.nagasaki.jp","shimabara.nagasaki.jp","shinkamigoto.nagasaki.jp","togitsu.nagasaki.jp","tsushima.nagasaki.jp","unzen.nagasaki.jp","ando.nara.jp","gose.nara.jp","heguri.nara.jp","higashiyoshino.nara.jp","ikaruga.nara.jp","ikoma.nara.jp","kamikitayama.nara.jp","kanmaki.nara.jp","kashiba.nara.jp","kashihara.nara.jp","katsuragi.nara.jp","kawai.nara.jp","kawakami.nara.jp","kawanishi.nara.jp","koryo.nara.jp","kurotaki.nara.jp","mitsue.nara.jp","miyake.nara.jp","nara.nara.jp","nosegawa.nara.jp","oji.nara.jp","ouda.nara.jp","oyodo.nara.jp","sakurai.nara.jp","sango.nara.jp","shimoichi.nara.jp","shimokitayama.nara.jp","shinjo.nara.jp","soni.nara.jp","takatori.nara.jp","tawaramoto.nara.jp","tenkawa.nara.jp","tenri.nara.jp","uda.nara.jp","yamatokoriyama.nara.jp","yamatotakada.nara.jp","yamazoe.nara.jp","yoshino.nara.jp","aga.niigata.jp","agano.niigata.jp","gosen.niigata.jp","itoigawa.niigata.jp","izumozaki.niigata.jp","joetsu.niigata.jp","kamo.niigata.jp","kariwa.niigata.jp","kashiwazaki.niigata.jp","minamiuonuma.niigata.jp","mitsuke.niigata.jp","muika.niigata.jp","murakami.niigata.jp","myoko.niigata.jp","nagaoka.niigata.jp","niigata.niigata.jp","ojiya.niigata.jp","omi.niigata.jp","sado.niigata.jp","sanjo.niigata.jp","seiro.niigata.jp","seirou.niigata.jp","sekikawa.niigata.jp","shibata.niigata.jp","tagami.niigata.jp","tainai.niigata.jp","tochio.niigata.jp","tokamachi.niigata.jp","tsubame.niigata.jp","tsunan.niigata.jp","uonuma.niigata.jp","yahiko.niigata.jp","yoita.niigata.jp","yuzawa.niigata.jp","beppu.oita.jp","bungoono.oita.jp","bungotakada.oita.jp","hasama.oita.jp","hiji.oita.jp","himeshima.oita.jp","hita.oita.jp","kamitsue.oita.jp","kokonoe.oita.jp","kuju.oita.jp","kunisaki.oita.jp","kusu.oita.jp","oita.oita.jp","saiki.oita.jp","taketa.oita.jp","tsukumi.oita.jp","usa.oita.jp","usuki.oita.jp","yufu.oita.jp","akaiwa.okayama.jp","asakuchi.okayama.jp","bizen.okayama.jp","hayashima.okayama.jp","ibara.okayama.jp","kagamino.okayama.jp","kasaoka.okayama.jp","kibichuo.okayama.jp","kumenan.okayama.jp","kurashiki.okayama.jp","maniwa.okayama.jp","misaki.okayama.jp","nagi.okayama.jp","niimi.okayama.jp","nishiawakura.okayama.jp","okayama.okayama.jp","satosho.okayama.jp","setouchi.okayama.jp","shinjo.okayama.jp","shoo.okayama.jp","soja.okayama.jp","takahashi.okayama.jp","tamano.okayama.jp","tsuyama.okayama.jp","wake.okayama.jp","yakage.okayama.jp","aguni.okinawa.jp","ginowan.okinawa.jp","ginoza.okinawa.jp","gushikami.okinawa.jp","haebaru.okinawa.jp","higashi.okinawa.jp","hirara.okinawa.jp","iheya.okinawa.jp","ishigaki.okinawa.jp","ishikawa.okinawa.jp","itoman.okinawa.jp","izena.okinawa.jp","kadena.okinawa.jp","kin.okinawa.jp","kitadaito.okinawa.jp","kitanakagusuku.okinawa.jp","kumejima.okinawa.jp","kunigami.okinawa.jp","minamidaito.okinawa.jp","motobu.okinawa.jp","nago.okinawa.jp","naha.okinawa.jp","nakagusuku.okinawa.jp","nakijin.okinawa.jp","nanjo.okinawa.jp","nishihara.okinawa.jp","ogimi.okinawa.jp","okinawa.okinawa.jp","onna.okinawa.jp","shimoji.okinawa.jp","taketomi.okinawa.jp","tarama.okinawa.jp","tokashiki.okinawa.jp","tomigusuku.okinawa.jp","tonaki.okinawa.jp","urasoe.okinawa.jp","uruma.okinawa.jp","yaese.okinawa.jp","yomitan.okinawa.jp","yonabaru.okinawa.jp","yonaguni.okinawa.jp","zamami.okinawa.jp","abeno.osaka.jp","chihayaakasaka.osaka.jp","chuo.osaka.jp","daito.osaka.jp","fujiidera.osaka.jp","habikino.osaka.jp","hannan.osaka.jp","higashiosaka.osaka.jp","higashisumiyoshi.osaka.jp","higashiyodogawa.osaka.jp","hirakata.osaka.jp","ibaraki.osaka.jp","ikeda.osaka.jp","izumi.osaka.jp","izumiotsu.osaka.jp","izumisano.osaka.jp","kadoma.osaka.jp","kaizuka.osaka.jp","kanan.osaka.jp","kashiwara.osaka.jp","katano.osaka.jp","kawachinagano.osaka.jp","kishiwada.osaka.jp","kita.osaka.jp","kumatori.osaka.jp","matsubara.osaka.jp","minato.osaka.jp","minoh.osaka.jp","misaki.osaka.jp","moriguchi.osaka.jp","neyagawa.osaka.jp","nishi.osaka.jp","nose.osaka.jp","osakasayama.osaka.jp","sakai.osaka.jp","sayama.osaka.jp","sennan.osaka.jp","settsu.osaka.jp","shijonawate.osaka.jp","shimamoto.osaka.jp","suita.osaka.jp","tadaoka.osaka.jp","taishi.osaka.jp","tajiri.osaka.jp","takaishi.osaka.jp","takatsuki.osaka.jp","tondabayashi.osaka.jp","toyonaka.osaka.jp","toyono.osaka.jp","yao.osaka.jp","ariake.saga.jp","arita.saga.jp","fukudomi.saga.jp","genkai.saga.jp","hamatama.saga.jp","hizen.saga.jp","imari.saga.jp","kamimine.saga.jp","kanzaki.saga.jp","karatsu.saga.jp","kashima.saga.jp","kitagata.saga.jp","kitahata.saga.jp","kiyama.saga.jp","kouhoku.saga.jp","kyuragi.saga.jp","nishiarita.saga.jp","ogi.saga.jp","omachi.saga.jp","ouchi.saga.jp","saga.saga.jp","shiroishi.saga.jp","taku.saga.jp","tara.saga.jp","tosu.saga.jp","yoshinogari.saga.jp","arakawa.saitama.jp","asaka.saitama.jp","chichibu.saitama.jp","fujimi.saitama.jp","fujimino.saitama.jp","fukaya.saitama.jp","hanno.saitama.jp","hanyu.saitama.jp","hasuda.saitama.jp","hatogaya.saitama.jp","hatoyama.saitama.jp","hidaka.saitama.jp","higashichichibu.saitama.jp","higashimatsuyama.saitama.jp","honjo.saitama.jp","ina.saitama.jp","iruma.saitama.jp","iwatsuki.saitama.jp","kamiizumi.saitama.jp","kamikawa.saitama.jp","kamisato.saitama.jp","kasukabe.saitama.jp","kawagoe.saitama.jp","kawaguchi.saitama.jp","kawajima.saitama.jp","kazo.saitama.jp","kitamoto.saitama.jp","koshigaya.saitama.jp","kounosu.saitama.jp","kuki.saitama.jp","kumagaya.saitama.jp","matsubushi.saitama.jp","minano.saitama.jp","misato.saitama.jp","miyashiro.saitama.jp","miyoshi.saitama.jp","moroyama.saitama.jp","nagatoro.saitama.jp","namegawa.saitama.jp","niiza.saitama.jp","ogano.saitama.jp","ogawa.saitama.jp","ogose.saitama.jp","okegawa.saitama.jp","omiya.saitama.jp","otaki.saitama.jp","ranzan.saitama.jp","ryokami.saitama.jp","saitama.saitama.jp","sakado.saitama.jp","satte.saitama.jp","sayama.saitama.jp","shiki.saitama.jp","shiraoka.saitama.jp","soka.saitama.jp","sugito.saitama.jp","toda.saitama.jp","tokigawa.saitama.jp","tokorozawa.saitama.jp","tsurugashima.saitama.jp","urawa.saitama.jp","warabi.saitama.jp","yashio.saitama.jp","yokoze.saitama.jp","yono.saitama.jp","yorii.saitama.jp","yoshida.saitama.jp","yoshikawa.saitama.jp","yoshimi.saitama.jp","aisho.shiga.jp","gamo.shiga.jp","higashiomi.shiga.jp","hikone.shiga.jp","koka.shiga.jp","konan.shiga.jp","kosei.shiga.jp","koto.shiga.jp","kusatsu.shiga.jp","maibara.shiga.jp","moriyama.shiga.jp","nagahama.shiga.jp","nishiazai.shiga.jp","notogawa.shiga.jp","omihachiman.shiga.jp","otsu.shiga.jp","ritto.shiga.jp","ryuoh.shiga.jp","takashima.shiga.jp","takatsuki.shiga.jp","torahime.shiga.jp","toyosato.shiga.jp","yasu.shiga.jp","akagi.shimane.jp","ama.shimane.jp","gotsu.shimane.jp","hamada.shimane.jp","higashiizumo.shimane.jp","hikawa.shimane.jp","hikimi.shimane.jp","izumo.shimane.jp","kakinoki.shimane.jp","masuda.shimane.jp","matsue.shimane.jp","misato.shimane.jp","nishinoshima.shimane.jp","ohda.shimane.jp","okinoshima.shimane.jp","okuizumo.shimane.jp","shimane.shimane.jp","tamayu.shimane.jp","tsuwano.shimane.jp","unnan.shimane.jp","yakumo.shimane.jp","yasugi.shimane.jp","yatsuka.shimane.jp","arai.shizuoka.jp","atami.shizuoka.jp","fuji.shizuoka.jp","fujieda.shizuoka.jp","fujikawa.shizuoka.jp","fujinomiya.shizuoka.jp","fukuroi.shizuoka.jp","gotemba.shizuoka.jp","haibara.shizuoka.jp","hamamatsu.shizuoka.jp","higashiizu.shizuoka.jp","ito.shizuoka.jp","iwata.shizuoka.jp","izu.shizuoka.jp","izunokuni.shizuoka.jp","kakegawa.shizuoka.jp","kannami.shizuoka.jp","kawanehon.shizuoka.jp","kawazu.shizuoka.jp","kikugawa.shizuoka.jp","kosai.shizuoka.jp","makinohara.shizuoka.jp","matsuzaki.shizuoka.jp","minamiizu.shizuoka.jp","mishima.shizuoka.jp","morimachi.shizuoka.jp","nishiizu.shizuoka.jp","numazu.shizuoka.jp","omaezaki.shizuoka.jp","shimada.shizuoka.jp","shimizu.shizuoka.jp","shimoda.shizuoka.jp","shizuoka.shizuoka.jp","susono.shizuoka.jp","yaizu.shizuoka.jp","yoshida.shizuoka.jp","ashikaga.tochigi.jp","bato.tochigi.jp","haga.tochigi.jp","ichikai.tochigi.jp","iwafune.tochigi.jp","kaminokawa.tochigi.jp","kanuma.tochigi.jp","karasuyama.tochigi.jp","kuroiso.tochigi.jp","mashiko.tochigi.jp","mibu.tochigi.jp","moka.tochigi.jp","motegi.tochigi.jp","nasu.tochigi.jp","nasushiobara.tochigi.jp","nikko.tochigi.jp","nishikata.tochigi.jp","nogi.tochigi.jp","ohira.tochigi.jp","ohtawara.tochigi.jp","oyama.tochigi.jp","sakura.tochigi.jp","sano.tochigi.jp","shimotsuke.tochigi.jp","shioya.tochigi.jp","takanezawa.tochigi.jp","tochigi.tochigi.jp","tsuga.tochigi.jp","ujiie.tochigi.jp","utsunomiya.tochigi.jp","yaita.tochigi.jp","aizumi.tokushima.jp","anan.tokushima.jp","ichiba.tokushima.jp","itano.tokushima.jp","kainan.tokushima.jp","komatsushima.tokushima.jp","matsushige.tokushima.jp","mima.tokushima.jp","minami.tokushima.jp","miyoshi.tokushima.jp","mugi.tokushima.jp","nakagawa.tokushima.jp","naruto.tokushima.jp","sanagochi.tokushima.jp","shishikui.tokushima.jp","tokushima.tokushima.jp","wajiki.tokushima.jp","adachi.tokyo.jp","akiruno.tokyo.jp","akishima.tokyo.jp","aogashima.tokyo.jp","arakawa.tokyo.jp","bunkyo.tokyo.jp","chiyoda.tokyo.jp","chofu.tokyo.jp","chuo.tokyo.jp","edogawa.tokyo.jp","fuchu.tokyo.jp","fussa.tokyo.jp","hachijo.tokyo.jp","hachioji.tokyo.jp","hamura.tokyo.jp","higashikurume.tokyo.jp","higashimurayama.tokyo.jp","higashiyamato.tokyo.jp","hino.tokyo.jp","hinode.tokyo.jp","hinohara.tokyo.jp","inagi.tokyo.jp","itabashi.tokyo.jp","katsushika.tokyo.jp","kita.tokyo.jp","kiyose.tokyo.jp","kodaira.tokyo.jp","koganei.tokyo.jp","kokubunji.tokyo.jp","komae.tokyo.jp","koto.tokyo.jp","kouzushima.tokyo.jp","kunitachi.tokyo.jp","machida.tokyo.jp","meguro.tokyo.jp","minato.tokyo.jp","mitaka.tokyo.jp","mizuho.tokyo.jp","musashimurayama.tokyo.jp","musashino.tokyo.jp","nakano.tokyo.jp","nerima.tokyo.jp","ogasawara.tokyo.jp","okutama.tokyo.jp","ome.tokyo.jp","oshima.tokyo.jp","ota.tokyo.jp","setagaya.tokyo.jp","shibuya.tokyo.jp","shinagawa.tokyo.jp","shinjuku.tokyo.jp","suginami.tokyo.jp","sumida.tokyo.jp","tachikawa.tokyo.jp","taito.tokyo.jp","tama.tokyo.jp","toshima.tokyo.jp","chizu.tottori.jp","hino.tottori.jp","kawahara.tottori.jp","koge.tottori.jp","kotoura.tottori.jp","misasa.tottori.jp","nanbu.tottori.jp","nichinan.tottori.jp","sakaiminato.tottori.jp","tottori.tottori.jp","wakasa.tottori.jp","yazu.tottori.jp","yonago.tottori.jp","asahi.toyama.jp","fuchu.toyama.jp","fukumitsu.toyama.jp","funahashi.toyama.jp","himi.toyama.jp","imizu.toyama.jp","inami.toyama.jp","johana.toyama.jp","kamiichi.toyama.jp","kurobe.toyama.jp","nakaniikawa.toyama.jp","namerikawa.toyama.jp","nanto.toyama.jp","nyuzen.toyama.jp","oyabe.toyama.jp","taira.toyama.jp","takaoka.toyama.jp","tateyama.toyama.jp","toga.toyama.jp","tonami.toyama.jp","toyama.toyama.jp","unazuki.toyama.jp","uozu.toyama.jp","yamada.toyama.jp","arida.wakayama.jp","aridagawa.wakayama.jp","gobo.wakayama.jp","hashimoto.wakayama.jp","hidaka.wakayama.jp","hirogawa.wakayama.jp","inami.wakayama.jp","iwade.wakayama.jp","kainan.wakayama.jp","kamitonda.wakayama.jp","katsuragi.wakayama.jp","kimino.wakayama.jp","kinokawa.wakayama.jp","kitayama.wakayama.jp","koya.wakayama.jp","koza.wakayama.jp","kozagawa.wakayama.jp","kudoyama.wakayama.jp","kushimoto.wakayama.jp","mihama.wakayama.jp","misato.wakayama.jp","nachikatsuura.wakayama.jp","shingu.wakayama.jp","shirahama.wakayama.jp","taiji.wakayama.jp","tanabe.wakayama.jp","wakayama.wakayama.jp","yuasa.wakayama.jp","yura.wakayama.jp","asahi.yamagata.jp","funagata.yamagata.jp","higashine.yamagata.jp","iide.yamagata.jp","kahoku.yamagata.jp","kaminoyama.yamagata.jp","kaneyama.yamagata.jp","kawanishi.yamagata.jp","mamurogawa.yamagata.jp","mikawa.yamagata.jp","murayama.yamagata.jp","nagai.yamagata.jp","nakayama.yamagata.jp","nanyo.yamagata.jp","nishikawa.yamagata.jp","obanazawa.yamagata.jp","oe.yamagata.jp","oguni.yamagata.jp","ohkura.yamagata.jp","oishida.yamagata.jp","sagae.yamagata.jp","sakata.yamagata.jp","sakegawa.yamagata.jp","shinjo.yamagata.jp","shirataka.yamagata.jp","shonai.yamagata.jp","takahata.yamagata.jp","tendo.yamagata.jp","tozawa.yamagata.jp","tsuruoka.yamagata.jp","yamagata.yamagata.jp","yamanobe.yamagata.jp","yonezawa.yamagata.jp","yuza.yamagata.jp","abu.yamaguchi.jp","hagi.yamaguchi.jp","hikari.yamaguchi.jp","hofu.yamaguchi.jp","iwakuni.yamaguchi.jp","kudamatsu.yamaguchi.jp","mitou.yamaguchi.jp","nagato.yamaguchi.jp","oshima.yamaguchi.jp","shimonoseki.yamaguchi.jp","shunan.yamaguchi.jp","tabuse.yamaguchi.jp","tokuyama.yamaguchi.jp","toyota.yamaguchi.jp","ube.yamaguchi.jp","yuu.yamaguchi.jp","chuo.yamanashi.jp","doshi.yamanashi.jp","fuefuki.yamanashi.jp","fujikawa.yamanashi.jp","fujikawaguchiko.yamanashi.jp","fujiyoshida.yamanashi.jp","hayakawa.yamanashi.jp","hokuto.yamanashi.jp","ichikawamisato.yamanashi.jp","kai.yamanashi.jp","kofu.yamanashi.jp","koshu.yamanashi.jp","kosuge.yamanashi.jp","minami-alps.yamanashi.jp","minobu.yamanashi.jp","nakamichi.yamanashi.jp","nanbu.yamanashi.jp","narusawa.yamanashi.jp","nirasaki.yamanashi.jp","nishikatsura.yamanashi.jp","oshino.yamanashi.jp","otsuki.yamanashi.jp","showa.yamanashi.jp","tabayama.yamanashi.jp","tsuru.yamanashi.jp","uenohara.yamanashi.jp","yamanakako.yamanashi.jp","yamanashi.yamanashi.jp","ke","ac.ke","co.ke","go.ke","info.ke","me.ke","mobi.ke","ne.ke","or.ke","sc.ke","kg","org.kg","net.kg","com.kg","edu.kg","gov.kg","mil.kg","*.kh","ki","edu.ki","biz.ki","net.ki","org.ki","gov.ki","info.ki","com.ki","km","org.km","nom.km","gov.km","prd.km","tm.km","edu.km","mil.km","ass.km","com.km","coop.km","asso.km","presse.km","medecin.km","notaires.km","pharmaciens.km","veterinaire.km","gouv.km","kn","net.kn","org.kn","edu.kn","gov.kn","kp","com.kp","edu.kp","gov.kp","org.kp","rep.kp","tra.kp","kr","ac.kr","co.kr","es.kr","go.kr","hs.kr","kg.kr","mil.kr","ms.kr","ne.kr","or.kr","pe.kr","re.kr","sc.kr","busan.kr","chungbuk.kr","chungnam.kr","daegu.kr","daejeon.kr","gangwon.kr","gwangju.kr","gyeongbuk.kr","gyeonggi.kr","gyeongnam.kr","incheon.kr","jeju.kr","jeonbuk.kr","jeonnam.kr","seoul.kr","ulsan.kr","kw","com.kw","edu.kw","emb.kw","gov.kw","ind.kw","net.kw","org.kw","ky","edu.ky","gov.ky","com.ky","org.ky","net.ky","kz","org.kz","edu.kz","net.kz","gov.kz","mil.kz","com.kz","la","int.la","net.la","info.la","edu.la","gov.la","per.la","com.la","org.la","lb","com.lb","edu.lb","gov.lb","net.lb","org.lb","lc","com.lc","net.lc","co.lc","org.lc","edu.lc","gov.lc","li","lk","gov.lk","sch.lk","net.lk","int.lk","com.lk","org.lk","edu.lk","ngo.lk","soc.lk","web.lk","ltd.lk","assn.lk","grp.lk","hotel.lk","ac.lk","lr","com.lr","edu.lr","gov.lr","org.lr","net.lr","ls","ac.ls","biz.ls","co.ls","edu.ls","gov.ls","info.ls","net.ls","org.ls","sc.ls","lt","gov.lt","lu","lv","com.lv","edu.lv","gov.lv","org.lv","mil.lv","id.lv","net.lv","asn.lv","conf.lv","ly","com.ly","net.ly","gov.ly","plc.ly","edu.ly","sch.ly","med.ly","org.ly","id.ly","ma","co.ma","net.ma","gov.ma","org.ma","ac.ma","press.ma","mc","tm.mc","asso.mc","md","me","co.me","net.me","org.me","edu.me","ac.me","gov.me","its.me","priv.me","mg","org.mg","nom.mg","gov.mg","prd.mg","tm.mg","edu.mg","mil.mg","com.mg","co.mg","mh","mil","mk","com.mk","org.mk","net.mk","edu.mk","gov.mk","inf.mk","name.mk","ml","com.ml","edu.ml","gouv.ml","gov.ml","net.ml","org.ml","presse.ml","*.mm","mn","gov.mn","edu.mn","org.mn","mo","com.mo","net.mo","org.mo","edu.mo","gov.mo","mobi","mp","mq","mr","gov.mr","ms","com.ms","edu.ms","gov.ms","net.ms","org.ms","mt","com.mt","edu.mt","net.mt","org.mt","mu","com.mu","net.mu","org.mu","gov.mu","ac.mu","co.mu","or.mu","museum","academy.museum","agriculture.museum","air.museum","airguard.museum","alabama.museum","alaska.museum","amber.museum","ambulance.museum","american.museum","americana.museum","americanantiques.museum","americanart.museum","amsterdam.museum","and.museum","annefrank.museum","anthro.museum","anthropology.museum","antiques.museum","aquarium.museum","arboretum.museum","archaeological.museum","archaeology.museum","architecture.museum","art.museum","artanddesign.museum","artcenter.museum","artdeco.museum","arteducation.museum","artgallery.museum","arts.museum","artsandcrafts.museum","asmatart.museum","assassination.museum","assisi.museum","association.museum","astronomy.museum","atlanta.museum","austin.museum","australia.museum","automotive.museum","aviation.museum","axis.museum","badajoz.museum","baghdad.museum","bahn.museum","bale.museum","baltimore.museum","barcelona.museum","baseball.museum","basel.museum","baths.museum","bauern.museum","beauxarts.museum","beeldengeluid.museum","bellevue.museum","bergbau.museum","berkeley.museum","berlin.museum","bern.museum","bible.museum","bilbao.museum","bill.museum","birdart.museum","birthplace.museum","bonn.museum","boston.museum","botanical.museum","botanicalgarden.museum","botanicgarden.museum","botany.museum","brandywinevalley.museum","brasil.museum","bristol.museum","british.museum","britishcolumbia.museum","broadcast.museum","brunel.museum","brussel.museum","brussels.museum","bruxelles.museum","building.museum","burghof.museum","bus.museum","bushey.museum","cadaques.museum","california.museum","cambridge.museum","can.museum","canada.museum","capebreton.museum","carrier.museum","cartoonart.museum","casadelamoneda.museum","castle.museum","castres.museum","celtic.museum","center.museum","chattanooga.museum","cheltenham.museum","chesapeakebay.museum","chicago.museum","children.museum","childrens.museum","childrensgarden.museum","chiropractic.museum","chocolate.museum","christiansburg.museum","cincinnati.museum","cinema.museum","circus.museum","civilisation.museum","civilization.museum","civilwar.museum","clinton.museum","clock.museum","coal.museum","coastaldefence.museum","cody.museum","coldwar.museum","collection.museum","colonialwilliamsburg.museum","coloradoplateau.museum","columbia.museum","columbus.museum","communication.museum","communications.museum","community.museum","computer.museum","computerhistory.museum","comunicações.museum","contemporary.museum","contemporaryart.museum","convent.museum","copenhagen.museum","corporation.museum","correios-e-telecomunicações.museum","corvette.museum","costume.museum","countryestate.museum","county.museum","crafts.museum","cranbrook.museum","creation.museum","cultural.museum","culturalcenter.museum","culture.museum","cyber.museum","cymru.museum","dali.museum","dallas.museum","database.museum","ddr.museum","decorativearts.museum","delaware.museum","delmenhorst.museum","denmark.museum","depot.museum","design.museum","detroit.museum","dinosaur.museum","discovery.museum","dolls.museum","donostia.museum","durham.museum","eastafrica.museum","eastcoast.museum","education.museum","educational.museum","egyptian.museum","eisenbahn.museum","elburg.museum","elvendrell.museum","embroidery.museum","encyclopedic.museum","england.museum","entomology.museum","environment.museum","environmentalconservation.museum","epilepsy.museum","essex.museum","estate.museum","ethnology.museum","exeter.museum","exhibition.museum","family.museum","farm.museum","farmequipment.museum","farmers.museum","farmstead.museum","field.museum","figueres.museum","filatelia.museum","film.museum","fineart.museum","finearts.museum","finland.museum","flanders.museum","florida.museum","force.museum","fortmissoula.museum","fortworth.museum","foundation.museum","francaise.museum","frankfurt.museum","franziskaner.museum","freemasonry.museum","freiburg.museum","fribourg.museum","frog.museum","fundacio.museum","furniture.museum","gallery.museum","garden.museum","gateway.museum","geelvinck.museum","gemological.museum","geology.museum","georgia.museum","giessen.museum","glas.museum","glass.museum","gorge.museum","grandrapids.museum","graz.museum","guernsey.museum","halloffame.museum","hamburg.museum","handson.museum","harvestcelebration.museum","hawaii.museum","health.museum","heimatunduhren.museum","hellas.museum","helsinki.museum","hembygdsforbund.museum","heritage.museum","histoire.museum","historical.museum","historicalsociety.museum","historichouses.museum","historisch.museum","historisches.museum","history.museum","historyofscience.museum","horology.museum","house.museum","humanities.museum","illustration.museum","imageandsound.museum","indian.museum","indiana.museum","indianapolis.museum","indianmarket.museum","intelligence.museum","interactive.museum","iraq.museum","iron.museum","isleofman.museum","jamison.museum","jefferson.museum","jerusalem.museum","jewelry.museum","jewish.museum","jewishart.museum","jfk.museum","journalism.museum","judaica.museum","judygarland.museum","juedisches.museum","juif.museum","karate.museum","karikatur.museum","kids.museum","koebenhavn.museum","koeln.museum","kunst.museum","kunstsammlung.museum","kunstunddesign.museum","labor.museum","labour.museum","lajolla.museum","lancashire.museum","landes.museum","lans.museum","läns.museum","larsson.museum","lewismiller.museum","lincoln.museum","linz.museum","living.museum","livinghistory.museum","localhistory.museum","london.museum","losangeles.museum","louvre.museum","loyalist.museum","lucerne.museum","luxembourg.museum","luzern.museum","mad.museum","madrid.museum","mallorca.museum","manchester.museum","mansion.museum","mansions.museum","manx.museum","marburg.museum","maritime.museum","maritimo.museum","maryland.museum","marylhurst.museum","media.museum","medical.museum","medizinhistorisches.museum","meeres.museum","memorial.museum","mesaverde.museum","michigan.museum","midatlantic.museum","military.museum","mill.museum","miners.museum","mining.museum","minnesota.museum","missile.museum","missoula.museum","modern.museum","moma.museum","money.museum","monmouth.museum","monticello.museum","montreal.museum","moscow.museum","motorcycle.museum","muenchen.museum","muenster.museum","mulhouse.museum","muncie.museum","museet.museum","museumcenter.museum","museumvereniging.museum","music.museum","national.museum","nationalfirearms.museum","nationalheritage.museum","nativeamerican.museum","naturalhistory.museum","naturalhistorymuseum.museum","naturalsciences.museum","nature.museum","naturhistorisches.museum","natuurwetenschappen.museum","naumburg.museum","naval.museum","nebraska.museum","neues.museum","newhampshire.museum","newjersey.museum","newmexico.museum","newport.museum","newspaper.museum","newyork.museum","niepce.museum","norfolk.museum","north.museum","nrw.museum","nyc.museum","nyny.museum","oceanographic.museum","oceanographique.museum","omaha.museum","online.museum","ontario.museum","openair.museum","oregon.museum","oregontrail.museum","otago.museum","oxford.museum","pacific.museum","paderborn.museum","palace.museum","paleo.museum","palmsprings.museum","panama.museum","paris.museum","pasadena.museum","pharmacy.museum","philadelphia.museum","philadelphiaarea.museum","philately.museum","phoenix.museum","photography.museum","pilots.museum","pittsburgh.museum","planetarium.museum","plantation.museum","plants.museum","plaza.museum","portal.museum","portland.museum","portlligat.museum","posts-and-telecommunications.museum","preservation.museum","presidio.museum","press.museum","project.museum","public.museum","pubol.museum","quebec.museum","railroad.museum","railway.museum","research.museum","resistance.museum","riodejaneiro.museum","rochester.museum","rockart.museum","roma.museum","russia.museum","saintlouis.museum","salem.museum","salvadordali.museum","salzburg.museum","sandiego.museum","sanfrancisco.museum","santabarbara.museum","santacruz.museum","santafe.museum","saskatchewan.museum","satx.museum","savannahga.museum","schlesisches.museum","schoenbrunn.museum","schokoladen.museum","school.museum","schweiz.museum","science.museum","scienceandhistory.museum","scienceandindustry.museum","sciencecenter.museum","sciencecenters.museum","science-fiction.museum","sciencehistory.museum","sciences.museum","sciencesnaturelles.museum","scotland.museum","seaport.museum","settlement.museum","settlers.museum","shell.museum","sherbrooke.museum","sibenik.museum","silk.museum","ski.museum","skole.museum","society.museum","sologne.museum","soundandvision.museum","southcarolina.museum","southwest.museum","space.museum","spy.museum","square.museum","stadt.museum","stalbans.museum","starnberg.museum","state.museum","stateofdelaware.museum","station.museum","steam.museum","steiermark.museum","stjohn.museum","stockholm.museum","stpetersburg.museum","stuttgart.museum","suisse.museum","surgeonshall.museum","surrey.museum","svizzera.museum","sweden.museum","sydney.museum","tank.museum","tcm.museum","technology.museum","telekommunikation.museum","television.museum","texas.museum","textile.museum","theater.museum","time.museum","timekeeping.museum","topology.museum","torino.museum","touch.museum","town.museum","transport.museum","tree.museum","trolley.museum","trust.museum","trustee.museum","uhren.museum","ulm.museum","undersea.museum","university.museum","usa.museum","usantiques.museum","usarts.museum","uscountryestate.museum","usculture.museum","usdecorativearts.museum","usgarden.museum","ushistory.museum","ushuaia.museum","uslivinghistory.museum","utah.museum","uvic.museum","valley.museum","vantaa.museum","versailles.museum","viking.museum","village.museum","virginia.museum","virtual.museum","virtuel.museum","vlaanderen.museum","volkenkunde.museum","wales.museum","wallonie.museum","war.museum","washingtondc.museum","watchandclock.museum","watch-and-clock.museum","western.museum","westfalen.museum","whaling.museum","wildlife.museum","williamsburg.museum","windmill.museum","workshop.museum","york.museum","yorkshire.museum","yosemite.museum","youth.museum","zoological.museum","zoology.museum","ירושלים.museum","иком.museum","mv","aero.mv","biz.mv","com.mv","coop.mv","edu.mv","gov.mv","info.mv","int.mv","mil.mv","museum.mv","name.mv","net.mv","org.mv","pro.mv","mw","ac.mw","biz.mw","co.mw","com.mw","coop.mw","edu.mw","gov.mw","int.mw","museum.mw","net.mw","org.mw","mx","com.mx","org.mx","gob.mx","edu.mx","net.mx","my","com.my","net.my","org.my","gov.my","edu.my","mil.my","name.my","mz","ac.mz","adv.mz","co.mz","edu.mz","gov.mz","mil.mz","net.mz","org.mz","na","info.na","pro.na","name.na","school.na","or.na","dr.na","us.na","mx.na","ca.na","in.na","cc.na","tv.na","ws.na","mobi.na","co.na","com.na","org.na","name","nc","asso.nc","nom.nc","ne","net","nf","com.nf","net.nf","per.nf","rec.nf","web.nf","arts.nf","firm.nf","info.nf","other.nf","store.nf","ng","com.ng","edu.ng","gov.ng","i.ng","mil.ng","mobi.ng","name.ng","net.ng","org.ng","sch.ng","ni","ac.ni","biz.ni","co.ni","com.ni","edu.ni","gob.ni","in.ni","info.ni","int.ni","mil.ni","net.ni","nom.ni","org.ni","web.ni","nl","no","fhs.no","vgs.no","fylkesbibl.no","folkebibl.no","museum.no","idrett.no","priv.no","mil.no","stat.no","dep.no","kommune.no","herad.no","aa.no","ah.no","bu.no","fm.no","hl.no","hm.no","jan-mayen.no","mr.no","nl.no","nt.no","of.no","ol.no","oslo.no","rl.no","sf.no","st.no","svalbard.no","tm.no","tr.no","va.no","vf.no","gs.aa.no","gs.ah.no","gs.bu.no","gs.fm.no","gs.hl.no","gs.hm.no","gs.jan-mayen.no","gs.mr.no","gs.nl.no","gs.nt.no","gs.of.no","gs.ol.no","gs.oslo.no","gs.rl.no","gs.sf.no","gs.st.no","gs.svalbard.no","gs.tm.no","gs.tr.no","gs.va.no","gs.vf.no","akrehamn.no","åkrehamn.no","algard.no","ålgård.no","arna.no","brumunddal.no","bryne.no","bronnoysund.no","brønnøysund.no","drobak.no","drøbak.no","egersund.no","fetsund.no","floro.no","florø.no","fredrikstad.no","hokksund.no","honefoss.no","hønefoss.no","jessheim.no","jorpeland.no","jørpeland.no","kirkenes.no","kopervik.no","krokstadelva.no","langevag.no","langevåg.no","leirvik.no","mjondalen.no","mjøndalen.no","mo-i-rana.no","mosjoen.no","mosjøen.no","nesoddtangen.no","orkanger.no","osoyro.no","osøyro.no","raholt.no","råholt.no","sandnessjoen.no","sandnessjøen.no","skedsmokorset.no","slattum.no","spjelkavik.no","stathelle.no","stavern.no","stjordalshalsen.no","stjørdalshalsen.no","tananger.no","tranby.no","vossevangen.no","afjord.no","åfjord.no","agdenes.no","al.no","ål.no","alesund.no","ålesund.no","alstahaug.no","alta.no","áltá.no","alaheadju.no","álaheadju.no","alvdal.no","amli.no","åmli.no","amot.no","åmot.no","andebu.no","andoy.no","andøy.no","andasuolo.no","ardal.no","årdal.no","aremark.no","arendal.no","ås.no","aseral.no","åseral.no","asker.no","askim.no","askvoll.no","askoy.no","askøy.no","asnes.no","åsnes.no","audnedaln.no","aukra.no","aure.no","aurland.no","aurskog-holand.no","aurskog-høland.no","austevoll.no","austrheim.no","averoy.no","averøy.no","balestrand.no","ballangen.no","balat.no","bálát.no","balsfjord.no","bahccavuotna.no","báhccavuotna.no","bamble.no","bardu.no","beardu.no","beiarn.no","bajddar.no","bájddar.no","baidar.no","báidár.no","berg.no","bergen.no","berlevag.no","berlevåg.no","bearalvahki.no","bearalváhki.no","bindal.no","birkenes.no","bjarkoy.no","bjarkøy.no","bjerkreim.no","bjugn.no","bodo.no","bodø.no","badaddja.no","bådåddjå.no","budejju.no","bokn.no","bremanger.no","bronnoy.no","brønnøy.no","bygland.no","bykle.no","barum.no","bærum.no","bo.telemark.no","bø.telemark.no","bo.nordland.no","bø.nordland.no","bievat.no","bievát.no","bomlo.no","bømlo.no","batsfjord.no","båtsfjord.no","bahcavuotna.no","báhcavuotna.no","dovre.no","drammen.no","drangedal.no","dyroy.no","dyrøy.no","donna.no","dønna.no","eid.no","eidfjord.no","eidsberg.no","eidskog.no","eidsvoll.no","eigersund.no","elverum.no","enebakk.no","engerdal.no","etne.no","etnedal.no","evenes.no","evenassi.no","evenášši.no","evje-og-hornnes.no","farsund.no","fauske.no","fuossko.no","fuoisku.no","fedje.no","fet.no","finnoy.no","finnøy.no","fitjar.no","fjaler.no","fjell.no","flakstad.no","flatanger.no","flekkefjord.no","flesberg.no","flora.no","fla.no","flå.no","folldal.no","forsand.no","fosnes.no","frei.no","frogn.no","froland.no","frosta.no","frana.no","fræna.no","froya.no","frøya.no","fusa.no","fyresdal.no","forde.no","førde.no","gamvik.no","gangaviika.no","gáŋgaviika.no","gaular.no","gausdal.no","gildeskal.no","gildeskål.no","giske.no","gjemnes.no","gjerdrum.no","gjerstad.no","gjesdal.no","gjovik.no","gjøvik.no","gloppen.no","gol.no","gran.no","grane.no","granvin.no","gratangen.no","grimstad.no","grong.no","kraanghke.no","kråanghke.no","grue.no","gulen.no","hadsel.no","halden.no","halsa.no","hamar.no","hamaroy.no","habmer.no","hábmer.no","hapmir.no","hápmir.no","hammerfest.no","hammarfeasta.no","hámmárfeasta.no","haram.no","hareid.no","harstad.no","hasvik.no","aknoluokta.no","ákŋoluokta.no","hattfjelldal.no","aarborte.no","haugesund.no","hemne.no","hemnes.no","hemsedal.no","heroy.more-og-romsdal.no","herøy.møre-og-romsdal.no","heroy.nordland.no","herøy.nordland.no","hitra.no","hjartdal.no","hjelmeland.no","hobol.no","hobøl.no","hof.no","hol.no","hole.no","holmestrand.no","holtalen.no","holtålen.no","hornindal.no","horten.no","hurdal.no","hurum.no","hvaler.no","hyllestad.no","hagebostad.no","hægebostad.no","hoyanger.no","høyanger.no","hoylandet.no","høylandet.no","ha.no","hå.no","ibestad.no","inderoy.no","inderøy.no","iveland.no","jevnaker.no","jondal.no","jolster.no","jølster.no","karasjok.no","karasjohka.no","kárášjohka.no","karlsoy.no","galsa.no","gálsá.no","karmoy.no","karmøy.no","kautokeino.no","guovdageaidnu.no","klepp.no","klabu.no","klæbu.no","kongsberg.no","kongsvinger.no","kragero.no","kragerø.no","kristiansand.no","kristiansund.no","krodsherad.no","krødsherad.no","kvalsund.no","rahkkeravju.no","ráhkkerávju.no","kvam.no","kvinesdal.no","kvinnherad.no","kviteseid.no","kvitsoy.no","kvitsøy.no","kvafjord.no","kvæfjord.no","giehtavuoatna.no","kvanangen.no","kvænangen.no","navuotna.no","návuotna.no","kafjord.no","kåfjord.no","gaivuotna.no","gáivuotna.no","larvik.no","lavangen.no","lavagis.no","loabat.no","loabát.no","lebesby.no","davvesiida.no","leikanger.no","leirfjord.no","leka.no","leksvik.no","lenvik.no","leangaviika.no","leaŋgaviika.no","lesja.no","levanger.no","lier.no","lierne.no","lillehammer.no","lillesand.no","lindesnes.no","lindas.no","lindås.no","lom.no","loppa.no","lahppi.no","láhppi.no","lund.no","lunner.no","luroy.no","lurøy.no","luster.no","lyngdal.no","lyngen.no","ivgu.no","lardal.no","lerdal.no","lærdal.no","lodingen.no","lødingen.no","lorenskog.no","lørenskog.no","loten.no","løten.no","malvik.no","masoy.no","måsøy.no","muosat.no","muosát.no","mandal.no","marker.no","marnardal.no","masfjorden.no","meland.no","meldal.no","melhus.no","meloy.no","meløy.no","meraker.no","meråker.no","moareke.no","moåreke.no","midsund.no","midtre-gauldal.no","modalen.no","modum.no","molde.no","moskenes.no","moss.no","mosvik.no","malselv.no","målselv.no","malatvuopmi.no","málatvuopmi.no","namdalseid.no","aejrie.no","namsos.no","namsskogan.no","naamesjevuemie.no","nååmesjevuemie.no","laakesvuemie.no","nannestad.no","narvik.no","narviika.no","naustdal.no","nedre-eiker.no","nes.akershus.no","nes.buskerud.no","nesna.no","nesodden.no","nesseby.no","unjarga.no","unjárga.no","nesset.no","nissedal.no","nittedal.no","nord-aurdal.no","nord-fron.no","nord-odal.no","norddal.no","nordkapp.no","davvenjarga.no","davvenjárga.no","nordre-land.no","nordreisa.no","raisa.no","ráisa.no","nore-og-uvdal.no","notodden.no","naroy.no","nærøy.no","notteroy.no","nøtterøy.no","odda.no","oksnes.no","øksnes.no","oppdal.no","oppegard.no","oppegård.no","orkdal.no","orland.no","ørland.no","orskog.no","ørskog.no","orsta.no","ørsta.no","os.hedmark.no","os.hordaland.no","osen.no","osteroy.no","osterøy.no","ostre-toten.no","østre-toten.no","overhalla.no","ovre-eiker.no","øvre-eiker.no","oyer.no","øyer.no","oygarden.no","øygarden.no","oystre-slidre.no","øystre-slidre.no","porsanger.no","porsangu.no","porsáŋgu.no","porsgrunn.no","radoy.no","radøy.no","rakkestad.no","rana.no","ruovat.no","randaberg.no","rauma.no","rendalen.no","rennebu.no","rennesoy.no","rennesøy.no","rindal.no","ringebu.no","ringerike.no","ringsaker.no","rissa.no","risor.no","risør.no","roan.no","rollag.no","rygge.no","ralingen.no","rælingen.no","rodoy.no","rødøy.no","romskog.no","rømskog.no","roros.no","røros.no","rost.no","røst.no","royken.no","røyken.no","royrvik.no","røyrvik.no","rade.no","råde.no","salangen.no","siellak.no","saltdal.no","salat.no","sálát.no","sálat.no","samnanger.no","sande.more-og-romsdal.no","sande.møre-og-romsdal.no","sande.vestfold.no","sandefjord.no","sandnes.no","sandoy.no","sandøy.no","sarpsborg.no","sauda.no","sauherad.no","sel.no","selbu.no","selje.no","seljord.no","sigdal.no","siljan.no","sirdal.no","skaun.no","skedsmo.no","ski.no","skien.no","skiptvet.no","skjervoy.no","skjervøy.no","skierva.no","skiervá.no","skjak.no","skjåk.no","skodje.no","skanland.no","skånland.no","skanit.no","skánit.no","smola.no","smøla.no","snillfjord.no","snasa.no","snåsa.no","snoasa.no","snaase.no","snåase.no","sogndal.no","sokndal.no","sola.no","solund.no","songdalen.no","sortland.no","spydeberg.no","stange.no","stavanger.no","steigen.no","steinkjer.no","stjordal.no","stjørdal.no","stokke.no","stor-elvdal.no","stord.no","stordal.no","storfjord.no","omasvuotna.no","strand.no","stranda.no","stryn.no","sula.no","suldal.no","sund.no","sunndal.no","surnadal.no","sveio.no","svelvik.no","sykkylven.no","sogne.no","søgne.no","somna.no","sømna.no","sondre-land.no","søndre-land.no","sor-aurdal.no","sør-aurdal.no","sor-fron.no","sør-fron.no","sor-odal.no","sør-odal.no","sor-varanger.no","sør-varanger.no","matta-varjjat.no","mátta-várjjat.no","sorfold.no","sørfold.no","sorreisa.no","sørreisa.no","sorum.no","sørum.no","tana.no","deatnu.no","time.no","tingvoll.no","tinn.no","tjeldsund.no","dielddanuorri.no","tjome.no","tjøme.no","tokke.no","tolga.no","torsken.no","tranoy.no","tranøy.no","tromso.no","tromsø.no","tromsa.no","romsa.no","trondheim.no","troandin.no","trysil.no","trana.no","træna.no","trogstad.no","trøgstad.no","tvedestrand.no","tydal.no","tynset.no","tysfjord.no","divtasvuodna.no","divttasvuotna.no","tysnes.no","tysvar.no","tysvær.no","tonsberg.no","tønsberg.no","ullensaker.no","ullensvang.no","ulvik.no","utsira.no","vadso.no","vadsø.no","cahcesuolo.no","čáhcesuolo.no","vaksdal.no","valle.no","vang.no","vanylven.no","vardo.no","vardø.no","varggat.no","várggát.no","vefsn.no","vaapste.no","vega.no","vegarshei.no","vegårshei.no","vennesla.no","verdal.no","verran.no","vestby.no","vestnes.no","vestre-slidre.no","vestre-toten.no","vestvagoy.no","vestvågøy.no","vevelstad.no","vik.no","vikna.no","vindafjord.no","volda.no","voss.no","varoy.no","værøy.no","vagan.no","vågan.no","voagat.no","vagsoy.no","vågsøy.no","vaga.no","vågå.no","valer.ostfold.no","våler.østfold.no","valer.hedmark.no","våler.hedmark.no","*.np","nr","biz.nr","info.nr","gov.nr","edu.nr","org.nr","net.nr","com.nr","nu","nz","ac.nz","co.nz","cri.nz","geek.nz","gen.nz","govt.nz","health.nz","iwi.nz","kiwi.nz","maori.nz","mil.nz","māori.nz","net.nz","org.nz","parliament.nz","school.nz","om","co.om","com.om","edu.om","gov.om","med.om","museum.om","net.om","org.om","pro.om","onion","org","pa","ac.pa","gob.pa","com.pa","org.pa","sld.pa","edu.pa","net.pa","ing.pa","abo.pa","med.pa","nom.pa","pe","edu.pe","gob.pe","nom.pe","mil.pe","org.pe","com.pe","net.pe","pf","com.pf","org.pf","edu.pf","*.pg","ph","com.ph","net.ph","org.ph","gov.ph","edu.ph","ngo.ph","mil.ph","i.ph","pk","com.pk","net.pk","edu.pk","org.pk","fam.pk","biz.pk","web.pk","gov.pk","gob.pk","gok.pk","gon.pk","gop.pk","gos.pk","info.pk","pl","com.pl","net.pl","org.pl","aid.pl","agro.pl","atm.pl","auto.pl","biz.pl","edu.pl","gmina.pl","gsm.pl","info.pl","mail.pl","miasta.pl","media.pl","mil.pl","nieruchomosci.pl","nom.pl","pc.pl","powiat.pl","priv.pl","realestate.pl","rel.pl","sex.pl","shop.pl","sklep.pl","sos.pl","szkola.pl","targi.pl","tm.pl","tourism.pl","travel.pl","turystyka.pl","gov.pl","ap.gov.pl","ic.gov.pl","is.gov.pl","us.gov.pl","kmpsp.gov.pl","kppsp.gov.pl","kwpsp.gov.pl","psp.gov.pl","wskr.gov.pl","kwp.gov.pl","mw.gov.pl","ug.gov.pl","um.gov.pl","umig.gov.pl","ugim.gov.pl","upow.gov.pl","uw.gov.pl","starostwo.gov.pl","pa.gov.pl","po.gov.pl","psse.gov.pl","pup.gov.pl","rzgw.gov.pl","sa.gov.pl","so.gov.pl","sr.gov.pl","wsa.gov.pl","sko.gov.pl","uzs.gov.pl","wiih.gov.pl","winb.gov.pl","pinb.gov.pl","wios.gov.pl","witd.gov.pl","wzmiuw.gov.pl","piw.gov.pl","wiw.gov.pl","griw.gov.pl","wif.gov.pl","oum.gov.pl","sdn.gov.pl","zp.gov.pl","uppo.gov.pl","mup.gov.pl","wuoz.gov.pl","konsulat.gov.pl","oirm.gov.pl","augustow.pl","babia-gora.pl","bedzin.pl","beskidy.pl","bialowieza.pl","bialystok.pl","bielawa.pl","bieszczady.pl","boleslawiec.pl","bydgoszcz.pl","bytom.pl","cieszyn.pl","czeladz.pl","czest.pl","dlugoleka.pl","elblag.pl","elk.pl","glogow.pl","gniezno.pl","gorlice.pl","grajewo.pl","ilawa.pl","jaworzno.pl","jelenia-gora.pl","jgora.pl","kalisz.pl","kazimierz-dolny.pl","karpacz.pl","kartuzy.pl","kaszuby.pl","katowice.pl","kepno.pl","ketrzyn.pl","klodzko.pl","kobierzyce.pl","kolobrzeg.pl","konin.pl","konskowola.pl","kutno.pl","lapy.pl","lebork.pl","legnica.pl","lezajsk.pl","limanowa.pl","lomza.pl","lowicz.pl","lubin.pl","lukow.pl","malbork.pl","malopolska.pl","mazowsze.pl","mazury.pl","mielec.pl","mielno.pl","mragowo.pl","naklo.pl","nowaruda.pl","nysa.pl","olawa.pl","olecko.pl","olkusz.pl","olsztyn.pl","opoczno.pl","opole.pl","ostroda.pl","ostroleka.pl","ostrowiec.pl","ostrowwlkp.pl","pila.pl","pisz.pl","podhale.pl","podlasie.pl","polkowice.pl","pomorze.pl","pomorskie.pl","prochowice.pl","pruszkow.pl","przeworsk.pl","pulawy.pl","radom.pl","rawa-maz.pl","rybnik.pl","rzeszow.pl","sanok.pl","sejny.pl","slask.pl","slupsk.pl","sosnowiec.pl","stalowa-wola.pl","skoczow.pl","starachowice.pl","stargard.pl","suwalki.pl","swidnica.pl","swiebodzin.pl","swinoujscie.pl","szczecin.pl","szczytno.pl","tarnobrzeg.pl","tgory.pl","turek.pl","tychy.pl","ustka.pl","walbrzych.pl","warmia.pl","warszawa.pl","waw.pl","wegrow.pl","wielun.pl","wlocl.pl","wloclawek.pl","wodzislaw.pl","wolomin.pl","wroclaw.pl","zachpomor.pl","zagan.pl","zarow.pl","zgora.pl","zgorzelec.pl","pm","pn","gov.pn","co.pn","org.pn","edu.pn","net.pn","post","pr","com.pr","net.pr","org.pr","gov.pr","edu.pr","isla.pr","pro.pr","biz.pr","info.pr","name.pr","est.pr","prof.pr","ac.pr","pro","aaa.pro","aca.pro","acct.pro","avocat.pro","bar.pro","cpa.pro","eng.pro","jur.pro","law.pro","med.pro","recht.pro","ps","edu.ps","gov.ps","sec.ps","plo.ps","com.ps","org.ps","net.ps","pt","net.pt","gov.pt","org.pt","edu.pt","int.pt","publ.pt","com.pt","nome.pt","pw","co.pw","ne.pw","or.pw","ed.pw","go.pw","belau.pw","py","com.py","coop.py","edu.py","gov.py","mil.py","net.py","org.py","qa","com.qa","edu.qa","gov.qa","mil.qa","name.qa","net.qa","org.qa","sch.qa","re","asso.re","com.re","nom.re","ro","arts.ro","com.ro","firm.ro","info.ro","nom.ro","nt.ro","org.ro","rec.ro","store.ro","tm.ro","www.ro","rs","ac.rs","co.rs","edu.rs","gov.rs","in.rs","org.rs","ru","rw","ac.rw","co.rw","coop.rw","gov.rw","mil.rw","net.rw","org.rw","sa","com.sa","net.sa","org.sa","gov.sa","med.sa","pub.sa","edu.sa","sch.sa","sb","com.sb","edu.sb","gov.sb","net.sb","org.sb","sc","com.sc","gov.sc","net.sc","org.sc","edu.sc","sd","com.sd","net.sd","org.sd","edu.sd","med.sd","tv.sd","gov.sd","info.sd","se","a.se","ac.se","b.se","bd.se","brand.se","c.se","d.se","e.se","f.se","fh.se","fhsk.se","fhv.se","g.se","h.se","i.se","k.se","komforb.se","kommunalforbund.se","komvux.se","l.se","lanbib.se","m.se","n.se","naturbruksgymn.se","o.se","org.se","p.se","parti.se","pp.se","press.se","r.se","s.se","t.se","tm.se","u.se","w.se","x.se","y.se","z.se","sg","com.sg","net.sg","org.sg","gov.sg","edu.sg","per.sg","sh","com.sh","net.sh","gov.sh","org.sh","mil.sh","si","sj","sk","sl","com.sl","net.sl","edu.sl","gov.sl","org.sl","sm","sn","art.sn","com.sn","edu.sn","gouv.sn","org.sn","perso.sn","univ.sn","so","com.so","edu.so","gov.so","me.so","net.so","org.so","sr","ss","biz.ss","com.ss","edu.ss","gov.ss","net.ss","org.ss","st","co.st","com.st","consulado.st","edu.st","embaixada.st","gov.st","mil.st","net.st","org.st","principe.st","saotome.st","store.st","su","sv","com.sv","edu.sv","gob.sv","org.sv","red.sv","sx","gov.sx","sy","edu.sy","gov.sy","net.sy","mil.sy","com.sy","org.sy","sz","co.sz","ac.sz","org.sz","tc","td","tel","tf","tg","th","ac.th","co.th","go.th","in.th","mi.th","net.th","or.th","tj","ac.tj","biz.tj","co.tj","com.tj","edu.tj","go.tj","gov.tj","int.tj","mil.tj","name.tj","net.tj","nic.tj","org.tj","test.tj","web.tj","tk","tl","gov.tl","tm","com.tm","co.tm","org.tm","net.tm","nom.tm","gov.tm","mil.tm","edu.tm","tn","com.tn","ens.tn","fin.tn","gov.tn","ind.tn","intl.tn","nat.tn","net.tn","org.tn","info.tn","perso.tn","tourism.tn","edunet.tn","rnrt.tn","rns.tn","rnu.tn","mincom.tn","agrinet.tn","defense.tn","turen.tn","to","com.to","gov.to","net.to","org.to","edu.to","mil.to","tr","av.tr","bbs.tr","bel.tr","biz.tr","com.tr","dr.tr","edu.tr","gen.tr","gov.tr","info.tr","mil.tr","k12.tr","kep.tr","name.tr","net.tr","org.tr","pol.tr","tel.tr","tsk.tr","tv.tr","web.tr","nc.tr","gov.nc.tr","tt","co.tt","com.tt","org.tt","net.tt","biz.tt","info.tt","pro.tt","int.tt","coop.tt","jobs.tt","mobi.tt","travel.tt","museum.tt","aero.tt","name.tt","gov.tt","edu.tt","tv","tw","edu.tw","gov.tw","mil.tw","com.tw","net.tw","org.tw","idv.tw","game.tw","ebiz.tw","club.tw","網路.tw","組織.tw","商業.tw","tz","ac.tz","co.tz","go.tz","hotel.tz","info.tz","me.tz","mil.tz","mobi.tz","ne.tz","or.tz","sc.tz","tv.tz","ua","com.ua","edu.ua","gov.ua","in.ua","net.ua","org.ua","cherkassy.ua","cherkasy.ua","chernigov.ua","chernihiv.ua","chernivtsi.ua","chernovtsy.ua","ck.ua","cn.ua","cr.ua","crimea.ua","cv.ua","dn.ua","dnepropetrovsk.ua","dnipropetrovsk.ua","dominic.ua","donetsk.ua","dp.ua","if.ua","ivano-frankivsk.ua","kh.ua","kharkiv.ua","kharkov.ua","kherson.ua","khmelnitskiy.ua","khmelnytskyi.ua","kiev.ua","kirovograd.ua","km.ua","kr.ua","krym.ua","ks.ua","kv.ua","kyiv.ua","lg.ua","lt.ua","lugansk.ua","lutsk.ua","lv.ua","lviv.ua","mk.ua","mykolaiv.ua","nikolaev.ua","od.ua","odesa.ua","odessa.ua","pl.ua","poltava.ua","rivne.ua","rovno.ua","rv.ua","sb.ua","sebastopol.ua","sevastopol.ua","sm.ua","sumy.ua","te.ua","ternopil.ua","uz.ua","uzhgorod.ua","vinnica.ua","vinnytsia.ua","vn.ua","volyn.ua","yalta.ua","zaporizhzhe.ua","zaporizhzhia.ua","zhitomir.ua","zhytomyr.ua","zp.ua","zt.ua","ug","co.ug","or.ug","ac.ug","sc.ug","go.ug","ne.ug","com.ug","org.ug","uk","ac.uk","co.uk","gov.uk","ltd.uk","me.uk","net.uk","nhs.uk","org.uk","plc.uk","police.uk","*.sch.uk","us","dni.us","fed.us","isa.us","kids.us","nsn.us","ak.us","al.us","ar.us","as.us","az.us","ca.us","co.us","ct.us","dc.us","de.us","fl.us","ga.us","gu.us","hi.us","ia.us","id.us","il.us","in.us","ks.us","ky.us","la.us","ma.us","md.us","me.us","mi.us","mn.us","mo.us","ms.us","mt.us","nc.us","nd.us","ne.us","nh.us","nj.us","nm.us","nv.us","ny.us","oh.us","ok.us","or.us","pa.us","pr.us","ri.us","sc.us","sd.us","tn.us","tx.us","ut.us","vi.us","vt.us","va.us","wa.us","wi.us","wv.us","wy.us","k12.ak.us","k12.al.us","k12.ar.us","k12.as.us","k12.az.us","k12.ca.us","k12.co.us","k12.ct.us","k12.dc.us","k12.de.us","k12.fl.us","k12.ga.us","k12.gu.us","k12.ia.us","k12.id.us","k12.il.us","k12.in.us","k12.ks.us","k12.ky.us","k12.la.us","k12.ma.us","k12.md.us","k12.me.us","k12.mi.us","k12.mn.us","k12.mo.us","k12.ms.us","k12.mt.us","k12.nc.us","k12.ne.us","k12.nh.us","k12.nj.us","k12.nm.us","k12.nv.us","k12.ny.us","k12.oh.us","k12.ok.us","k12.or.us","k12.pa.us","k12.pr.us","k12.ri.us","k12.sc.us","k12.tn.us","k12.tx.us","k12.ut.us","k12.vi.us","k12.vt.us","k12.va.us","k12.wa.us","k12.wi.us","k12.wy.us","cc.ak.us","cc.al.us","cc.ar.us","cc.as.us","cc.az.us","cc.ca.us","cc.co.us","cc.ct.us","cc.dc.us","cc.de.us","cc.fl.us","cc.ga.us","cc.gu.us","cc.hi.us","cc.ia.us","cc.id.us","cc.il.us","cc.in.us","cc.ks.us","cc.ky.us","cc.la.us","cc.ma.us","cc.md.us","cc.me.us","cc.mi.us","cc.mn.us","cc.mo.us","cc.ms.us","cc.mt.us","cc.nc.us","cc.nd.us","cc.ne.us","cc.nh.us","cc.nj.us","cc.nm.us","cc.nv.us","cc.ny.us","cc.oh.us","cc.ok.us","cc.or.us","cc.pa.us","cc.pr.us","cc.ri.us","cc.sc.us","cc.sd.us","cc.tn.us","cc.tx.us","cc.ut.us","cc.vi.us","cc.vt.us","cc.va.us","cc.wa.us","cc.wi.us","cc.wv.us","cc.wy.us","lib.ak.us","lib.al.us","lib.ar.us","lib.as.us","lib.az.us","lib.ca.us","lib.co.us","lib.ct.us","lib.dc.us","lib.fl.us","lib.ga.us","lib.gu.us","lib.hi.us","lib.ia.us","lib.id.us","lib.il.us","lib.in.us","lib.ks.us","lib.ky.us","lib.la.us","lib.ma.us","lib.md.us","lib.me.us","lib.mi.us","lib.mn.us","lib.mo.us","lib.ms.us","lib.mt.us","lib.nc.us","lib.nd.us","lib.ne.us","lib.nh.us","lib.nj.us","lib.nm.us","lib.nv.us","lib.ny.us","lib.oh.us","lib.ok.us","lib.or.us","lib.pa.us","lib.pr.us","lib.ri.us","lib.sc.us","lib.sd.us","lib.tn.us","lib.tx.us","lib.ut.us","lib.vi.us","lib.vt.us","lib.va.us","lib.wa.us","lib.wi.us","lib.wy.us","pvt.k12.ma.us","chtr.k12.ma.us","paroch.k12.ma.us","ann-arbor.mi.us","cog.mi.us","dst.mi.us","eaton.mi.us","gen.mi.us","mus.mi.us","tec.mi.us","washtenaw.mi.us","uy","com.uy","edu.uy","gub.uy","mil.uy","net.uy","org.uy","uz","co.uz","com.uz","net.uz","org.uz","va","vc","com.vc","net.vc","org.vc","gov.vc","mil.vc","edu.vc","ve","arts.ve","co.ve","com.ve","e12.ve","edu.ve","firm.ve","gob.ve","gov.ve","info.ve","int.ve","mil.ve","net.ve","org.ve","rec.ve","store.ve","tec.ve","web.ve","vg","vi","co.vi","com.vi","k12.vi","net.vi","org.vi","vn","com.vn","net.vn","org.vn","edu.vn","gov.vn","int.vn","ac.vn","biz.vn","info.vn","name.vn","pro.vn","health.vn","vu","com.vu","edu.vu","net.vu","org.vu","wf","ws","com.ws","net.ws","org.ws","gov.ws","edu.ws","yt","امارات","հայ","বাংলা","бг","бел","中国","中國","الجزائر","مصر","ею","ευ","موريتانيا","გე","ελ","香港","公司.香港","教育.香港","政府.香港","個人.香港","網絡.香港","組織.香港","ಭಾರತ","ଭାରତ","ভাৰত","भारतम्","भारोत","ڀارت","ഭാരതം","भारत","بارت","بھارت","భారత్","ભારત","ਭਾਰਤ","ভারত","இந்தியா","ایران","ايران","عراق","الاردن","한국","қаз","ලංකා","இலங்கை","المغرب","мкд","мон","澳門","澳门","مليسيا","عمان","پاکستان","پاكستان","فلسطين","срб","пр.срб","орг.срб","обр.срб","од.срб","упр.срб","ак.срб","рф","قطر","السعودية","السعودیة","السعودیۃ","السعوديه","سودان","新加坡","சிங்கப்பூர்","سورية","سوريا","ไทย","ศึกษา.ไทย","ธุรกิจ.ไทย","รัฐบาล.ไทย","ทหาร.ไทย","เน็ต.ไทย","องค์กร.ไทย","تونس","台灣","台湾","臺灣","укр","اليمن","xxx","*.ye","ac.za","agric.za","alt.za","co.za","edu.za","gov.za","grondar.za","law.za","mil.za","net.za","ngo.za","nic.za","nis.za","nom.za","org.za","school.za","tm.za","web.za","zm","ac.zm","biz.zm","co.zm","com.zm","edu.zm","gov.zm","info.zm","mil.zm","net.zm","org.zm","sch.zm","zw","ac.zw","co.zw","gov.zw","mil.zw","org.zw","aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","academy","accenture","accountant","accountants","aco","actor","adac","ads","adult","aeg","aetna","afamilycompany","afl","africa","agakhan","agency","aig","aigo","airbus","airforce","airtel","akdn","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","aol","apartments","app","apple","aquarelle","arab","aramco","archi","army","art","arte","asda","associates","athleta","attorney","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aws","axa","azure","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bbc","bbt","bbva","bcg","bcn","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bharti","bible","bid","bike","bing","bingo","bio","black","blackfriday","blockbuster","blog","bloomberg","blue","bms","bmw","bnpparibas","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","bradesco","bridgestone","broadway","broker","brother","brussels","budapest","bugatti","build","builders","business","buy","buzz","bzh","cab","cafe","cal","call","calvinklein","cam","camera","camp","cancerresearch","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","caseih","cash","casino","catering","catholic","cba","cbn","cbre","cbs","ceb","center","ceo","cern","cfa","cfd","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","coach","codes","coffee","college","cologne","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","corsica","country","coupon","coupons","courses","cpa","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","csc","cuisinella","cymru","cyou","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dnp","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","duck","dunlop","dupont","durban","dvag","dvr","earth","eat","eco","edeka","education","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","ericsson","erni","esq","estate","esurance","etisalat","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","flickr","flights","flir","florist","flowers","fly","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fujixerox","fun","fund","furniture","futbol","fyi","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gbiz","gdn","gea","gent","genting","george","ggee","gift","gifts","gives","giving","glade","glass","gle","global","globo","gmail","gmbh","gmo","gmx","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","grainger","graphics","gratis","green","gripe","grocery","group","guardian","gucci","guge","guide","guitars","guru","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hkt","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hsbc","hughes","hyatt","hyundai","ibm","icbc","ice","icu","ieee","ifm","ikano","imamat","imdb","immo","immobilien","inc","industries","infiniti","ing","ink","institute","insurance","insure","intel","international","intuit","investments","ipiranga","irish","ismaili","ist","istanbul","itau","itv","iveco","jaguar","java","jcb","jcp","jeep","jetzt","jewelry","jio","jll","jmp","jnj","joburg","jot","joy","jpmorgan","jprs","juegos","juniper","kaufen","kddi","kerryhotels","kerrylogistics","kerryproperties","kfh","kia","kim","kinder","kindle","kitchen","kiwi","koeln","komatsu","kosher","kpmg","kpn","krd","kred","kuokgroup","kyoto","lacaixa","lamborghini","lamer","lancaster","lancia","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","lixil","llc","llp","loan","loans","locker","locus","loft","lol","london","lotte","lotto","love","lpl","lplfinancial","ltd","ltda","lundbeck","lupin","luxe","luxury","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mckinsey","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","metlife","miami","microsoft","mini","mint","mit","mitsubishi","mlb","mls","mma","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","msd","mtn","mtr","mutual","nab","nadex","nagoya","nationwide","natura","navy","nba","nec","netbank","netflix","network","neustar","new","newholland","news","next","nextdirect","nexus","nfl","ngo","nhk","nico","nike","nikon","ninja","nissan","nissay","nokia","northwesternmutual","norton","now","nowruz","nowtv","nra","nrw","ntt","nyc","obi","observer","off","office","okinawa","olayan","olayangroup","oldnavy","ollo","omega","one","ong","onl","online","onyourside","ooo","open","oracle","orange","organic","origins","osaka","otsuka","ott","ovh","page","panasonic","paris","pars","partners","parts","party","passagens","pay","pccw","pet","pfizer","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","place","play","playstation","plumbing","plus","pnc","pohl","poker","politie","porn","pramerica","praxi","press","prime","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","pub","pwc","qpon","quebec","quest","qvc","racing","radio","raid","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","rightathome","ril","rio","rip","rmit","rocher","rocks","rodeo","rogers","room","rsvp","rugby","ruhr","run","rwe","ryukyu","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sbi","sbs","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scjohnson","scor","scot","search","seat","secure","security","seek","select","sener","services","ses","seven","sew","sex","sexy","sfr","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","shriram","silk","sina","singles","site","ski","skin","sky","skype","sling","smart","smile","sncf","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","spreadbetting","srl","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","sucks","supplies","supply","support","surf","surgery","suzuki","swatch","swiftcover","swiss","sydney","symantec","systems","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tci","tdk","team","tech","technology","temasek","tennis","teva","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tjmaxx","tjx","tkmaxx","tmall","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tube","tui","tunes","tushu","tvs","ubank","ubs","unicom","university","uno","uol","ups","vacations","vana","vanguard","vegas","ventures","verisign","versicherung","vet","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vodka","volkswagen","volvo","vote","voting","voto","voyage","vuelos","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","कॉम","セール","佛山","慈善","集团","在线","大众汽车","点看","คอม","八卦","موقع","公益","公司","香格里拉","网站","移动","我爱你","москва","католик","онлайн","сайт","联通","קום","时尚","微博","淡马锡","ファッション","орг","नेट","ストア","アマゾン","삼성","商标","商店","商城","дети","ポイント","新闻","工行","家電","كوم","中文网","中信","娱乐","谷歌","電訊盈科","购物","クラウド","通販","网店","संगठन","餐厅","网络","ком","亚马逊","诺基亚","食品","飞利浦","手表","手机","ارامكو","العليان","اتصالات","بازار","ابوظبي","كاثوليك","همراه","닷컴","政府","شبكة","بيتك","عرب","机构","组织机构","健康","招聘","рус","珠宝","大拿","みんな","グーグル","世界","書籍","网址","닷넷","コム","天主教","游戏","vermögensberater","vermögensberatung","企业","信息","嘉里大酒店","嘉里","广东","政务","xyz","yachts","yahoo","yamaxun","yandex","yodobashi","yoga","yokohama","you","youtube","yun","zappos","zara","zero","zip","zone","zuerich","cc.ua","inf.ua","ltd.ua","adobeaemcloud.com","adobeaemcloud.net","*.dev.adobeaemcloud.com","beep.pl","barsy.ca","*.compute.estate","*.alces.network","altervista.org","alwaysdata.net","cloudfront.net","*.compute.amazonaws.com","*.compute-1.amazonaws.com","*.compute.amazonaws.com.cn","us-east-1.amazonaws.com","cn-north-1.eb.amazonaws.com.cn","cn-northwest-1.eb.amazonaws.com.cn","elasticbeanstalk.com","ap-northeast-1.elasticbeanstalk.com","ap-northeast-2.elasticbeanstalk.com","ap-northeast-3.elasticbeanstalk.com","ap-south-1.elasticbeanstalk.com","ap-southeast-1.elasticbeanstalk.com","ap-southeast-2.elasticbeanstalk.com","ca-central-1.elasticbeanstalk.com","eu-central-1.elasticbeanstalk.com","eu-west-1.elasticbeanstalk.com","eu-west-2.elasticbeanstalk.com","eu-west-3.elasticbeanstalk.com","sa-east-1.elasticbeanstalk.com","us-east-1.elasticbeanstalk.com","us-east-2.elasticbeanstalk.com","us-gov-west-1.elasticbeanstalk.com","us-west-1.elasticbeanstalk.com","us-west-2.elasticbeanstalk.com","*.elb.amazonaws.com","*.elb.amazonaws.com.cn","s3.amazonaws.com","s3-ap-northeast-1.amazonaws.com","s3-ap-northeast-2.amazonaws.com","s3-ap-south-1.amazonaws.com","s3-ap-southeast-1.amazonaws.com","s3-ap-southeast-2.amazonaws.com","s3-ca-central-1.amazonaws.com","s3-eu-central-1.amazonaws.com","s3-eu-west-1.amazonaws.com","s3-eu-west-2.amazonaws.com","s3-eu-west-3.amazonaws.com","s3-external-1.amazonaws.com","s3-fips-us-gov-west-1.amazonaws.com","s3-sa-east-1.amazonaws.com","s3-us-gov-west-1.amazonaws.com","s3-us-east-2.amazonaws.com","s3-us-west-1.amazonaws.com","s3-us-west-2.amazonaws.com","s3.ap-northeast-2.amazonaws.com","s3.ap-south-1.amazonaws.com","s3.cn-north-1.amazonaws.com.cn","s3.ca-central-1.amazonaws.com","s3.eu-central-1.amazonaws.com","s3.eu-west-2.amazonaws.com","s3.eu-west-3.amazonaws.com","s3.us-east-2.amazonaws.com","s3.dualstack.ap-northeast-1.amazonaws.com","s3.dualstack.ap-northeast-2.amazonaws.com","s3.dualstack.ap-south-1.amazonaws.com","s3.dualstack.ap-southeast-1.amazonaws.com","s3.dualstack.ap-southeast-2.amazonaws.com","s3.dualstack.ca-central-1.amazonaws.com","s3.dualstack.eu-central-1.amazonaws.com","s3.dualstack.eu-west-1.amazonaws.com","s3.dualstack.eu-west-2.amazonaws.com","s3.dualstack.eu-west-3.amazonaws.com","s3.dualstack.sa-east-1.amazonaws.com","s3.dualstack.us-east-1.amazonaws.com","s3.dualstack.us-east-2.amazonaws.com","s3-website-us-east-1.amazonaws.com","s3-website-us-west-1.amazonaws.com","s3-website-us-west-2.amazonaws.com","s3-website-ap-northeast-1.amazonaws.com","s3-website-ap-southeast-1.amazonaws.com","s3-website-ap-southeast-2.amazonaws.com","s3-website-eu-west-1.amazonaws.com","s3-website-sa-east-1.amazonaws.com","s3-website.ap-northeast-2.amazonaws.com","s3-website.ap-south-1.amazonaws.com","s3-website.ca-central-1.amazonaws.com","s3-website.eu-central-1.amazonaws.com","s3-website.eu-west-2.amazonaws.com","s3-website.eu-west-3.amazonaws.com","s3-website.us-east-2.amazonaws.com","amsw.nl","t3l3p0rt.net","tele.amune.org","apigee.io","on-aptible.com","user.aseinet.ne.jp","gv.vc","d.gv.vc","user.party.eus","pimienta.org","poivron.org","potager.org","sweetpepper.org","myasustor.com","myfritz.net","*.awdev.ca","*.advisor.ws","b-data.io","backplaneapp.io","balena-devices.com","app.banzaicloud.io","betainabox.com","bnr.la","blackbaudcdn.net","boomla.net","boxfuse.io","square7.ch","bplaced.com","bplaced.de","square7.de","bplaced.net","square7.net","browsersafetymark.io","uk0.bigv.io","dh.bytemark.co.uk","vm.bytemark.co.uk","mycd.eu","carrd.co","crd.co","uwu.ai","ae.org","ar.com","br.com","cn.com","com.de","com.se","de.com","eu.com","gb.com","gb.net","hu.com","hu.net","jp.net","jpn.com","kr.com","mex.com","no.com","qc.com","ru.com","sa.com","se.net","uk.com","uk.net","us.com","uy.com","za.bz","za.com","africa.com","gr.com","in.net","us.org","co.com","c.la","certmgr.org","xenapponazure.com","discourse.group","discourse.team","virtueeldomein.nl","cleverapps.io","*.lcl.dev","*.stg.dev","c66.me","cloud66.ws","cloud66.zone","jdevcloud.com","wpdevcloud.com","cloudaccess.host","freesite.host","cloudaccess.net","cloudcontrolled.com","cloudcontrolapp.com","cloudera.site","trycloudflare.com","workers.dev","wnext.app","co.ca","*.otap.co","co.cz","c.cdn77.org","cdn77-ssl.net","r.cdn77.net","rsc.cdn77.org","ssl.origin.cdn77-secure.org","cloudns.asia","cloudns.biz","cloudns.club","cloudns.cc","cloudns.eu","cloudns.in","cloudns.info","cloudns.org","cloudns.pro","cloudns.pw","cloudns.us","cloudeity.net","cnpy.gdn","co.nl","co.no","webhosting.be","hosting-cluster.nl","ac.ru","edu.ru","gov.ru","int.ru","mil.ru","test.ru","dyn.cosidns.de","dynamisches-dns.de","dnsupdater.de","internet-dns.de","l-o-g-i-n.de","dynamic-dns.info","feste-ip.net","knx-server.net","static-access.net","realm.cz","*.cryptonomic.net","cupcake.is","*.customer-oci.com","*.oci.customer-oci.com","*.ocp.customer-oci.com","*.ocs.customer-oci.com","cyon.link","cyon.site","daplie.me","localhost.daplie.me","dattolocal.com","dattorelay.com","dattoweb.com","mydatto.com","dattolocal.net","mydatto.net","biz.dk","co.dk","firm.dk","reg.dk","store.dk","*.dapps.earth","*.bzz.dapps.earth","builtwithdark.com","edgestack.me","debian.net","dedyn.io","dnshome.de","online.th","shop.th","drayddns.com","dreamhosters.com","mydrobo.com","drud.io","drud.us","duckdns.org","dy.fi","tunk.org","dyndns-at-home.com","dyndns-at-work.com","dyndns-blog.com","dyndns-free.com","dyndns-home.com","dyndns-ip.com","dyndns-mail.com","dyndns-office.com","dyndns-pics.com","dyndns-remote.com","dyndns-server.com","dyndns-web.com","dyndns-wiki.com","dyndns-work.com","dyndns.biz","dyndns.info","dyndns.org","dyndns.tv","at-band-camp.net","ath.cx","barrel-of-knowledge.info","barrell-of-knowledge.info","better-than.tv","blogdns.com","blogdns.net","blogdns.org","blogsite.org","boldlygoingnowhere.org","broke-it.net","buyshouses.net","cechire.com","dnsalias.com","dnsalias.net","dnsalias.org","dnsdojo.com","dnsdojo.net","dnsdojo.org","does-it.net","doesntexist.com","doesntexist.org","dontexist.com","dontexist.net","dontexist.org","doomdns.com","doomdns.org","dvrdns.org","dyn-o-saur.com","dynalias.com","dynalias.net","dynalias.org","dynathome.net","dyndns.ws","endofinternet.net","endofinternet.org","endoftheinternet.org","est-a-la-maison.com","est-a-la-masion.com","est-le-patron.com","est-mon-blogueur.com","for-better.biz","for-more.biz","for-our.info","for-some.biz","for-the.biz","forgot.her.name","forgot.his.name","from-ak.com","from-al.com","from-ar.com","from-az.net","from-ca.com","from-co.net","from-ct.com","from-dc.com","from-de.com","from-fl.com","from-ga.com","from-hi.com","from-ia.com","from-id.com","from-il.com","from-in.com","from-ks.com","from-ky.com","from-la.net","from-ma.com","from-md.com","from-me.org","from-mi.com","from-mn.com","from-mo.com","from-ms.com","from-mt.com","from-nc.com","from-nd.com","from-ne.com","from-nh.com","from-nj.com","from-nm.com","from-nv.com","from-ny.net","from-oh.com","from-ok.com","from-or.com","from-pa.com","from-pr.com","from-ri.com","from-sc.com","from-sd.com","from-tn.com","from-tx.com","from-ut.com","from-va.com","from-vt.com","from-wa.com","from-wi.com","from-wv.com","from-wy.com","ftpaccess.cc","fuettertdasnetz.de","game-host.org","game-server.cc","getmyip.com","gets-it.net","go.dyndns.org","gotdns.com","gotdns.org","groks-the.info","groks-this.info","ham-radio-op.net","here-for-more.info","hobby-site.com","hobby-site.org","home.dyndns.org","homedns.org","homeftp.net","homeftp.org","homeip.net","homelinux.com","homelinux.net","homelinux.org","homeunix.com","homeunix.net","homeunix.org","iamallama.com","in-the-band.net","is-a-anarchist.com","is-a-blogger.com","is-a-bookkeeper.com","is-a-bruinsfan.org","is-a-bulls-fan.com","is-a-candidate.org","is-a-caterer.com","is-a-celticsfan.org","is-a-chef.com","is-a-chef.net","is-a-chef.org","is-a-conservative.com","is-a-cpa.com","is-a-cubicle-slave.com","is-a-democrat.com","is-a-designer.com","is-a-doctor.com","is-a-financialadvisor.com","is-a-geek.com","is-a-geek.net","is-a-geek.org","is-a-green.com","is-a-guru.com","is-a-hard-worker.com","is-a-hunter.com","is-a-knight.org","is-a-landscaper.com","is-a-lawyer.com","is-a-liberal.com","is-a-libertarian.com","is-a-linux-user.org","is-a-llama.com","is-a-musician.com","is-a-nascarfan.com","is-a-nurse.com","is-a-painter.com","is-a-patsfan.org","is-a-personaltrainer.com","is-a-photographer.com","is-a-player.com","is-a-republican.com","is-a-rockstar.com","is-a-socialist.com","is-a-soxfan.org","is-a-student.com","is-a-teacher.com","is-a-techie.com","is-a-therapist.com","is-an-accountant.com","is-an-actor.com","is-an-actress.com","is-an-anarchist.com","is-an-artist.com","is-an-engineer.com","is-an-entertainer.com","is-by.us","is-certified.com","is-found.org","is-gone.com","is-into-anime.com","is-into-cars.com","is-into-cartoons.com","is-into-games.com","is-leet.com","is-lost.org","is-not-certified.com","is-saved.org","is-slick.com","is-uberleet.com","is-very-bad.org","is-very-evil.org","is-very-good.org","is-very-nice.org","is-very-sweet.org","is-with-theband.com","isa-geek.com","isa-geek.net","isa-geek.org","isa-hockeynut.com","issmarterthanyou.com","isteingeek.de","istmein.de","kicks-ass.net","kicks-ass.org","knowsitall.info","land-4-sale.us","lebtimnetz.de","leitungsen.de","likes-pie.com","likescandy.com","merseine.nu","mine.nu","misconfused.org","mypets.ws","myphotos.cc","neat-url.com","office-on-the.net","on-the-web.tv","podzone.net","podzone.org","readmyblog.org","saves-the-whales.com","scrapper-site.net","scrapping.cc","selfip.biz","selfip.com","selfip.info","selfip.net","selfip.org","sells-for-less.com","sells-for-u.com","sells-it.net","sellsyourhome.org","servebbs.com","servebbs.net","servebbs.org","serveftp.net","serveftp.org","servegame.org","shacknet.nu","simple-url.com","space-to-rent.com","stuff-4-sale.org","stuff-4-sale.us","teaches-yoga.com","thruhere.net","traeumtgerade.de","webhop.biz","webhop.info","webhop.net","webhop.org","worse-than.tv","writesthisblog.com","ddnss.de","dyn.ddnss.de","dyndns.ddnss.de","dyndns1.de","dyn-ip24.de","home-webserver.de","dyn.home-webserver.de","myhome-server.de","ddnss.org","definima.net","definima.io","bci.dnstrace.pro","ddnsfree.com","ddnsgeek.com","giize.com","gleeze.com","kozow.com","loseyourip.com","ooguy.com","theworkpc.com","casacam.net","dynu.net","accesscam.org","camdvr.org","freeddns.org","mywire.org","webredirect.org","myddns.rocks","blogsite.xyz","dynv6.net","e4.cz","en-root.fr","mytuleap.com","onred.one","staging.onred.one","enonic.io","customer.enonic.io","eu.org","al.eu.org","asso.eu.org","at.eu.org","au.eu.org","be.eu.org","bg.eu.org","ca.eu.org","cd.eu.org","ch.eu.org","cn.eu.org","cy.eu.org","cz.eu.org","de.eu.org","dk.eu.org","edu.eu.org","ee.eu.org","es.eu.org","fi.eu.org","fr.eu.org","gr.eu.org","hr.eu.org","hu.eu.org","ie.eu.org","il.eu.org","in.eu.org","int.eu.org","is.eu.org","it.eu.org","jp.eu.org","kr.eu.org","lt.eu.org","lu.eu.org","lv.eu.org","mc.eu.org","me.eu.org","mk.eu.org","mt.eu.org","my.eu.org","net.eu.org","ng.eu.org","nl.eu.org","no.eu.org","nz.eu.org","paris.eu.org","pl.eu.org","pt.eu.org","q-a.eu.org","ro.eu.org","ru.eu.org","se.eu.org","si.eu.org","sk.eu.org","tr.eu.org","uk.eu.org","us.eu.org","eu-1.evennode.com","eu-2.evennode.com","eu-3.evennode.com","eu-4.evennode.com","us-1.evennode.com","us-2.evennode.com","us-3.evennode.com","us-4.evennode.com","twmail.cc","twmail.net","twmail.org","mymailer.com.tw","url.tw","apps.fbsbx.com","ru.net","adygeya.ru","bashkiria.ru","bir.ru","cbg.ru","com.ru","dagestan.ru","grozny.ru","kalmykia.ru","kustanai.ru","marine.ru","mordovia.ru","msk.ru","mytis.ru","nalchik.ru","nov.ru","pyatigorsk.ru","spb.ru","vladikavkaz.ru","vladimir.ru","abkhazia.su","adygeya.su","aktyubinsk.su","arkhangelsk.su","armenia.su","ashgabad.su","azerbaijan.su","balashov.su","bashkiria.su","bryansk.su","bukhara.su","chimkent.su","dagestan.su","east-kazakhstan.su","exnet.su","georgia.su","grozny.su","ivanovo.su","jambyl.su","kalmykia.su","kaluga.su","karacol.su","karaganda.su","karelia.su","khakassia.su","krasnodar.su","kurgan.su","kustanai.su","lenug.su","mangyshlak.su","mordovia.su","msk.su","murmansk.su","nalchik.su","navoi.su","north-kazakhstan.su","nov.su","obninsk.su","penza.su","pokrovsk.su","sochi.su","spb.su","tashkent.su","termez.su","togliatti.su","troitsk.su","tselinograd.su","tula.su","tuva.su","vladikavkaz.su","vladimir.su","vologda.su","channelsdvr.net","u.channelsdvr.net","fastly-terrarium.com","fastlylb.net","map.fastlylb.net","freetls.fastly.net","map.fastly.net","a.prod.fastly.net","global.prod.fastly.net","a.ssl.fastly.net","b.ssl.fastly.net","global.ssl.fastly.net","fastpanel.direct","fastvps-server.com","fhapp.xyz","fedorainfracloud.org","fedorapeople.org","cloud.fedoraproject.org","app.os.fedoraproject.org","app.os.stg.fedoraproject.org","mydobiss.com","filegear.me","filegear-au.me","filegear-de.me","filegear-gb.me","filegear-ie.me","filegear-jp.me","filegear-sg.me","firebaseapp.com","flynnhub.com","flynnhosting.net","0e.vc","freebox-os.com","freeboxos.com","fbx-os.fr","fbxos.fr","freebox-os.fr","freeboxos.fr","freedesktop.org","*.futurecms.at","*.ex.futurecms.at","*.in.futurecms.at","futurehosting.at","futuremailing.at","*.ex.ortsinfo.at","*.kunden.ortsinfo.at","*.statics.cloud","service.gov.uk","gehirn.ne.jp","usercontent.jp","gentapps.com","lab.ms","github.io","githubusercontent.com","gitlab.io","glitch.me","lolipop.io","cloudapps.digital","london.cloudapps.digital","homeoffice.gov.uk","ro.im","shop.ro","goip.de","run.app","a.run.app","web.app","*.0emm.com","appspot.com","*.r.appspot.com","blogspot.ae","blogspot.al","blogspot.am","blogspot.ba","blogspot.be","blogspot.bg","blogspot.bj","blogspot.ca","blogspot.cf","blogspot.ch","blogspot.cl","blogspot.co.at","blogspot.co.id","blogspot.co.il","blogspot.co.ke","blogspot.co.nz","blogspot.co.uk","blogspot.co.za","blogspot.com","blogspot.com.ar","blogspot.com.au","blogspot.com.br","blogspot.com.by","blogspot.com.co","blogspot.com.cy","blogspot.com.ee","blogspot.com.eg","blogspot.com.es","blogspot.com.mt","blogspot.com.ng","blogspot.com.tr","blogspot.com.uy","blogspot.cv","blogspot.cz","blogspot.de","blogspot.dk","blogspot.fi","blogspot.fr","blogspot.gr","blogspot.hk","blogspot.hr","blogspot.hu","blogspot.ie","blogspot.in","blogspot.is","blogspot.it","blogspot.jp","blogspot.kr","blogspot.li","blogspot.lt","blogspot.lu","blogspot.md","blogspot.mk","blogspot.mr","blogspot.mx","blogspot.my","blogspot.nl","blogspot.no","blogspot.pe","blogspot.pt","blogspot.qa","blogspot.re","blogspot.ro","blogspot.rs","blogspot.ru","blogspot.se","blogspot.sg","blogspot.si","blogspot.sk","blogspot.sn","blogspot.td","blogspot.tw","blogspot.ug","blogspot.vn","cloudfunctions.net","cloud.goog","codespot.com","googleapis.com","googlecode.com","pagespeedmobilizer.com","publishproxy.com","withgoogle.com","withyoutube.com","awsmppl.com","fin.ci","free.hr","caa.li","ua.rs","conf.se","hs.zone","hs.run","hashbang.sh","hasura.app","hasura-app.io","hepforge.org","herokuapp.com","herokussl.com","myravendb.com","ravendb.community","ravendb.me","development.run","ravendb.run","bpl.biz","orx.biz","ng.city","biz.gl","ng.ink","col.ng","firm.ng","gen.ng","ltd.ng","ngo.ng","ng.school","sch.so","häkkinen.fi","*.moonscale.io","moonscale.net","iki.fi","dyn-berlin.de","in-berlin.de","in-brb.de","in-butter.de","in-dsl.de","in-dsl.net","in-dsl.org","in-vpn.de","in-vpn.net","in-vpn.org","biz.at","info.at","info.cx","ac.leg.br","al.leg.br","am.leg.br","ap.leg.br","ba.leg.br","ce.leg.br","df.leg.br","es.leg.br","go.leg.br","ma.leg.br","mg.leg.br","ms.leg.br","mt.leg.br","pa.leg.br","pb.leg.br","pe.leg.br","pi.leg.br","pr.leg.br","rj.leg.br","rn.leg.br","ro.leg.br","rr.leg.br","rs.leg.br","sc.leg.br","se.leg.br","sp.leg.br","to.leg.br","pixolino.com","ipifony.net","mein-iserv.de","test-iserv.de","iserv.dev","iobb.net","myjino.ru","*.hosting.myjino.ru","*.landing.myjino.ru","*.spectrum.myjino.ru","*.vps.myjino.ru","*.triton.zone","*.cns.joyent.com","js.org","kaas.gg","khplay.nl","keymachine.de","kinghost.net","uni5.net","knightpoint.systems","oya.to","co.krd","edu.krd","git-repos.de","lcube-server.de","svn-repos.de","leadpages.co","lpages.co","lpusercontent.com","lelux.site","co.business","co.education","co.events","co.financial","co.network","co.place","co.technology","app.lmpm.com","linkitools.space","linkyard.cloud","linkyard-cloud.ch","members.linode.com","nodebalancer.linode.com","we.bs","loginline.app","loginline.dev","loginline.io","loginline.services","loginline.site","krasnik.pl","leczna.pl","lubartow.pl","lublin.pl","poniatowa.pl","swidnik.pl","uklugs.org","glug.org.uk","lug.org.uk","lugs.org.uk","barsy.bg","barsy.co.uk","barsyonline.co.uk","barsycenter.com","barsyonline.com","barsy.club","barsy.de","barsy.eu","barsy.in","barsy.info","barsy.io","barsy.me","barsy.menu","barsy.mobi","barsy.net","barsy.online","barsy.org","barsy.pro","barsy.pub","barsy.shop","barsy.site","barsy.support","barsy.uk","*.magentosite.cloud","mayfirst.info","mayfirst.org","hb.cldmail.ru","miniserver.com","memset.net","cloud.metacentrum.cz","custom.metacentrum.cz","flt.cloud.muni.cz","usr.cloud.muni.cz","meteorapp.com","eu.meteorapp.com","co.pl","azurecontainer.io","azurewebsites.net","azure-mobile.net","cloudapp.net","mozilla-iot.org","bmoattachments.org","net.ru","org.ru","pp.ru","ui.nabu.casa","pony.club","of.fashion","on.fashion","of.football","in.london","of.london","for.men","and.mom","for.mom","for.one","for.sale","of.work","to.work","nctu.me","bitballoon.com","netlify.com","4u.com","ngrok.io","nh-serv.co.uk","nfshost.com","dnsking.ch","mypi.co","n4t.co","001www.com","ddnslive.com","myiphost.com","forumz.info","16-b.it","32-b.it","64-b.it","soundcast.me","tcp4.me","dnsup.net","hicam.net","now-dns.net","ownip.net","vpndns.net","dynserv.org","now-dns.org","x443.pw","now-dns.top","ntdll.top","freeddns.us","crafting.xyz","zapto.xyz","nsupdate.info","nerdpol.ovh","blogsyte.com","brasilia.me","cable-modem.org","ciscofreak.com","collegefan.org","couchpotatofries.org","damnserver.com","ddns.me","ditchyourip.com","dnsfor.me","dnsiskinky.com","dvrcam.info","dynns.com","eating-organic.net","fantasyleague.cc","geekgalaxy.com","golffan.us","health-carereform.com","homesecuritymac.com","homesecuritypc.com","hopto.me","ilovecollege.info","loginto.me","mlbfan.org","mmafan.biz","myactivedirectory.com","mydissent.net","myeffect.net","mymediapc.net","mypsx.net","mysecuritycamera.com","mysecuritycamera.net","mysecuritycamera.org","net-freaks.com","nflfan.org","nhlfan.net","no-ip.ca","no-ip.co.uk","no-ip.net","noip.us","onthewifi.com","pgafan.net","point2this.com","pointto.us","privatizehealthinsurance.net","quicksytes.com","read-books.org","securitytactics.com","serveexchange.com","servehumour.com","servep2p.com","servesarcasm.com","stufftoread.com","ufcfan.org","unusualperson.com","workisboring.com","3utilities.com","bounceme.net","ddns.net","ddnsking.com","gotdns.ch","hopto.org","myftp.biz","myftp.org","myvnc.com","no-ip.biz","no-ip.info","no-ip.org","noip.me","redirectme.net","servebeer.com","serveblog.net","servecounterstrike.com","serveftp.com","servegame.com","servehalflife.com","servehttp.com","serveirc.com","serveminecraft.net","servemp3.com","servepics.com","servequake.com","sytes.net","webhop.me","zapto.org","stage.nodeart.io","nodum.co","nodum.io","pcloud.host","nyc.mn","nom.ae","nom.af","nom.ai","nom.al","nym.by","nom.bz","nym.bz","nom.cl","nym.ec","nom.gd","nom.ge","nom.gl","nym.gr","nom.gt","nym.gy","nym.hk","nom.hn","nym.ie","nom.im","nom.ke","nym.kz","nym.la","nym.lc","nom.li","nym.li","nym.lt","nym.lu","nom.lv","nym.me","nom.mk","nym.mn","nym.mx","nom.nu","nym.nz","nym.pe","nym.pt","nom.pw","nom.qa","nym.ro","nom.rs","nom.si","nym.sk","nom.st","nym.su","nym.sx","nom.tj","nym.tw","nom.ug","nom.uy","nom.vc","nom.vg","static.observableusercontent.com","cya.gg","cloudycluster.net","nid.io","opencraft.hosting","operaunite.com","skygearapp.com","outsystemscloud.com","ownprovider.com","own.pm","ox.rs","oy.lc","pgfog.com","pagefrontapp.com","art.pl","gliwice.pl","krakow.pl","poznan.pl","wroc.pl","zakopane.pl","pantheonsite.io","gotpantheon.com","mypep.link","perspecta.cloud","on-web.fr","*.platform.sh","*.platformsh.site","dyn53.io","co.bn","xen.prgmr.com","priv.at","prvcy.page","*.dweb.link","protonet.io","chirurgiens-dentistes-en-france.fr","byen.site","pubtls.org","qualifioapp.com","qbuser.com","instantcloud.cn","ras.ru","qa2.com","qcx.io","*.sys.qcx.io","dev-myqnapcloud.com","alpha-myqnapcloud.com","myqnapcloud.com","*.quipelements.com","vapor.cloud","vaporcloud.io","rackmaze.com","rackmaze.net","*.on-k3s.io","*.on-rancher.cloud","*.on-rio.io","readthedocs.io","rhcloud.com","app.render.com","onrender.com","repl.co","repl.run","resindevice.io","devices.resinstaging.io","hzc.io","wellbeingzone.eu","ptplus.fit","wellbeingzone.co.uk","git-pages.rit.edu","sandcats.io","logoip.de","logoip.com","schokokeks.net","gov.scot","scrysec.com","firewall-gateway.com","firewall-gateway.de","my-gateway.de","my-router.de","spdns.de","spdns.eu","firewall-gateway.net","my-firewall.org","myfirewall.org","spdns.org","senseering.net","biz.ua","co.ua","pp.ua","shiftedit.io","myshopblocks.com","shopitsite.com","mo-siemens.io","1kapp.com","appchizi.com","applinzi.com","sinaapp.com","vipsinaapp.com","siteleaf.net","bounty-full.com","alpha.bounty-full.com","beta.bounty-full.com","stackhero-network.com","static.land","dev.static.land","sites.static.land","apps.lair.io","*.stolos.io","spacekit.io","customer.speedpartner.de","api.stdlib.com","storj.farm","utwente.io","soc.srcf.net","user.srcf.net","temp-dns.com","applicationcloud.io","scapp.io","*.s5y.io","*.sensiosite.cloud","syncloud.it","diskstation.me","dscloud.biz","dscloud.me","dscloud.mobi","dsmynas.com","dsmynas.net","dsmynas.org","familyds.com","familyds.net","familyds.org","i234.me","myds.me","synology.me","vpnplus.to","direct.quickconnect.to","taifun-dns.de","gda.pl","gdansk.pl","gdynia.pl","med.pl","sopot.pl","edugit.org","telebit.app","telebit.io","*.telebit.xyz","gwiddle.co.uk","thingdustdata.com","cust.dev.thingdust.io","cust.disrec.thingdust.io","cust.prod.thingdust.io","cust.testing.thingdust.io","arvo.network","azimuth.network","bloxcms.com","townnews-staging.com","12hp.at","2ix.at","4lima.at","lima-city.at","12hp.ch","2ix.ch","4lima.ch","lima-city.ch","trafficplex.cloud","de.cool","12hp.de","2ix.de","4lima.de","lima-city.de","1337.pictures","clan.rip","lima-city.rocks","webspace.rocks","lima.zone","*.transurl.be","*.transurl.eu","*.transurl.nl","tuxfamily.org","dd-dns.de","diskstation.eu","diskstation.org","dray-dns.de","draydns.de","dyn-vpn.de","dynvpn.de","mein-vigor.de","my-vigor.de","my-wan.de","syno-ds.de","synology-diskstation.de","synology-ds.de","uber.space","*.uberspace.de","hk.com","hk.org","ltd.hk","inc.hk","virtualuser.de","virtual-user.de","urown.cloud","dnsupdate.info","lib.de.us","2038.io","router.management","v-info.info","voorloper.cloud","v.ua","wafflecell.com","*.webhare.dev","wedeploy.io","wedeploy.me","wedeploy.sh","remotewd.com","wmflabs.org","myforum.community","community-pro.de","diskussionsbereich.de","community-pro.net","meinforum.net","half.host","xnbay.com","u2.xnbay.com","u2-local.xnbay.com","cistron.nl","demon.nl","xs4all.space","yandexcloud.net","storage.yandexcloud.net","website.yandexcloud.net","official.academy","yolasite.com","ybo.faith","yombo.me","homelink.one","ybo.party","ybo.review","ybo.science","ybo.trade","nohost.me","noho.st","za.net","za.org","now.sh","bss.design","basicserver.io","virtualserver.io","enterprisecloud.nu"]

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/favicon.ico";

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(147)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(948),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(918)
  __webpack_require__(919)
}
var Component = __webpack_require__(147)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a92f2e62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(147)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7d888a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(147)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f29d35f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 947:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default w",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedName || _vm.placeholder) + " "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    key: _vm.num + '-' + _vm.id,
    staticClass: "cont",
    class: {
      active: _vm.isActive,
      pt0: _vm.filter || _vm.btnShow
    },
    style: ({
      maxHeight: (_vm.maxHeight || 300) + 'px'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('ul', {
    staticClass: "beautyul"
  }, [(_vm.multiple && _vm.soptions.length && _vm.isShowSelectAll) ? _c('li', {
    staticClass: "select-condition"
  }, [(_vm.btnShow) ? _c('div', {
    staticClass: "btn-group btn-block btn-con-border mb10"
  }, [(_vm.showSelectBtn) ? _c('button', {
    staticClass: "btn btn-default select-btn max-width-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]) : _vm._e(), _vm._v(" "), (_vm.showCancelBtn) ? _c('button', {
    staticClass: "btn btn-default select-btn max-width-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelAll
    }
  }, [_vm._v("取消")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filter) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKey),
      expression: "filterKey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.filterKey)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKey = $event.target.value
      }, _vm.filterHandle]
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.soptions), function(o, index) {
    return _c('li', {
      key: o.name + index,
      class: {
        active: o.$isActive,
        disabled: o.$isDisabled,
        visibility: o.$isVisible,
      },
      on: {
        "click": function($event) {
          return _vm.selHandle(o, index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(o[_vm.name]))]), _vm._v(" "), _c('i', {
      staticClass: "fa"
    })])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t暂无数据\n\t\t\t")])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default w select-popper-btn",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedName || _vm.placeholder) + " "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont select-popper",
    class: {
      active: _vm.isActive
    },
    style: ({
      maxHeight: (_vm.maxHeight || 300) + 'px'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('ul', {
    staticClass: "beautyul"
  }, [(_vm.multiple && _vm.soptions.length) ? _c('li', [_c('div', {
    staticClass: "btn-group btn-block mb10"
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelAll
    }
  }, [_vm._v("取消")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.soptions), function(o, index) {
    return _c('li', {
      class: {
        active: o.$isActive
      },
      on: {
        "click": function($event) {
          return _vm.selHandle(o, index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(o[_vm.name]))]), _vm._v(" "), _c('i', {
      staticClass: "fa"
    })])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.soptions.length),
      expression: "!soptions.length"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t暂无数据\n\t\t\t")])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "mod scroll"
  }, [_c('div', {
    staticClass: "mod-head"
  }, [_c('h1', {
    staticClass: "text-center fz16"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times pull-right",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "watermark",
      rawName: "v-watermark",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "mod-body-wrap"
  }, [_c('div', {
    staticClass: "mod-body",
    domProps: {
      "innerHTML": _vm._s(_vm.dbody)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 951:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bd-toast",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })
},staticRenderFns: []}

/***/ })

},[1224]);


// WEBPACK FOOTER //
// static/js/20260509181340.app.5d67436e9275d43399c5.js